import rifter0 from '../images/rifter0.jpg'
import rifter1 from '../images/rifter1.jpg'
import rifter2 from '../images/rifter2.jpg'
import rifter3 from '../images/rifter3.jpg'
import rifter4 from '../images/rifter4.jpg'
import rifter5 from '../images/rifter5.jpg'
import rifter6 from '../images/rifter6.jpg'
import rifter7 from '../images/rifter7.jpg'
import rifter8 from '../images/rifter8.jpg'
import rifter9 from '../images/rifter9.jpg'
import rifter95 from '../images/rifter95.jpg'
import rifter10 from '../images/rifter10.jpg'
import rifter11 from '../images/rifter11.jpg'
import rifter12 from '../images/rifter12.jpg'
import rifter13 from '../images/rifter13.jpg'
import rifter14 from '../images/rifter14.jpg'
import rifter15 from '../images/rifter15.jpg'
import rifter16 from '../images/rifter16.jpg'
import rifter17 from '../images/rifter17.jpg'
import rifter18 from '../images/rifter18.jpg'
import rifter19 from '../images/rifter19.jpg'
import rifter20 from '../images/rifter20.jpg'
import rifter21 from '../images/rifter21.jpg'
import rifter22 from '../images/rifter22.jpg'
import rifter23 from '../images/rifter23.jpg'
import rifter24 from '../images/rifter24.jpg'
import rifter25 from '../images/rifter25.jpg'
import rifter26 from '../images/rifter26.jpg'
import rifter27 from '../images/rifter27.jpg'
import rifter28 from '../images/rifter28.jpg'
import rifter29 from '../images/rifter29.jpg'
import rifter30 from '../images/rifter30.jpg'
import rifter31 from '../images/rifter31.jpg'
import rifter32 from '../images/rifter32.jpg'
import rifter33 from '../images/rifter33.jpg'
import rifter34 from '../images/rifter34.jpg'
import rifter35 from '../images/rifter35.jpg'
import rifter36 from '../images/rifter36.jpg'
import rifter37 from '../images/rifter37.jpg'
import rifter38 from '../images/rifter38.jpg'
import rifter39 from '../images/rifter39.jpg'
import rifter40 from '../images/rifter40.jpg'
import rifter41 from '../images/rifter41.jpg'
import rifter42 from '../images/rifter42.jpg'
import rifter43 from '../images/rifter43.jpg'
import rifter44 from '../images/rifter44.jpg'
import rifter45 from '../images/rifter45.jpg'
import rifter46 from '../images/rifter46.jpg'
import rifter47 from '../images/rifter47.jpg'
import rifter48 from '../images/rifter48.jpg'
import rifter49 from '../images/rifter49.jpg'
import rifter50 from '../images/rifter50.jpg'
import rifter51 from '../images/rifter51.jpg'
import rifter52 from '../images/rifter52.jpg'
import rifter53 from '../images/rifter53.jpg'
import rifter54 from '../images/rifter54.jpg'
import rifter55 from '../images/rifter55.jpg'
import rifter56 from '../images/rifter56.jpg'
import rifter57 from '../images/rifter57.jpg'
import rifter58 from '../images/rifter58.jpg'
import rifter59 from '../images/rifter59.jpg'
import rifter60 from '../images/rifter60.jpg'
import rifter61 from '../images/rifter61.jpg'
import rifter62 from '../images/rifter62.jpg'
import rifter63 from '../images/rifter63.jpg'
import rifter64 from '../images/rifter64.jpg'
import rifter65 from '../images/rifter65.jpg'
import rifter66 from '../images/rifter66.jpg'
import rifter67 from '../images/rifter67.jpg'
import rifter68 from '../images/rifter68.jpg'
import rifter69 from '../images/rifter69.jpg'
import rifter70 from '../images/rifter70.jpg'
import rifter71 from '../images/rifter71.jpg'
import rifter73 from '../images/rifter73.jpg'
import rifter74 from '../images/rifter74.jpg'
import rifter75 from '../images/rifter75.jpg'
import rifter76 from '../images/rifter76.jpg'
import rifter77 from '../images/rifter77.jpg'
import rifter78 from '../images/rifter78.jpg'
import rifter79 from '../images/rifter79.jpg'
import rifter80 from '../images/rifter80.jpg'
import rifter81 from '../images/rifter81.jpg'
import rifter82 from '../images/rifter82.jpg'
import rifter83 from '../images/rifter83.jpg'
import rifter84 from '../images/rifter84.jpg'
import rifter85 from '../images/rifter85.jpg'

const theRifterArr =
[
  {
    id: '1',
    article: 'Culture and Tradition',
    author: ['Nate Bingham'],
    artist: [''],
    page: '8-12',
    issue: rifter0,
    issueTitle: 'The Rifter #0',
    image: './images/rifter0.jpg',
    summary: "New tables to further flesh out your character's background, or help GMs add some quick color to their NPCs.",
    games: ['Any'],
    official: 'No',
    tags: ['tools']
  },
  {
    id: '2',
    article: 'Seven Years on Cerebus',
    author: ['Robert Lionheart'],
    artist: [''],
    page: '13-35',
    issue: rifter0,
    issueTitle: 'The Rifter #0',
    image: './images/rifter0.jpg',
    summary: 'Huge cross-over adventure for use with both Splicers and Rifts.',
    games: ['Rifts', 'Splicers'],
    official: 'No',
    tags: ['adventure']
  },
  {
    id: '3',
    article: 'Handheld Weapon Bio-Enhancements',
    author: ['Chris Kluge'],
    artist: [''],
    page: '36-47',
    issue: rifter0,
    issueTitle: 'The Rifter #0',
    image: './images/rifter0.jpg',
    summary: 'New options for customizing your Splicers gear.',
    games: ['Splicers'],
    official: 'No',
    tags: ['weapon']
  },
  {
    id: '4',
    article: 'A Megaverse of Skills at your Fingertips',
    author: ['Michael G. Totton Jr.'],
    artist: [''],
    page: '49-62',
    issue: rifter0,
    issueTitle: 'The Rifter #0',
    image: './images/rifter0.jpg',
    summary: 'Handy list of skills used all over the Palladium Megaverse complete with base percentages and the books they were printed in.',
    games: ['Any'],
    official: 'No',
    tags: ['skills']
  },
  {
    id: '5',
    article: 'Known Worlds of the Megaverse',
    author: ['Linwood Foster'],
    artist: [''],
    page: '64-74',
    issue: rifter0,
    issueTitle: 'The Rifter #0',
    image: './images/rifter0.jpg',
    summary: 'An unofficial list of all the planets in the Megaverse, complete with the species on each planet.',
    games: ['Any'],
    official: 'No',
    tags: ['race', 'races']
  },
  {
    id: '6',
    article: 'Santa Claus',
    author: ['Josh Hilden'],
    artist: [''],
    page: '75',
    issue: rifter0,
    issueTitle: 'The Rifter #0',
    image: './images/rifter0.jpg',
    summary: 'Jolly Fat Man that everyone loves to get gifts from.',
    games: ['Any'],
    official: 'No',
    tags: ['npc']
  },
  {
    id: '7',
    article: 'Ludicrous Magic III',
    author: ['Nate Bingham'],
    artist: [''],
    page: '75-85',
    issue: rifter0,
    issueTitle: 'The Rifter #0',
    image: './images/rifter0.jpg',
    summary: 'Third installment of spells for those crazy, crazy mages we all know and love from the infamous Rifter 9.5',
    games: ['Any'],
    official: 'No',
    tags: ['spells']
  },
  {
    id: '8',
    article: 'Spells of the Arch-Mage',
    author: ['Matthew Daye'],
    artist: [''],
    page: '87-94',
    issue: rifter0,
    issueTitle: 'The Rifter #0',
    image: './images/rifter0.jpg',
    summary: 'A collection of new spells for magic users who have a much keener understanding of the arcane arts.',
    games: ['Rifts', 'Palladium Fantasy'],
    official: 'No',
    tags: ['spells']
  },
  {
    id: '9',
    article: 'Sunaj Revisited',
    author: ['Rob Wilkison'],
    artist: [''],
    page: '95-100',
    issue: rifter0,
    issueTitle: 'The Rifter #0',
    image: './images/rifter0.jpg',
    summary: 'Those evil Atlanteans and their evil schemes, complete with their own weaponry and background tables.',
    games: ['Rifts'],
    official: 'No',
    tags: ['sunaj', 'weapon', 'weapons']
  },
  {
    id: '10',
    article: "There's Gold in them thar Hills!",
    author: ['Matthew Daye'],
    artist: [''],
    page: '101-104',
    issue: rifter0,
    issueTitle: 'The Rifter #0',
    image: './images/rifter0.jpg',
    summary: 'An explanation of where the Coalition States and other nations are getting all their resources.',
    games: ['Rifts'],
    official: 'No',
    tags: ['cs', 'coalition']
  },
  {
    id: '11',
    article: 'The Name Giver',
    author: ['Erick Wujcik'],
    artist: [],
    page: '9-12',
    issue: rifter1,
    issueTitle: 'The Rifter #1',
    image: './images/rifter1.jpg',
    summary: 'Erick Wujcik offers suggestions and humor on how to come up with names for RPG characters.',
    games: ['Any'],
    official: 'No',
    tags: ['gm', 'tools', 'tips']
  },
  {
    id: '12',
    article: 'Rifts City Creation Rules',
    author: ['Eric J. Lind'],
    artist: [],
    page: '24-30',
    issue: rifter1,
    issueTitle: 'The Rifter #1',
    image: './images/rifter1.jpg',
    summary: 'A set of optional rules for generating urban communities in Rifts.',
    games: ['Rifts'],
    official: 'No',
    tags: ['rules']
  },
  {
    id: '13',
    article: 'The New Roman Republic',
    author: ['Rodney Stott'],
    artist: [],
    page: '30-42',
    issue: rifter1,
    issueTitle: 'The Rifter #1',
    image: './images/rifter1.jpg',
    summary: 'A view of Rifts Italy, the Mafia, and the growing New Roman Republic of Rifts Earth. Optional R.C.C. and equipment.',
    games: ['Rifts'],
    official: 'No',
    tags: ['location', 'rcc']
  },
  {
    id: '14',
    article: 'The Knights of Kamnos',
    author: ['James M.G. Cannon'],
    artist: [],
    page: '43-45',
    issue: rifter1,
    issueTitle: 'The Rifter #1',
    image: './images/rifter1.jpg',
    summary: 'A brief overview of the heroic Kamnos Knights who serve the Three Galaxies.',
    games: ['Rifts', 'Phase World'],
    official: 'No',
    tags: ['kamnos']
  },
  {
    id: '15',
    article: 'New Major Super Powers',
    author: ['Aaron Oliver', 'Steve Trustrum'],
    artist: [],
    page: '66-82',
    issue: rifter1,
    issueTitle: 'The Rifter #1',
    image: './images/rifter1.jpg',
    summary: 'Some of these super abilities are awesome, others clever, and some silly, but all are fun, optional abilities.',
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['ability', 'powers']
  },
  {
    id: '16',
    article: 'New Morphus Tables',
    author: ['Aaron Oliver'],
    artist: [],
    page: '84-93',
    issue: rifter1,
    issueTitle: 'The Rifter #1',
    image: './images/rifter1.jpg',
    summary: 'Some outrageous, but cool, ideas for optional Nightbane Morphus.',
    games: ['Nightbane'],
    official: 'No',
    tags: ['morphus']
  },
  {
    id: '17',
    article: 'The Inlustris',
    author: ['William R. Muench'],
    artist: [],
    page: '93-104',
    issue: rifter1,
    issueTitle: 'The Rifter #1',
    image: './images/rifter1.jpg',
    summary: 'A new, optional, faction for Nightbane. Includes optional Uziel R.C.C. and Psiren P.C.C.',
    games: ['Nightbane'],
    official: 'No',
    tags: ['faction', 'rcc', 'pcc', 'magic']
  },
  {
    id: '18',
    article: 'Nightbane Hook, Line and Sinker',
    author: ['Aaron Oliver', 'Shawn Merrow'],
    artist: [],
    page: '104-108',
    issue: rifter1,
    issueTitle: 'The Rifter #1',
    image: './images/rifter1.jpg',
    summary: 'Quickie, HLS adventures.',
    games: ['Nightbane'],
    official: 'No',
    tags: ['adventure']
  },
  {
    id: '19',
    article: 'Beyond the Supernatural O.C.C.s',
    author: ['William Muench', 'James Calder'],
    artist: [],
    page: '111-117',
    issue: rifter1,
    issueTitle: 'The Rifter #1',
    image: './images/rifter1.jpg',
    summary: 'A handful of optional Psychic Character Classes (P.C.C.).',
    games: ['Beyond the Supernatural'],
    official: 'No',
    tags: ['pcc']
  },
  {
    id: '20',
    article: 'Thinking Big',
    author: ['Erick Wujcik'],
    artist: [],
    page: '8-10',
    issue: rifter2,
    issueTitle: 'The Rifter #2',
    image: './images/rifter2.jpg',
    summary: 'A talk about long-running RPG campaigns. Personal experiences and suggestions for role-playing expansive adventures.',
    games: ['Any'],
    official: 'No',
    tags: ['gm', 'tips']
  },
  {
    id: '21',
    article: 'The Rifts Connection',
    author: ['Kevin Siembieda'],
    artist: [],
    page: '18',
    issue: rifter2,
    issueTitle: 'The Rifter #2',
    image: './images/rifter2.jpg',
    summary: 'Explanation of how timelines, people, and occurrences in Heroes Unlimited, Beyond the Supernatural, and other Palladium world settings tie together in Rifts.',
    games: ['Rifts', 'Heroes Unlimited', 'Beyond the Supernatural'],
    official: 'No',
    tags: ['gm']
  },
  {
    id: '22',
    article: 'The Imp, Supernatural Rumormonger',
    author: ['William Muench'],
    artist: [],
    page: '19-20',
    issue: rifter2,
    issueTitle: 'The Rifter #2',
    image: './images/rifter2.jpg',
    summary: 'An interesting perspective on the imp.',
    games: ['Rifts', 'Beyond the Supernatural', 'Nightbane', 'Palladium Fantasy'],
    official: 'No',
    tags: ['monster']
  },
  {
    id: '23',
    article: 'Palladium Pirates',
    author: ['Shawn Merrow'],
    artist: [],
    page: '22-26',
    issue: rifter2,
    issueTitle: 'The Rifter #2',
    image: './images/rifter2.jpg',
    summary: 'Optional rules and suggestions for playing pirates in Palladium Fantasy. Plus Hook, Line and Sinker adventures.',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['adventure', 'rules']
  },
  {
    id: '24',
    article: 'Hacking, Cyberjacking, and Supernatural Data Theft Across the Megaverse',
    author: ['Wayne Breaux Jr.'],
    artist: ['Wayne Breaux Jr.'],
    page: '27-54',
    issue: rifter2,
    issueTitle: 'The Rifter #2',
    image: './images/rifter2.jpg',
    summary: 'A tour de force presentation with characters, rules, stats, information and fun stuff for use in Palladium games.',
    games: ['Rifts', 'Heroes Unlimited', 'Nightbane', 'Beyond the Supernatural'],
    official: 'No',
    tags: ['tools', 'rules']
  },
  {
    id: '25',
    article: 'Wormwood: The Blood Shaman',
    author: ['Steven Trustrum'],
    artist: ['Matthew Plog'],
    page: '55-65',
    issue: rifter2,
    issueTitle: 'The Rifter #2',
    image: './images/rifter2.jpg',
    summary: 'A delightfully gross and icky optional O.C.C. and magic for a new Wormwood character called The Blood Shaman.',
    games: ['Rifts'],
    official: 'No',
    tags: ['occ', 'location', 'magic']
  },
  {
    id: '26',
    article: 'Techno-Wizard Extravaganza',
    author: ['Mark Sumimoto', 'Jason Richards'],
    artist: [],
    page: '66-101',
    issue: rifter2,
    issueTitle: 'The Rifter #2',
    image: './images/rifter2.jpg',
    summary: 'Over 30 pages of breathtaking insight and optional TW rules, magic and devices.',
    games: ['Rifts'],
    official: 'No',
    tags: ['tw', 'technowizard', 'rules', 'magic']
  },
  {
    id: '27',
    article: 'Mastering the Game',
    author: ['Apollo Okamura'],
    artist: [],
    page: '8-10',
    issue: rifter3,
    issueTitle: 'The Rifter #3',
    image: './images/rifter3.jpg',
    summary: 'Game Master and storytelling tips.',
    games: ['Any'],
    official: 'No',
    tags: ['tools', 'tips']
  },
  {
    id: '28',
    article: 'Critters, Magic and Herbs',
    author: ['Randi Cartier'],
    artist: ['Michael Wilson', 'Scott Johnson'],
    page: '11-14',
    issue: rifter3,
    issueTitle: 'The Rifter #3',
    image: './images/rifter3.jpg',
    summary: 'Interesting and fun odds and ends for Palladium Fantasy. Including a pair of monsters, a few magic items and herbs.',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['monster', 'magic']
  },
  {
    id: '29',
    article: "Everybody's Kung Fu Fighting",
    author: ['William Muench'],
    artist: ['Michael Wilson', 'Roger Petersen'],
    page: '25-38',
    issue: rifter3,
    issueTitle: 'The Rifter #3',
    image: './images/rifter3.jpg',
    summary: 'Some thoughts about martial arts and eight, new, martial arts fighting styles suitable for use in Nightbane.',
    games: ['Nightbane'],
    official: 'No',
    tags: ['martial', 'npc']
  },
  {
    id: '30',
    article: 'Revised Grappling Rules and New Martial Arts',
    author: ['Lee Casebolt'],
    artist: [],
    page: '39-43',
    issue: rifter3,
    issueTitle: 'The Rifter #3',
    image: './images/rifter3.jpg',
    summary: "Insight on various martial art moves, particularly 'grappling.' Also provides three additional martial arts fighting styles and wrestling as a form of combat.",
    games: ['Ninjas and Superspies', 'Heroes Unlimited'],
    official: 'No',
    tags: ['martial', 'rules', 'combat']
  },
  {
    id: '31',
    article: 'Mystic China Conversion for Rifts',
    author: ['Andrew Smith'],
    artist: ['Vince Martin', 'Roger Petersen', 'Wayne Breaux Jr.'],
    page: '44-60',
    issue: rifter3,
    issueTitle: 'The Rifter #3',
    image: './images/rifter3.jpg',
    summary: 'Optional conversion notes, suggestions, and some new powers and abilities for using the martials arts, chi, and mystic powers in Rifts.',
    games: ['Rifts'],
    official: 'No',
    tags: ['combat', 'rules', 'martial']
  },
  {
    id: '32',
    article: 'The Xiticix',
    author: ['Wayne Breaux Jr.'],
    artist: ['Wayne Breaux Jr.'],
    page: '61-77',
    issue: rifter3,
    issueTitle: 'The Rifter #3',
    image: './images/rifter3.jpg',
    summary: 'Takes the reader into the Xiticix Hive to give greater insight and understanding about The Xiticix.',
    games: ['Rifts'],
    official: 'Yes',
    tags: ['monster']
  },
  {
    id: '33',
    article: 'Spatial Mage',
    author: ['Steven Trustrum'],
    artist: ['Apollo Okamura'],
    page: '78-89',
    issue: rifter3,
    issueTitle: 'The Rifter #3',
    image: './images/rifter3.jpg',
    summary: 'Optional O.C.C.',
    games: ['Rifts', 'Nightbane', 'Heroes Unlimited'],
    official: 'No',
    tags: ['occ', 'magic']
  },
  {
    id: '34',
    article: 'Primorder',
    author: ['Rodney Stott'],
    artist: ['Apollo Okamura', 'Wayne Breaux Jr.'],
    page: '90-98',
    issue: rifter3,
    issueTitle: 'The Rifter #3',
    image: './images/rifter3.jpg',
    summary: 'An optional world to explore in the tradition of the Rifts Dimension Books. World background, the two primary races, weapons, and items of note are presented.',
    games: ['Rifts'],
    official: 'No',
    tags: ['race', 'weapon', 'location']
  },
  {
    id: '35',
    article: 'Hook, Line and Sinkers for the Western Empire',
    author: ['Bill Coffin'],
    artist: [''],
    page: '12-20',
    issue: rifter4,
    issueTitle: 'The Rifter #4',
    image: './images/rifter4.jpg',
    summary: "A hunk of material that couldn't get squeezed into the Western Empire adventure sourcebook.",
    games: ['Palladium Fantasy'],
    official: 'Yes',
    tags: ['adventure']
  },
  {
    id: '36',
    article: 'Long, Strange Trips',
    author: ['Bill Coffin'],
    artist: ['Mike Wilson'],
    page: '23-32',
    issue: rifter4,
    issueTitle: 'The Rifter #4',
    image: './images/rifter4.jpg',
    summary: 'Game Master tips and ideas for writing epic campaigns for Palladium Fantasy',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['tools', 'tips']
  },
  {
    id: '37',
    article: 'Death is Not Always Final',
    author: ['Randi Cartier', 'Kevin Siembieda'],
    artist: ['Scott Johnson', 'Apollo Okamura', 'Kevin Long'],
    page: '33-39',
    issue: rifter4,
    issueTitle: 'The Rifter #4',
    image: './images/rifter4.jpg',
    summary: 'Some gruesome spirits of vengeance designed specifically for the Palladium Fantasy RPG.',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['monster']
  },
  {
    id: '38',
    article: 'The Tribes of the Moon',
    author: ['Steve Trustrum'],
    artist: ['Wayne Breaux Jr.'],
    page: '40-63',
    issue: rifter4,
    issueTitle: 'The Rifter #4',
    image: './images/rifter4.jpg',
    summary: 'Werebeasts for the modern age. Perfect for Nightbane and Beyond the Supernatural. R.C.C.s, O.C.C.s, skills, tribes and secret societies.',
    games: ['Nightbane', 'Beyond the Supernatural'],
    official: 'No',
    tags: ['monster', 'rcc', 'occ', 'race', 'skills']
  },
  {
    id: '39',
    article: 'A.R.C.H.I.E. Three vs. The World',
    author: ['Mark Sumimoto'],
    artist: ['Brandon C. Clark', 'Ka Xiong', 'Mark Dudley'],
    page: '64-89',
    issue: rifter4,
    issueTitle: 'The Rifter #4',
    image: './images/rifter4.jpg',
    summary: "An epic Rifts adventure involving ARCHIE-3. Plus data on The Titan Robotics Complex and various Cyberworks, Titan, Northern Gun and other 'bots, weapons and equipment.",
    games: ['Rifts'],
    official: 'No',
    tags: ['adventure', 'archie', 'ng', 'weapons', 'robot', 'equipment']
  },
  {
    id: '40',
    article: 'The Evolved',
    author: ['David Ransom'],
    artist: ['Apollo Okamura'],
    page: '90-95',
    issue: rifter4,
    issueTitle: 'The Rifter #4',
    image: './images/rifter4.jpg',
    summary: 'Optional Rifts adventure and source material involving the feared and hated Gene Splicers.',
    games: ['Rifts'],
    official: 'No',
    tags: ['adventure']
  },
  {
    id: '41',
    article: "New Mecha for Palladium's Robotech RPG",
    author: ['Stan Bundy'],
    artist: ['Ryan Beres', 'Wayne Breaux Jr.'],
    page: '17-21',
    issue: rifter5,
    issueTitle: 'The Rifter #5',
    image: './images/rifter5.jpg',
    summary: 'The REF Heavy Assault Battle Pod.',
    games: ['Robotech'],
    official: 'No',
    tags: ['weapon', 'robot']
  },
  {
    id: '42',
    article: 'Heroes Throughout the Ages',
    author: ['Jayh Fitzloff', 'Julius Rosenstein'],
    artist: ['Apollo Okamura'],
    page: '22-30',
    issue: rifter5,
    issueTitle: 'The Rifter #5',
    image: './images/rifter5.jpg',
    summary: 'Observations, tips, rules modifications, optional tables and suggestions for playing comic book heroes from 1920 to our modern day, and beyond.',
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['tips', 'rules']
  },
  {
    id: '43',
    article: 'The Rahu-Man - An In-Depth Study',
    author: ['Peter Finin'],
    artist: ['Mark Dudley', 'Brandon C. Clark', 'Drew'],
    page: '31-41',
    issue: rifter5,
    issueTitle: 'The Rifter #5',
    image: './images/rifter5.jpg',
    summary: 'An interesting look at the Rahu-Man in an Earth setting with data about their past, present and future.',
    games: ['Heroes Unlimited', 'Ninjas and Superspies', 'Rifts'],
    official: 'No',
    tags: ['martial']
  },
  {
    id: '44',
    article: 'A Mind of Their Own',
    author: ['Nathan Taylor'],
    artist: ['Ryan Beres'],
    page: '42-48',
    issue: rifter5,
    issueTitle: 'The Rifter #5',
    image: './images/rifter5.jpg',
    summary: 'A fascinating look at a handful of legendary Rune Weapons in the Palladium World.',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['weapon']
  },
  {
    id: '45',
    article: 'The Right Stuff',
    author: ['Edward J. Sauerland'],
    artist: ['Kent Burles'],
    page: '49-61',
    issue: rifter5,
    issueTitle: 'The Rifter #5',
    image: './images/rifter5.jpg',
    summary: 'An optional O.C.C. for Rifts called the Barnstormer, a daredevil pilot with nerves of steel. Also presents the Robotech Mecha Test Pilot O.C.C., plus optional rules for Air Combat and Vintage Techno-Wizard Aircraft.',
    games: ['Robotech', 'Rifts'],
    official: 'No',
    tags: ['occ', 'combat', 'tw', 'technowizard', 'rules', 'tw']
  },
  {
    id: '46',
    article: 'The World of the Operator',
    author: ['Eric Thompson', 'Jeremy Clements'],
    artist: ['Ryan Beres'],
    page: '62-69',
    issue: rifter5,
    issueTitle: 'The Rifter #5',
    image: './images/rifter5.jpg',
    summary: 'A closer look at the mechanical genius known on Rifts Earth as The Operator, and the Armorer O.C.C.',
    games: ['Rifts'],
    official: 'No',
    tags: ['occ']
  },
  {
    id: '47',
    article: 'Spatial Mage Additions',
    author: ['Steve Trustrum'],
    artist: [],
    page: '70-74',
    issue: rifter5,
    issueTitle: 'The Rifter #5',
    image: './images/rifter5.jpg',
    summary: 'More Spatial Magic',
    games: ['Rifts'],
    official: 'No',
    tags: ['spells', 'magic']
  },
  {
    id: '47a',
    article: 'The Tribes of the Moon, Part Two',
    author: ['Steve Trustrum'],
    artist: ['Wayne Breaux Jr.'],
    page: '75-98',
    issue: rifter5,
    issueTitle: 'The Rifter #5',
    image: './images/rifter5.jpg',
    summary: 'Werebeasts for the modern age. More werebeast tribes, mutants, background data and mystery. New magic items and arcane spells.',
    games: ['Nightbane'],
    official: 'No',
    tags: ['spells', 'magic', 'monster', 'mutant']
  },
  {
    id: '48',
    article: 'Cloak and Dagger: A look at Assassins.',
    author: ['Richard Thomassen'],
    artist: ['Mike Wilson'],
    page: '15-29',
    issue: rifter6,
    issueTitle: 'The Rifter #6',
    image: './images/rifter6.jpg',
    summary: 'At look at Assassins. A unique overview of assassins in the Western Empire, Timiro, Lopan, Bizantium, Eastern Territory and the Wolfen Empire. Rules and creation guides for making Assassins Guilds.',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['occ', 'tools', 'rules']
  },
  {
    id: '49',
    article: 'Russian Gods',
    author: ['Kevin Siembieda'],
    artist: ['Kent Burles'],
    page: '30-49',
    issue: rifter6,
    issueTitle: 'The Rifter #6',
    image: './images/rifter6.jpg',
    summary: 'Official Gods for use in Rifts Russia.',
    games: ['Rifts'],
    official: 'Yes',
    tags: ['god']
  },
  {
    id: '50',
    article: 'Focus on Fun',
    author: ['Hugh King'],
    artist: ['Wayne Breaux Jr.'],
    page: '50-66',
    issue: rifter6,
    issueTitle: 'The Rifter #6',
    image: './images/rifter6.jpg',
    summary: 'Excellent advice, tips and observations about Game Mastering in Rifts, Heroes Unlimited, and all others.',
    games: ['All'],
    official: 'No',
    tags: ['tips', 'gm']
  },
  {
    id: '51',
    article: 'Intrigue in Singapore',
    author: ['Victor Russof'],
    artist: ['Mark Duley'],
    page: '67-70',
    issue: rifter6,
    issueTitle: 'The Rifter #6',
    image: './images/rifter6.jpg',
    summary: 'A role-playing scenario for use with Ninjas and Superspies, plus source material, adventure ideas, and stats for Kenpo Karate.',
    games: ['Ninjas and Superspies'],
    official: 'No',
    tags: ['adventure', 'martial', 'location']
  },
  {
    id: '52',
    article: 'The Old Ways',
    author: ['David Solon Philips'],
    artist: [''],
    page: '71-75',
    issue: rifter6,
    issueTitle: 'The Rifter #6',
    image: './images/rifter6.jpg',
    summary: 'A look at the Mafia after Dark Day. How do organized crime syndicates fit into the world of Nightbane. Includes the Wise Guy and a pair of Assassin O.C.C.s',
    games: ['Nightbane'],
    official: 'No',
    tags: ['occ']
  },
  {
    id: '53',
    article: 'Hunter Robotics',
    author: ['Matthew M. Foster'],
    artist: ['Ryan Beres'],
    page: '76-82',
    issue: rifter6,
    issueTitle: 'The Rifter #6',
    image: './images/rifter6.jpg',
    summary: 'A robotics manufacturer and a handful of robots for use in Heroes Unlimited. Not to mention a couple of Hook, Line and Sinker adventures.',
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['robot', 'adventure']
  },
  {
    id: '54',
    article: 'The Khans of Mongolia',
    author: ['Christopher Jones'],
    artist: ['Drunken Style Studio'],
    page: '83-94',
    issue: rifter6,
    issueTitle: 'The Rifter #6',
    image: './images/rifter6.jpg',
    summary: 'Optional material for Rifts Mongolia and introduces a new D-Bee race called the Gragundi. Other spirits, new weapons, monsters, and R.C.C.s.',
    games: ['Rifts'],
    official: 'No',
    tags: ['location', 'race', 'rcc', 'weapon', 'monster', 'dbee']
  },
  {
    id: '55',
    article: 'The Children of Domhain Dorcha',
    author: ['Chad Rasnake'],
    artist: ['Ryan Beres'],
    page: '15-30',
    issue: rifter7,
    issueTitle: 'The Rifter #7',
    image: './images/rifter7.jpg',
    summary: 'An optional realm of the Dreamstream and the monstrous denizen that stalk the realm. Goblins, the King of Nightmares, an adventure idea and more.',
    games: ['Nightbane'],
    official: 'No',
    tags: ['npc', 'monster', 'adventure']
  },
  {
    id: '56',
    article: 'The Dragon Hunters of Kremakrilon',
    author: ['Jon Thompson'],
    artist: ['Apollo Okamura'],
    page: '31-38',
    issue: rifter7,
    issueTitle: 'The Rifter #7',
    image: './images/rifter7.jpg',
    summary: 'Includes the Dragon Hunter O.C.C., special magical abilities and a half dozen Hook, Line and Sinker adventures',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['occ', 'magic', 'adventure']
  },
  {
    id: '57',
    article: 'World Warriors',
    author: ['Ben Lucas'],
    artist: ['Mike Wilson'],
    page: '39-54',
    issue: rifter7,
    issueTitle: 'The Rifter #7',
    image: './images/rifter7.jpg',
    summary: 'Several different styles of martial arts combat from around the world. Brazilian Jujitsu, Capoeira, Kick Boxing, Krav Mahga, Savate, Professional Boxing and many others.',
    games: ['Ninjas and Superspies', 'Heroes Unlimited'],
    official: 'No',
    tags: ['martial']
  },
  {
    id: '58',
    article: 'Chaos Earth',
    author: ['Kevin Siembieda'],
    artist: ['Vince Martin'],
    page: '55-57',
    issue: rifter7,
    issueTitle: 'The Rifter #7',
    image: './images/rifter7.jpg',
    summary: 'A glimpse at the much-anticipated role-playing game series: Chaos Earth',
    games: ['Chaos Earth'],
    official: 'No',
    tags: ['rpg']
  },
  {
    id: '59',
    article: 'Skelebots: The Mechanical Menace',
    author: ['David Haendler'],
    artist: ['Drunken Style Studio', 'Adam Kass'],
    page: '58-69',
    issue: rifter7,
    issueTitle: 'The Rifter #7',
    image: './images/rifter7.jpg',
    summary: 'A few optional new skelebots. The Sea Skelebot, Super Skelebot, and Lurker Drone.',
    games: ['Rifts'],
    official: 'No',
    tags: ['robot', 'cs', 'coalition']
  },
  {
    id: '60',
    article: 'Rifts England: A Green and Unpleasant Land',
    author: ['Kevin F. Whitlock'],
    artist: ['Kevin Long'],
    page: '70-82',
    issue: rifter7,
    issueTitle: 'The Rifter #7',
    image: './images/rifter7.jpg',
    summary: 'A short story written by the late Kevin F. Whitlock. A tale of adventure, change and irony.',
    games: ['Rifts'],
    official: 'No',
    tags: ['story']
  },
  {
    id: '61',
    article: 'Systems Failure - Adventure and Source Material',
    author: ['Bill Coffin'],
    artist: ['Scott Johnson'],
    page: '12-27',
    issue: rifter8,
    issueTitle: 'The Rifter #8',
    image: './images/rifter8.jpg',
    summary: 'Adventure and official source material for Systems Failure. Flyboy O.C.C. and new core material.',
    games: ['Systems Failure'],
    official: 'Yes',
    tags: ['adventure', 'occ']
  },
  {
    id: '62',
    article: 'Mysteries of the Deep Forest',
    author: ['Randi Cartier'],
    artist: ['Apollo Okamura'],
    page: '30-39',
    issue: rifter8,
    issueTitle: 'The Rifter #8',
    image: './images/rifter8.jpg',
    summary: 'Optional critters, monsters, a new Warlock spell, and herbs for Palladium Fantasy.',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['monster', 'magic']
  },
  {
    id: '63',
    article: 'The Charonis',
    author: ['James M. G. Cannon'],
    artist: ['Ryan Beres'],
    page: '40-46',
    issue: rifter8,
    issueTitle: 'The Rifter #8',
    image: './images/rifter8.jpg',
    summary: "A new variety of werebeasts - 'werebats' from around the world.",
    games: ['Nightbane', 'Beyond the Supernatural'],
    official: 'No',
    tags: ['monster']
  },
  {
    id: '64',
    article: 'The Laughing Man R.C.C.',
    author: ['James Calder'],
    artist: [],
    page: '47-48',
    issue: rifter8,
    issueTitle: 'The Rifter #8',
    image: './images/rifter8.jpg',
    summary: "A demonic creature suitable for Palladium's horror games.",
    games: ['Beyond the Supernatural', 'Nightbane'],
    official: 'No',
    tags: ['monster', 'rcc']
  },
  {
    id: '65',
    article: 'Demonwrath',
    author: ['Matthew Burns'],
    artist: ['Drew'],
    page: '57-59',
    issue: rifter8,
    issueTitle: 'The Rifter #8',
    image: './images/rifter8.jpg',
    summary: 'A suitably scary, demon-stomping adventure set in Rifts Russia.',
    games: ['Rifts'],
    official: 'No',
    tags: ['adventure', 'location']
  },
  {
    id: '66',
    article: 'The New Kingdom',
    author: ['Jason Richards', 'Nathan Taylor'],
    artist: ['Wayne Breaux Jr.', 'Apollo Okamura'],
    page: '60-75',
    issue: rifter8,
    issueTitle: 'The Rifter #8',
    image: './images/rifter8.jpg',
    summary: 'A new Vampire Kingdom and menaces to deal with. Some cool, optional vampire variants, the Abandoned Vampire, Blood Wraith, and Blood Priest.',
    games: ['Rifts'],
    official: 'No',
    tags: ['monster', 'vampire', 'rcc']
  },
  {
    id: '67',
    article: 'Bring Out Your Dead',
    author: ['Mark Sumimoto'],
    artist: ['Ryan Beres'],
    page: '76-94',
    issue: rifter8,
    issueTitle: 'The Rifter #8',
    image: './images/rifter8.jpg',
    summary: 'Evil practitioners of Necromantic Arts - an optional O.C.C. different from the classic Necromancer. They include the Cursebringer, Death Walker, Murder-Mage, Warborn, and Warbaby',
    games: ['Rifts'],
    official: 'No',
    tags: ['magic', 'occ']
  },
  {
    id: '68',
    article: 'Three Words',
    author: ['Jason Marker'],
    artist: ['Ramon Perez'],
    page: '95-98',
    issue: rifter8,
    issueTitle: 'The Rifter #8',
    image: './images/rifter8.jpg',
    summary: "A short story inspired by Ramon Perez's illustration in Rifts Lone Star.",
    games: ['Rifts'],
    official: 'No',
    tags: ['story']
  },
  {
    id: '70',
    article: 'Beyond Between the Shadows',
    author: ['Todd Sterrett'],
    artist: ['Ryan Beres'],
    page: '18-38',
    issue: rifter9,
    issueTitle: 'The Rifter #9',
    image: './images/rifter9.jpg',
    summary: 'Optional new material for adventure into the Astral Plane. New psychic and Astral Lord powers, magic spells, portals, and dimensional Rifts. Cosmology 101. Astral O.C.C.s, Astral Domains, and much more.',
    games: ['Nightbane'],
    official: 'No',
    tags: ['spell', 'occ', 'magic', 'psionic']
  },
  {
    id: '71',
    article: 'New Type Bio-Borgs',
    author: ['Mark Sumimoto'],
    artist: ['Michael Dubisch'],
    page: '47-63',
    issue: rifter9,
    issueTitle: 'The Rifter #9',
    image: './images/rifter9.jpg',
    summary: 'Bio-Borgs written out of the original Rifts: Atlantis Two, Dimensional Market book. Bio-Leech, Fire Eater, Kill Crazy, and Sym-Killer.',
    games: ['Rifts'],
    official: 'Yes',
    tags: ['monster']
  },
  {
    id: '73',
    article: 'The Territory of Arzno (Part One of Two)',
    author: ['Jason Richards', 'Nathan Taylor'],
    artist: ['Wayne Breaux Jr.'],
    page: '81-104',
    issue: rifter9,
    issueTitle: 'The Rifter #9',
    image: './images/rifter9.jpg',
    summary: 'The independent City of Arzno, Arizona. Built from scratch and defended by the Arzno Mercenary Corp. City history, background, government and key mercenary characters.',
    games: ['Rifts'],
    official: 'No',
    tags: ['location', 'npc']
  },
  {
    id: '74',
    article: 'General RPG Tips',
    author: ['Owen Johnson'],
    artist: [''],
    page: '105-106',
    issue: rifter9,
    issueTitle: 'The Rifter #9',
    image: './images/rifter9.jpg',
    summary: 'Thoughts and optional tables for weather conditions.',
    games: ['Any'],
    official: 'No',
    tags: ['gm', 'tools', 'tips']
  },
  {
    id: '75',
    article: 'Palladium Fantasy Hook, Line and Sinker Adventures',
    author: ['Shawn Merrow'],
    artist: ['Ryan Beres'],
    page: '108-111',
    issue: rifter9,
    issueTitle: 'The Rifter #9',
    image: './images/rifter9.jpg',
    summary: '14 adventure ideas for The Palladium Fantasy RPG.',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['adventure']
  },
  {
    id: '76',
    article: 'The Rifter Credit Card?',
    author: ['Priscilla Ferkelberger', 'Peter Ferkelberger'],
    artist: [''],
    page: '9',
    issue: rifter95,
    issueTitle: 'The Rifter #9.5',
    image: './images/rifter95.jpg',
    summary: 'A sure-fire way to build experience points for your characters.',
    games: ['Any'],
    official: 'No',
    tags: ['gm', 'silly']
  },
  {
    id: '77',
    article: 'Giga-Damage',
    author: ['Peter Ferkelberger'],
    artist: ['Ryan Beres'],
    page: '10-16',
    issue: rifter95,
    issueTitle: 'The Rifter #9.5',
    image: './images/rifter95.jpg',
    summary: 'The next BIG thing in gaming.',
    games: ['Any'],
    official: 'No',
    tags: ['rpg', 'silly']
  },
  {
    id: '78',
    article: 'Silly answers to some silly questions',
    author: ['J.P. Ferkelberger'],
    artist: ['Apollo Okamura'],
    page: '17-21',
    issue: rifter95,
    issueTitle: 'The Rifter #9.5',
    image: './images/rifter95.jpg',
    summary: 'Be afraid.',
    games: ['Any'],
    official: 'No',
    tags: ['silly']
  },
  {
    id: '79',
    article: "Where's Wayne",
    author: [''],
    artist: ['Ramon Perez'],
    page: '22-27',
    issue: rifter95,
    issueTitle: 'The Rifter #9.5',
    image: './images/rifter95.jpg',
    summary: 'An adventure worth it for the stats on Wayne Smith alone, not to mention the villainous Motown Maniacs.',
    games: ['Any'],
    official: 'No',
    tags: ['adventure', 'silly']
  },
  {
    id: '80',
    article: 'Wacky Powers for Heroes Unlimited',
    author: ['Paulie Ferkelberger', 'Percy Ferkelberger'],
    artist: ['Scott Johnson'],
    page: '28-30',
    issue: rifter95,
    issueTitle: 'The Rifter #9.5',
    image: './images/rifter95.jpg',
    summary: 'Yummy fun.',
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['silly']
  },
  {
    id: '81',
    article: 'Heroes and Villains with Unusual Powers',
    author: ['Paulie Ferkelberger'],
    artist: ['Scott Johnson'],
    page: '31-40',
    issue: rifter95,
    issueTitle: 'The Rifter #9.5',
    image: './images/rifter95.jpg',
    summary: 'Such amazing super-dudes as Frank and Beanz, Pasta Man and Dragonbreath.',
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['silly', 'npc']
  },
  {
    id: '82',
    article: 'Reality Twist',
    author: ['Peter Ferkelberger'],
    artist: ['Freddie Williams II'],
    page: '10-16',
    issue: rifter95,
    issueTitle: 'The Rifter #9.5',
    image: './images/rifter95.jpg',
    summary: 'Inspired by Century Station, a batch of wild superhuman heroes and villains.',
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['npc', 'silly']
  },
  {
    id: '83',
    article: 'Heroes Unlimited (Again!?)',
    author: ['Paulie Ferkelberger', 'Percy Ferkelberger'],
    artist: [''],
    page: '55-57',
    issue: rifter95,
    issueTitle: 'The Rifter #9.5',
    image: './images/rifter95.jpg',
    summary: 'A variety of humorous defects to many of the super abilities in Heroes Unlimited.',
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['abilities', 'silly']
  },
  {
    id: '84',
    article: 'Unlikely Gods',
    author: [''],
    artist: ['Kent Burles'],
    page: '58-63',
    issue: rifter95,
    issueTitle: 'The Rifter #9.5',
    image: './images/rifter95.jpg',
    summary: 'Questionably divine beings',
    games: ['Rifts', 'Palladium Fantasy'],
    official: 'No',
    tags: ['npc', 'god', 'silly']
  },
  {
    id: '85',
    article: 'The Trickster and Ludicrous Mage',
    author: ['Percy Ferkelberger'],
    artist: ['Mike Wilson'],
    page: '64-92',
    issue: rifter95,
    issueTitle: 'The Rifter #9.5',
    image: './images/rifter95.jpg',
    summary: '100 new spells',
    games: ['Rifts', 'Palladium Fantasy', 'Heroes Unlimited'],
    official: 'No',
    tags: ['magic', 'silly']
  },
  {
    id: '86',
    article: "Crazy Accoloth's Discount Alchemy",
    author: ['Priscilla Ferkelberger'],
    artist: [''],
    page: '93-96',
    issue: rifter95,
    issueTitle: 'The Rifter #9.5',
    image: './images/rifter95.jpg',
    summary: 'A few delightful and rare magic items and magic spells.',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['spells', 'silly', 'magic']
  },
  {
    id: '87',
    article: 'The Tourist O.C.C.',
    author: ['Philipe Ferkelberger'],
    artist: ['Scott Johnson', 'Mike Wilson'],
    page: '97-101',
    issue: rifter95,
    issueTitle: 'The Rifter #9.5',
    image: './images/rifter95.jpg',
    summary: 'Hilarious new character class.',
    games: ['Rifts'],
    official: 'No',
    tags: ['occ', 'silly']
  },
  {
    id: '88',
    article: 'Rifts Short Story',
    author: ['Cousin Forhorn Ferkelberger'],
    artist: [''],
    page: '102-110',
    issue: rifter95,
    issueTitle: 'The Rifter #9.5',
    image: './images/rifter95.jpg',
    summary: 'A dog-gone good story.',
    games: ['Rifts'],
    official: 'No',
    tags: ['story', 'silly']
  },
  {
    id: '89',
    article: 'The Magic of Science',
    author: ['Greg Diaczyk'],
    artist: ['Kent Burles'],
    page: '19-23',
    issue: rifter10,
    issueTitle: 'The Rifter #10',
    image: './images/rifter10.jpg',
    summary: 'Thoughts and ideas for technology in the Palladium Fantasy RPG setting. Tinker O.C.C., explosives, machines, and gadgets.',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['occ', 'weapon']
  },
  {
    id: '90',
    article: 'The Changeling Morph',
    author: ['Mark Hall'],
    artist: ['Apollo Okamura'],
    page: '24-25',
    issue: rifter10,
    issueTitle: 'The Rifter #10',
    image: './images/rifter10.jpg',
    summary: 'The Changeling Metamorph, a sort of rare, super-changeling who can assume all types of transformations beyond the capabilities of a normal Changeling.',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['morphus', 'occ']
  },
  {
    id: '91',
    article: 'The Gestalt Power Category',
    author: ['Jay Fitzloff', 'Wayne Smith'],
    artist: ['Drunken Style Studio', 'Freddie Williams II'],
    page: '26-39',
    issue: rifter10,
    issueTitle: 'The Rifter #10',
    image: './images/rifter10.jpg',
    summary: 'An entirely new Power Category for Heroes Unlimited. A rare and bizarre class of superbeing that is more than he or she may seem.',
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['power', 'occ']
  },
  {
    id: '92',
    article: 'Trouble in the Midwest',
    author: ['Blake Trzpuc'],
    artist: ['Drunken Style Studio'],
    page: '40-45',
    issue: rifter10,
    issueTitle: 'The Rifter #10',
    image: './images/rifter10.jpg',
    summary: 'A frightening adventure for Beyond the Supernatural. Ideal for low to mid-level characters.',
    games: ['Beyond the Supernatural'],
    official: 'No',
    tags: ['adventure', 'location']
  },
  {
    id: '93',
    article: 'Dark Consequences',
    author: ['Russel Brin'],
    artist: ['Kent Burles'],
    page: '46-47',
    issue: rifter10,
    issueTitle: 'The Rifter #10',
    image: './images/rifter10.jpg',
    summary: 'Another little adventure for Beyond the Supernatural.',
    games: ['Beyond the Supernatural'],
    official: 'No',
    tags: ['adventure']
  },
  {
    id: '94',
    article: 'On the Fringe of the Night',
    author: ['David Solon Phillips'],
    artist: ['Drunken Style Studio'],
    page: '48-56',
    issue: rifter10,
    issueTitle: 'The Rifter #10',
    image: './images/rifter10.jpg',
    summary: 'Optional fringe group O.C.C.s for the Nightbane setting. A look at how modern day militia groups might respond to the Nightlords and their minions.',
    games: ['Nightbane'],
    official: 'No',
    tags: ['occ']
  },
  {
    id: '95',
    article: 'The Territory of Arzno (Part Two)',
    author: ['Jason Richards', 'Nathan Taylor'],
    artist: ['Wayne Breaux Jr.'],
    page: '65-78',
    issue: rifter10,
    issueTitle: 'The Rifter #10',
    image: './images/rifter10.jpg',
    summary: 'Part two presents TW Armor, gizmos and vehicles used by this southwestern community. Plus the optional Weapon Mage O.C.C. and a few Hook, Line and Sinker style adventures.',
    games: ['Rifts'],
    official: 'No',
    tags: ['technowizard', 'techno-wizard', 'occ', 'adventure', 'tw']
  },
  {
    id: '96',
    article: 'The Environment of Space',
    author: ['Ewen Cluney'],
    artist: ['Wayne Breaux Jr.'],
    page: '79-92',
    issue: rifter10,
    issueTitle: 'The Rifter #10',
    image: './images/rifter10.jpg',
    summary: 'The pitfalls of playing in outer space for Rifts characters. Definitions, observations, and rules all topped by over 40 spells designed for use in space and space travel.',
    games: ['Rifts', 'Phase World'],
    official: 'No',
    tags: ['magic', 'spell', 'rules']
  },
  {
    id: '97',
    article: 'Optional Combat Rules for Rifts and Other Games',
    author: ['Matthew Olfson'],
    artist: [''],
    page: '17-21',
    issue: rifter11,
    issueTitle: 'The Rifter #11',
    image: './images/rifter11.jpg',
    summary: 'House rules and modifications involving Hand-to-Hand and long-range combat.',
    games: ['Any'],
    official: 'No',
    tags: ['rules', 'combat']
  },
  {
    id: '98',
    article: 'Optional New Superpowers',
    author: ['Nick Luna', 'Jason Lukowski', 'Leland Smith', 'Richard Winters'],
    artist: ['Wayne Breaux Jr.'],
    page: '22-27',
    issue: rifter11,
    issueTitle: 'The Rifter #11',
    image: './images/rifter11.jpg',
    summary: 'A number of new and variant super abilities.',
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['abilities', 'super', 'powers']
  },
  {
    id: '99',
    article: 'Games Master Tips, Suggestions, and Good Advice',
    author: ['Hugh King'],
    artist: ['Apollo Okamura'],
    page: '28-47',
    issue: rifter11,
    issueTitle: 'The Rifter #11',
    image: './images/rifter11.jpg',
    summary: 'Excellent observations, comments, tips, and suggestions on playing Practitioners of Magic in Rifts. ',
    games: ['Rifts'],
    official: 'No',
    tags: ['gm', 'tips', 'magic']
  },
  {
    id: '100',
    article: 'Questions and Answers',
    author: ['Rodney Stott', 'Shawn Merrow'],
    artist: ['Brandon C. Clark', 'Apollo Okamura'],
    page: '48-52',
    issue: rifter11,
    issueTitle: 'The Rifter #11',
    image: './images/rifter11.jpg',
    summary: "The first in a continuing series of 'Questions and Answers.'",
    games: ['Any'],
    official: 'No',
    tags: ['qa', 'tips', 'rules']
  },
  {
    id: '101',
    article: "'The Nightbane'",
    author: ['Kevin Siembieda'],
    artist: [''],
    page: '63-64',
    issue: rifter11,
    issueTitle: 'The Rifter #11',
    image: './images/rifter11.jpg',
    summary: "A look at the Nightbane themselves in a short tale that serves as something or an introduction to William Muench's 'Gregors Chronicle' story. It offers insight into the Nightbane, their struggle against the Nightlords, their purpose and introduces the Salvation of Light.",
    games: ['Nightbane'],
    official: 'No',
    tags: ['story']
  },
  {
    id: '102',
    article: "Gregor's Chronicle: The Tale of a Lost Boy",
    author: ['William Muench'],
    artist: [''],
    page: '65-68',
    issue: rifter11,
    issueTitle: 'The Rifter #11',
    image: './images/rifter11.jpg',
    summary: 'A tale of confrontation and survival set in the world of The Nightbane.',
    games: ['Nightbane'],
    official: 'No',
    tags: ['story']
  },
  {
    id: '103',
    article: 'The Shrine of Ventax',
    author: ['Michael Long'],
    artist: ['Mark Dudley', 'Brandon C. Clark', 'Ka Xiong', 'Michael Long'],
    page: '79-108',
    issue: rifter11,
    issueTitle: 'The Rifter #11',
    image: './images/rifter11.jpg',
    summary: 'A Palladium Fantasy adventure suitable for mid-level characters, set in the border lands between the Eastern Territory and the Old Kingdom. Defenseless farmers, a dangerous dungeon, treasure, mystery, combat, heroism, marauding Orcs, Ratlings, the Dread-Lord, and fun!',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['adventure', 'npc']
  },
  {
    id: '104',
    article: 'Questions and Answers',
    author: ['Rodney Stott', 'Shawn Merrow'],
    artist: ['Scott Johnson', 'Mike Wilson'],
    page: '23-26',
    issue: rifter12,
    issueTitle: 'The Rifter #12',
    image: './images/rifter12.jpg',
    summary: 'A focus on questions concerning practitioners of magic as it applies to Rifts, Palladium Fantasy, and our other RPGs.',
    games: ['Any'],
    official: 'No',
    tags: ['qa', 'tips', 'rules', 'magic']
  },
  {
    id: '105',
    article: 'Game Master and Player Tips and Advice for Creating Fun and Interesting Characters',
    author: ['Christina Stiles'],
    artist: ['Wayne Breaux Jr.'],
    page: '27-28',
    issue: rifter12,
    issueTitle: 'The Rifter #12',
    image: './images/rifter12.jpg',
    summary: 'A number of cool ideas and suggestions for building colorful and dynamic characters with personality and history behind them.',
    games: ['Any'],
    official: 'No',
    tags: ['gm', 'tips']
  },
  {
    id: '106',
    article: 'Into the Shadows',
    author: ['Jon Thompson'],
    artist: ['Wayne Breaux Jr.'],
    page: '29-39',
    issue: rifter12,
    issueTitle: 'The Rifter #12',
    image: './images/rifter12.jpg',
    summary: "An in-depth look at the professional assassin in Palladium Fantasy. Includes the assassin's code, types of assassins and their areas of expertise (along with appropriate bonuses), new assassin skills, new poisons, and a variety of gimmick weapons and magic items perfect for the trade.",
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['skill', 'occ', 'magic']
  },
  {
    id: '107',
    article: 'The Texas Lone Star Cavalry',
    author: ['Ismael Alverez'],
    artist: ['Scott Johnson'],
    page: '40-47',
    issue: rifter12,
    issueTitle: 'The Rifter #12',
    image: './images/rifter12.jpg',
    summary: 'Optional source material, characters, and adventure ideas for the bug-invasion RPG. Includes some new equipment.',
    games: ['Systems Failure'],
    official: 'No',
    tags: ['adventure', 'npc', 'equipment']
  },
  {
    id: '108',
    article: 'The Geiger Organization',
    author: ['Carl Syphrett'],
    artist: ['Freddie Williams II'],
    page: '48-72',
    issue: rifter12,
    issueTitle: 'The Rifter #12',
    image: './images/rifter12.jpg',
    summary: 'The Geiger Organization - a dark and secret operation involving superhumans and its own dangerous agenda. Over 18 superbeings, Living Dead Men, and Hook, Line and Sinker adventures.',
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['npc', 'adventure']
  },
  {
    id: '109',
    article: 'Blueprint of a Dragon',
    author: ['John Courtenay Shera'],
    artist: ['Tyler Walpole'],
    page: '73-78',
    issue: rifter12,
    issueTitle: 'The Rifter #12',
    image: './images/rifter12.jpg',
    summary: 'An interesting bit of prose and ideas for adventure.',
    games: ['Rifts'],
    official: 'No',
    tags: ['adventure']
  },
  {
    id: '110',
    article: 'Phase World Source Material',
    author: ['Richard Jenkin'],
    artist: ['Apollo Okamura'],
    page: '79-102',
    issue: rifter12,
    issueTitle: 'The Rifter #12',
    image: './images/rifter12.jpg',
    summary: 'Tyrell Industries for Phase World. Including William Tyrell, Advanced Weapon Tech Division, and new weapons, spaceships, robots and gizmos.',
    games: ['Rifts', 'Phase World'],
    official: 'No',
    tags: ['npc', 'weapon', 'robot']
  },
  {
    id: '111',
    article: 'Questions and Answers',
    author: ['Rodney Stott', 'Shawn Merrow'],
    artist: ['Wayne Breaux JR.'],
    page: '16-18',
    issue: rifter13,
    issueTitle: 'The Rifter #13',
    image: './images/rifter13.jpg',
    summary: 'Addresses questions concerning fate, luck, curses and healing, Horror Factor and drinking booze.',
    games: ['Any'],
    official: 'No',
    tags: ['qa', 'tips', 'rules']
  },
  {
    id: '112',
    article: 'Lucky Charms and Superstitions',
    author: ['Joseph Larsen'],
    artist: ['Tyler Walpole'],
    page: '19-21',
    issue: rifter13,
    issueTitle: 'The Rifter #13',
    image: './images/rifter13.jpg',
    summary: 'Some optional rules, thoughts and suggestions on luck and lucky charms (not the cereal).',
    games: ['Any'],
    official: 'No',
    tags: ['rules', 'gm', 'tips']
  },
  {
    id: '113',
    article: 'P.C.C.: The Cursed',
    author: ['Shawn Merrow'],
    artist: ['Wayne Breaux Jr.'],
    page: '22-23',
    issue: rifter13,
    issueTitle: 'The Rifter #13',
    image: './images/rifter13.jpg',
    summary: 'A really cool character idea.',
    games: ['Nightbane'],
    official: 'No',
    tags: ['pcc']
  },
  {
    id: '114',
    article: 'Optional O.C.C.s and Ideas for Beyond the Supernatural',
    author: ['James Calder'],
    artist: ['Wayne Breaux Jr.'],
    page: '24-29',
    issue: rifter13,
    issueTitle: 'The Rifter #13',
    image: './images/rifter13.jpg',
    summary: 'Presents the Arcane Archaeologist, the Occultist, and Cryptozoologist as optional O.C.C.s for Beyond the Supernatural, along with a few lore skills.',
    games: ['Beyond the Supernatural'],
    official: 'No',
    tags: ['skill', 'occ']
  },
  {
    id: '115',
    article: 'Living Numbers and Curses',
    author: ['Russell Brin'],
    artist: ['Wayne Breaux Jr.'],
    page: '30-33',
    issue: rifter13,
    issueTitle: 'The Rifter #13',
    image: './images/rifter13.jpg',
    summary: 'Some wild, supernatural, optional source material for Beyond the Supernatural, including the ominous Thirteen Entity, a new kind of magical being (a living manifestation) of numbers, and some curse magic.',
    games: ['Beyond the Supernatural'],
    official: 'No',
    tags: ['npc', 'magic']
  },
  {
    id: '116',
    article: 'The Fayfield Inn Adventure',
    author: ['Russell Brin'],
    artist: ['Wayne Breaux Jr.'],
    page: '34-37',
    issue: rifter13,
    issueTitle: 'The Rifter #13',
    image: './images/rifter13.jpg',
    summary: 'An adventure for Beyond the Supernatural.',
    games: ['Beyond the Supernatural'],
    official: 'No',
    tags: ['adventure']
  },
  {
    id: '117',
    article: 'In the Hands of Fate',
    author: ['Crystal Frasier'],
    artist: ['Tyler Walpole'],
    page: '38-44',
    issue: rifter13,
    issueTitle: 'The Rifter #13',
    image: './images/rifter13.jpg',
    summary: "The 'Deck of Fate', a powerful and rare magic item of incredible power.",
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['magic']
  },
  {
    id: '118',
    article: 'The Thirteenth Tribe',
    author: ['Richard Thomassen'],
    artist: ['Tyler Walpole'],
    page: '45-48',
    issue: rifter13,
    issueTitle: 'The Rifter #13',
    image: './images/rifter13.jpg',
    summary: 'Adventure source material about the legendary 13th tribe of Wolfen people thought to be extinct.',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['adventure']
  },
  {
    id: '119',
    article: 'The Thirteen Deadly Magicks',
    author: ['James Calder'],
    artist: ['Wayne Breaux Jr.'],
    page: '49-53',
    issue: rifter13,
    issueTitle: 'The Rifter #13',
    image: './images/rifter13.jpg',
    summary: 'Thirteen new, optional, spells for Palladium Fantasy.',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['magic', 'spell']
  },
  {
    id: '120',
    article: 'The Legend of the Thirteen Orcish Lords',
    author: ['Jon Thompson'],
    artist: ['Apollo Okamura'],
    page: '54-70',
    issue: rifter13,
    issueTitle: 'The Rifter #13',
    image: './images/rifter13.jpg',
    summary: 'Adventure source material for Palladium Fantasy about legendary Orcish Lords. Includes the High Orc O.C.C, Orcish Knight R.C.C., a new riding animal used by Orcs, and other fun stuff.',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['occ', 'rcc', 'adventure']
  },
  {
    id: '121',
    article: 'Dark Techno-Wizardry',
    author: ['Bill Fellows'],
    artist: ['Kent Burles'],
    page: '71-84',
    issue: rifter13,
    issueTitle: 'The Rifter #13',
    image: './images/rifter13.jpg',
    summary: 'Some interesting, optional O.C.C.s and Techno-Wizard devices for use in Rifts. Includes the Necro-Tech and Techno-Shifter, as well as building Techno-Horrors and various O.C.C. related powers and TW devices and guns.',
    games: ['Rifts'],
    official: 'No',
    tags: ['occ', 'tw', 'technowizard', 'weapon']
  },
  {
    id: '122',
    article: 'The Thirteenth Hour',
    author: ['Rick Wulf'],
    artist: ['Apollo Okamura', 'David Black'],
    page: '85-96',
    issue: rifter13,
    issueTitle: 'The Rifter #13',
    image: './images/rifter13.jpg',
    summary: 'A strangle little tale about strange happenings, the monstrous Rodian, dimensional travel and Techno-Wizard magic for expanding into adventures.',
    games: ['Rifts'],
    official: 'No',
    tags: ['story', 'technowizard', 'tw']
  },
  {
    id: '123',
    article: 'Questions and Answers',
    author: ['Rodney Stott', 'Shawn Merrow'],
    artist: ['Apollo Okamura', 'Mike Wilson'],
    page: '12-14',
    issue: rifter14,
    issueTitle: 'The Rifter #14',
    image: './images/rifter14.jpg',
    summary: "Addresses questions concerning 'skills', particularly for Heroes Unlimited and its skills and skill programs, as well as O.C.C., R.C.C., experience, hover crafts, and Cyber-Knights.",
    games: ['Any'],
    official: 'No',
    tags: ['occ', 'rcc', 'qa', 'rules', 'tips']
  },
  {
    id: '124',
    article: 'The Atorian Empire',
    author: ['Wayne Breaux Jr.'],
    artist: ['Wayne Breaux Jr.'],
    page: '27-37',
    issue: rifter14,
    issueTitle: 'The Rifter #14',
    image: './images/rifter14.jpg',
    summary: 'Insight and source material about the Atorian Empire. Includes the structure of the Atorian Empire, current state of affairs, and select O.C.C.s common to the Imperial Army. Not to mention Empress De Atoria, power armor.',
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['occ', 'npc']
  },
  {
    id: '125',
    article: "Destiny's Call",
    author: ['Erik Growen'],
    artist: ['Freddie Williams II'],
    page: '38-56',
    issue: rifter14,
    issueTitle: 'The Rifter #14',
    image: './images/rifter14.jpg',
    summary: 'An adventure that spans a generation involving an Infernal Demon Overlord. Starts at the end of World War II, continues on into the Indochina War, and maybe end or continue on into the present day. Includes special skill programs and options, battlefield Horror Factor, a variety of weapons, aircraft, and troops, encounter tables, plus a bunch of Hook, Line and Sinker adventures.',
    games: ['Ninjas and Superspies'],
    official: 'No',
    tags: ['adventure', 'npc', 'skill', 'weapon']
  },
  {
    id: '126',
    article: 'Beneath the Surface',
    author: ['Sonny Rice'],
    artist: ['Mike Wilson'],
    page: '57-70',
    issue: rifter14,
    issueTitle: 'The Rifter #14',
    image: './images/rifter14.jpg',
    summary: 'Life, adventure and combat under the Palladium World. Includes new skills, natural dangers, fighting underground, and a host of monsters such as the Heat Worm, Vydoracks, Mataat Carrion People, Sharee Chameleon People, Necro Knights, Dirt Vipers, Murder Fog and others.',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['weapon', 'skill', 'monster']
  },
  {
    id: '127',
    article: 'Goodcourt - Life in a Fadetown',
    author: ['Eric Swanson'],
    artist: ['Apollo Okamura'],
    page: '71-86',
    issue: rifter14,
    issueTitle: 'The Rifter #14',
    image: './images/rifter14.jpg',
    summary: 'The Fadetown of Goodcourt, along with its most notable features and inhabitants. It is a magical place with Techno-Wizards and High Magi from Dweomer. A handful of new Techno-Wizard items and Adventure ideas.',
    games: ['Rifts'],
    official: 'No',
    tags: ['location', 'technowizard', 'tw', 'magic', 'adventure']
  },
  {
    id: '128',
    article: 'Horlock Robots Inc.',
    author: ['Jeremy Clements'],
    artist: ['Drunken Style Studio'],
    page: '87-104',
    issue: rifter14,
    issueTitle: 'The Rifter #14',
    image: './images/rifter14.jpg',
    summary: "Horlock Robots: one of the Black Market's suppliers of power armor, robotics and knock-off technology. The Zombie Exoskeleton, Medusa Power Armor, Harpy Power Armor, and Fire-Walker Assault Robot.",
    games: ['Rifts'],
    official: 'No',
    tags: ['blackmarket', 'armor', 'robot']
  },
  {
    id: '129',
    article: 'Asylum',
    author: ['Anthony Miron'],
    artist: ['Wayne Breaux Jr.'],
    page: '105',
    issue: rifter14,
    issueTitle: 'The Rifter #14',
    image: './images/rifter14.jpg',
    summary: 'A short story brought to you.',
    games: ['Nightbane'],
    official: 'No',
    tags: ['story']
  },
  {
    id: '130',
    article: 'Questions and Answers',
    author: ['Rodney Stott', 'Shawn Merrow'],
    artist: ['Jeff Burke'],
    page: '17-18',
    issue: rifter15,
    issueTitle: 'The Rifter #15',
    image: './images/rifter15.jpg',
    summary: "Questions concerning a variety of topics, from the price of Palladium Fantasy RPG wagons to vehicle speed in a 'dense' forest to Cosmo Knights, and jet lag.",
    games: ['Any'],
    official: 'No',
    tags: ['qa', 'rules', 'tips']
  },
  {
    id: '131',
    article: 'Knights of the Eastern Territories',
    author: ['Steve Edwards'],
    artist: ['Jeff Burke'],
    page: '19-26',
    issue: rifter15,
    issueTitle: 'The Rifter #15',
    image: './images/rifter15.jpg',
    summary: 'A bit of history and specific Knightly Orders found in the southern and northern parts of the Eastern Territories, presented in detail. Includes masters of the shield, sword, lance and horse.',
    games: ['Palladium Fantasy'],
    official: 'Yes',
    tags: ['story', 'location']
  },
  {
    id: '132',
    article: 'Blade Law',
    author: ['Richard Thomassen'],
    artist: ['Apollo Okamura'],
    page: '27-32',
    issue: rifter15,
    issueTitle: 'The Rifter #15',
    image: './images/rifter15.jpg',
    summary: "History, magic and rules for Rune Weapons. Some cool ideas and a keen insight as to how these fabled weapons were created. The Backlash section takes into consideration the magical weapons' intelligence, awareness and curses.",
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['weapon', 'rules', 'magic']
  },
  {
    id: '133',
    article: 'In Only Six Days',
    author: ['James M.G. Cannon'],
    artist: ['Michael Wilson'],
    page: '33-41',
    issue: rifter15,
    issueTitle: 'The Rifter #15',
    image: './images/rifter15.jpg',
    summary: "Insight and suggestions to 'world building' in the Heroes Unlimited setting. The world at large, history, technology, magic, vigilantes, themes and more.",
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['gm', 'tools', 'location', 'tips', 'magic']
  },
  {
    id: '134',
    article: 'Brain Fry',
    author: ['David Haendler'],
    artist: ['Freddie Williams II'],
    page: '42-50',
    issue: rifter15,
    issueTitle: 'The Rifter #15',
    image: './images/rifter15.jpg',
    summary: 'Villains and designer drugs for the world of the misbegotten and misunderstood Nightbane. Plus a trio of villains.',
    games: ['Nightbane', 'Heroes Unlimited'],
    official: 'No',
    tags: ['npc', 'monster', 'adventure']
  },
  {
    id: '135',
    article: 'New Morphus Tables',
    author: ['Eric Baierl', 'David Solon Phillips', 'RC Craigo', 'DeAnna Renae Bearce'],
    artist: ['Wayne Breaux Jr.'],
    page: '51-64',
    issue: rifter15,
    issueTitle: 'The Rifter #15',
    image: './images/rifter15.jpg',
    summary: 'Really cool and exciting new morphus combinations, including Alien Appendage, Food, Fish, Mannequin, Toy, Freak and Undead Tables. New Nightbane talents, including Shadow Weapons and other cool things.',
    games: ['Nightbane'],
    official: 'No',
    tags: ['morphus']
  },
  {
    id: '136',
    article: 'Operation Ironskull',
    author: ['Ted Dimitry'],
    artist: ['Ted Dimitry'],
    page: '65-75',
    issue: rifter15,
    issueTitle: 'The Rifter #15',
    image: './images/rifter15.jpg',
    summary: 'Optional Coalition Cyborgs and skullduggery. Four optional new CS Cyborgs and adventure ideas.',
    games: ['Rifts'],
    official: 'No',
    tags: ['coalition', 'adventure', 'cs', 'occ']
  },
  {
    id: '137',
    article: 'One Chance in a Million',
    author: ['Paul Sillanpaa'],
    artist: ['Michael Wilson'],
    page: '76-87',
    issue: rifter15,
    issueTitle: 'The Rifter #15',
    image: './images/rifter15.jpg',
    summary: 'Part one of a three-part story dealing with Chi-Town, the Black Market, NTSET and Colonel Thaddius Lyboc.',
    games: ['Rifts'],
    official: 'No',
    tags: ['coalition', 'story', 'npc', 'blackmarket', 'cs']
  },
  {
    id: '138',
    article: 'Specialized Shifters',
    author: ['Alex Miller'],
    artist: ['Wayne Breaux Jr.'],
    page: '88-103',
    issue: rifter15,
    issueTitle: 'The Rifter #15',
    image: './images/rifter15.jpg',
    summary: 'Variant Shifter O.C.C.s for your consideration. Includes the Traveler, Sensechal, and a dozen or more new Shifter spells.',
    games: ['Rifts'],
    official: 'No',
    tags: ['occ', 'magic', 'spell']
  },
  {
    id: '139',
    article: 'Questions and Answers',
    author: ['Rodney Stott', 'Shawn Merrow', 'Kevin Siembieda'],
    artist: ['Ramon Perez', 'Scott Johnson', 'Apollo Okamura'],
    page: '17-21',
    issue: rifter16,
    issueTitle: 'The Rifter #16',
    image: './images/rifter16.jpg',
    summary: "Questions concerning a variety of 'combat' issues for Rifts, Palladium Fantasy, and others. Includes a 'Sequence of Combat' example.",
    games: ['Any'],
    official: 'No',
    tags: ['qa', 'tips', 'rules']
  },
  {
    id: '140',
    article: 'Young, Dumb and Ugly',
    author: ['Mark Hall'],
    artist: ['Michael Wilson'],
    page: '24-27',
    issue: rifter16,
    issueTitle: 'The Rifter #16',
    image: './images/rifter16.jpg',
    summary: 'The grim and grimy life, history and society of the ugly members of the Palladium Fantasy world: Orcs, Goblins, and Hob-Goblins. Includes the True Cobbler R.C.C. (magic wielding Goblins)',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['monster', 'monster', 'rcc', 'magic']
  },
  {
    id: '141',
    article: 'Teen Heroes Unlimited',
    author: ['Kurt Charbonnier'],
    artist: ['Tyler Walpole'],
    page: '28-32',
    issue: rifter16,
    issueTitle: 'The Rifter #16',
    image: './images/rifter16.jpg',
    summary: "Optional rules and ideas for playing 'teenage' superheroes and sidekicks. Includes random power tables, plus Age Modifiers, Power Control, Sidekick Training, and Special Abilities.",
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['rules', 'power']
  },
  {
    id: '142',
    article: 'Hell: Frozen Over',
    author: ['Erik Growen'],
    artist: [''],
    page: '33-48',
    issue: rifter16,
    issueTitle: 'The Rifter #16',
    image: './images/rifter16.jpg',
    summary: 'An adventure suitable for use with Ninjas and Superspies or Beyond the Supernatural or RECON. Involves the horrors of war, an insane Undead Immortal, the supernatural and the Korean War. Includes Battlefield Horror Factor rules, fighting in sub-zero temperatures, night fighting, and a cool villain: Major Yung Ngo. Several adventure ideas and adventure outlines.',
    games: ['Ninjas and Superspies', 'Beyond the Supernatural', 'RECON'],
    official: 'No',
    tags: ['npc', 'rules', 'adventure']
  },
  {
    id: '143',
    article: 'Dark Revelations',
    author: ['Jason Vey'],
    artist: ['Wayne Breaux Jr.'],
    page: '49-81',
    issue: rifter16,
    issueTitle: 'The Rifter #16',
    image: './images/rifter16.jpg',
    summary: 'Nightbane adventure and source material. Angel-like Athanatos, another supernatural force in the dark world controlled by the Nightlords. These strange, but winged creatures are more than human. Much more.',
    games: ['Nightbane'],
    official: 'No',
    tags: ['adventure', 'npc']
  },
  {
    id: '144',
    article: 'Coalition Wars: Final Siege',
    author: ['Bill Coffin'],
    artist: ['Tyler Walpole', 'Michael Wilson', 'Wayne Breaux Jr.'],
    page: '82-90',
    issue: rifter16,
    issueTitle: 'The Rifter #16',
    image: './images/rifter16.jpg',
    summary: 'Hook, Line and Sinker adventures for Final Siege (on Tolkeen). ',
    games: ['Rifts'],
    official: 'Yes',
    tags: ['adventure']
  },
  {
    id: '145',
    article: 'One Chance in a Million',
    author: ['Paul Sillanpaa'],
    artist: [''],
    page: '97-109',
    issue: rifter16,
    issueTitle: 'The Rifter #16',
    image: './images/rifter16.jpg',
    summary: 'Part two (of three) of this intriguing story of a mage stuck in Chi-Town.',
    games: ['Rifts'],
    official: 'No',
    tags: ['story', 'coalition']
  },
  {
    id: '146',
    article: 'Questions and Answers',
    author: ['Rodney Stott', 'Shawn Merrow', 'Kevin Siembieda'],
    artist: ['Kevin Long', 'Ramon Perez', 'Freddie Williams'],
    page: '16-24',
    issue: rifter17,
    issueTitle: 'The Rifter #17',
    image: './images/rifter17.jpg',
    summary: "Includes a new Minor Super Ability, information on swimming, deep sea depths, the bends and the oceans, plus rules for mistreating weapons, S.D.C. for weapons and equipment, penalties on damaged body armor, footwear, vampires and 'Defining the -10 dodge bullets' rule.",
    games: ['Any'],
    official: 'No',
    tags: ['rules', 'power', 'combat', 'weapon']
  },
  {
    id: '147',
    article: 'Last Street; scenario setting',
    author: ['Todd Yoho'],
    artist: ['Wayne Breaux Jr.'],
    page: '25-34',
    issue: rifter17,
    issueTitle: 'The Rifter #17',
    image: './images/rifter17.jpg',
    summary: "Interesting and creepy setting for Beyond the Supernatural including notable places like the Center for the Study of the Arcane, Things Forgotten Antique Shop, Land's Outfitters and a number of other places, as well as notable NPCs. Also, a few mysteries, equipment items and adventure ideas.",
    games: ['Beyond the Supernatural'],
    official: 'No',
    tags: ['magic', 'npc', 'adventure', 'location', 'equipment']
  },
  {
    id: '148',
    article: 'The Thropo Aliens Revisited',
    author: ['Wayne Breaux Jr.'],
    artist: ['Wayne Breaux Jr.'],
    page: '35-44',
    issue: rifter17,
    issueTitle: 'The Rifter #17',
    image: './images/rifter17.jpg',
    summary: 'Takes a closer look at the apish Thropo aliens and their role in the Atorian Empire and universe at large. Background, society, military, galactic travels, bionics and the Thropo Super Soldier.',
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['npc', 'occ']
  },
  {
    id: '149',
    article: 'Stilt City',
    author: ['Sonny Rice'],
    artist: ['Kent Burles'],
    page: '45-55',
    issue: rifter17,
    issueTitle: 'The Rifter #17',
    image: './images/rifter17.jpg',
    summary: "Stilt City in the remote and mysterious Land of the South Winds. The city's history, population, and notable people and places. Local folk such as Duke Theadin, Guildmaster Swan, Kraigan the Assassin and others. Plus some adventure ideas.",
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['location', 'npc', 'adventure']
  },
  {
    id: '150',
    article: 'Dweomer Mage O.C.C. (and new magic)',
    author: ['James Calder'],
    artist: ['Michael Wilson'],
    page: '56-68',
    issue: rifter17,
    issueTitle: 'The Rifter #17',
    image: './images/rifter17.jpg',
    summary: 'The Dweomer Mage presented in detail, followed by a host of new magic spells for the mage or others.',
    games: ['Rifts'],
    official: 'No',
    tags: ['spell', 'occ']
  },
  {
    id: '151',
    article: 'The Bandits of Hollow Hill',
    author: ['Patrick Nowak'],
    artist: ['Apollo Okamura'],
    page: '69-78',
    issue: rifter17,
    issueTitle: 'The Rifter #17',
    image: './images/rifter17.jpg',
    summary: 'Adventure source-material about The Hollow Hill bandit lair (with maps), the bandits, monsters, surprises, and adventure ideas.',
    games: ['Rifts'],
    official: 'No',
    tags: ['adventure']
  },
  {
    id: '152',
    article: 'Blood Magic',
    author: ['Nathan Bingham'],
    artist: ['Wayne Breaux Jr.', 'Tyler Walpole'],
    page: '79-83',
    issue: rifter17,
    issueTitle: 'The Rifter #17',
    image: './images/rifter17.jpg',
    summary: "The gruesome mythos of 'Blood Magic.'",
    games: ['Rifts'],
    official: 'No',
    tags: ['magic', 'spell']
  },
  {
    id: '153',
    article: 'One Chance in a Million',
    author: ['Paul Sillanpaa'],
    artist: ['Apollo Okamura'],
    page: '84-92',
    issue: rifter17,
    issueTitle: 'The Rifter #17',
    image: './images/rifter17.jpg',
    summary: "The third and final chapter in Paul Sillanpaa's Rifts story.",
    games: ['Rifts'],
    official: 'No',
    tags: ['story']
  },
  {
    id: '154',
    article: 'Chaos Earth RPG Part One: The Great Cataclysm',
    author: ['Kevin Siembieda'],
    artist: ['Kent Burles', 'Kevin Long', 'Mike Williams'],
    page: '101-110',
    issue: rifter17,
    issueTitle: 'The Rifter #17',
    image: './images/rifter18.jpg',
    summary: 'A serialization of Chaos Earth.',
    games: ['Chaos Earth'],
    official: 'No',
    tags: ['story']
  },
  {
    id: '155',
    article: 'Questions and Answers',
    author: ['Rodney Stott', 'Shawn Merrow', 'Kevin Siembieda'],
    artist: ['Mike Wilson', 'Tyler Walpole'],
    page: '16-19',
    issue: rifter18,
    issueTitle: 'The Rifter #18',
    image: './images/rifter18.jpg',
    summary: 'Focuses on mutants, dogs, and the After the Bomb RPG. Mutant Emperor Penguins, Trained Dogs, small mutants, and other mutant-related things.',
    games: ['After the Bomb'],
    official: 'No',
    tags: ['mutant']
  },
  {
    id: '156',
    article: 'Expanded Unusual Characteristics Tables',
    author: ['Rob Morrison'],
    artist: ['Tyler Walpole'],
    page: '20-24',
    issue: rifter18,
    issueTitle: 'The Rifter #18',
    image: './images/rifter18.jpg',
    summary: 'A massive table with many sub-tables for the appearance of mutants for Heroes Unlimited. Includes bonuses, penalties and, sometimes, special powers or abilities.',
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['rules', 'power']
  },
  {
    id: '157',
    article: 'Mysteries of Southeast Asia',
    author: ['Russell Brin'],
    artist: ['Ramen Perez'],
    page: '25-33',
    issue: rifter18,
    issueTitle: 'The Rifter #18',
    image: './images/rifter18.jpg',
    summary: 'Strange and interesting martial arts O.C.C.s. There is the Dukun sorcerer healer, new spells, Stickfighter and Bersilat Malaysian martial artist, plus a few monsters.',
    games: ['Ninjas and Superspies', 'Heroes Unlimited'],
    official: 'No',
    tags: ['occ', 'monster', 'combat', 'magic', 'spell']
  },
  {
    id: '158',
    article: 'Planetary Creation Guide',
    author: ['Daniel Denis'],
    artist: ['Apollo Okamura', 'Michael Wilson'],
    page: '34-46',
    issue: rifter18,
    issueTitle: 'The Rifter #18',
    image: './images/rifter18.jpg',
    summary: 'Interesting and comprehensive planetary creation tables and considerations as an optional way for creating worlds and solar systems throughout the Megaverse.',
    games: ['Heroes Unlimited', 'Phase World'],
    official: 'No',
    tags: ['tools', 'gm']
  },
  {
    id: '159',
    article: 'Song Magic',
    author: ['Joseph Larsen'],
    artist: ['Tyler Walpole'],
    page: '47-53',
    issue: rifter18,
    issueTitle: 'The Rifter #18',
    image: './images/rifter18.jpg',
    summary: 'The magic of music in this unique presentation on one of the many obscure mystic arts of the Palladium World. Includes the optional Song Mage O.C.C. and over 20 musical spells.',
    games: ['Palladium Fantasy', 'Rifts'],
    official: 'No',
    tags: ['occ', 'magic', 'spell']
  },
  {
    id: '160',
    article: 'Wormwood',
    author: ['Eric Thompson'],
    artist: ['Tyler Walpole'],
    page: '54-61',
    issue: rifter18,
    issueTitle: 'The Rifter #18',
    image: './images/rifter18.jpg',
    summary: 'A presentation of the Symbiotic Warrior of Wormwood, some cool powers over symbiotes, combat symbiotes, some notes and guidelines.',
    games: ['Rifts'],
    official: 'No',
    tags: ['occ', 'tips']
  },
  {
    id: '161',
    article: 'A Long Dark Walk',
    author: ['Kimara Bernard'],
    artist: ['Kent Burles'],
    page: '62-67',
    issue: rifter18,
    issueTitle: 'The Rifter #18',
    image: './images/rifter18.jpg',
    summary: 'Part story, part optional source material, complete with new O.C.C.s and plot ideas.',
    games: ['Rifts'],
    official: 'No',
    tags: ['story', 'occ', 'adventure']
  },
  {
    id: '162',
    article: 'Coalition Biowarfare Division',
    author: ['David Liam Moran'],
    artist: ['Apollo Okamura'],
    page: '68-85',
    issue: rifter18,
    issueTitle: 'The Rifter #18',
    image: './images/rifter18.jpg',
    summary: "Very 'optional' set of source material for CS biowarfare. NOT officially sanctioned by Kevin Siembieda or Palladium Books.",
    games: ['Rifts'],
    official: 'No',
    tags: ['coalition', 'cs']
  },
  {
    id: '163',
    article: 'Chaos Earth RPG Part Two: NEMA O.C.C.s and The Great Cataclysm',
    author: ['Kevin Siembieda'],
    artist: ['Kent Burles', 'Kevin Long', 'Mike Williams'],
    page: '94-111',
    issue: rifter18,
    issueTitle: 'The Rifter #18',
    image: './images/rifter18.jpg',
    summary: 'The second installment for Chaos Earth. Armageddon Christmas Day Blues. NEMA and NEMA Response Teams broken down by O.C.C.s like the Chromium Guardsmen, Fire and Rescue, Para-Arcane, and the Silver Eagle Strike Force. Paranoid Vigilantes and Militia groups, and Witch-Hunters.',
    games: ['Chaos Earth'],
    official: 'No',
    tags: ['occ']
  },
  {
    id: '164',
    article: 'Questions and Answers',
    author: ['Rodney Stott', 'Shawn Merrow', 'Kevin Siembieda'],
    artist: ['Kevin Long', 'Mike Wilson'],
    page: '21-24',
    issue: rifter19,
    issueTitle: 'The Rifter #19',
    image: './images/rifter19.jpg',
    summary: 'Includes Rahu-Men and Changelings in Rifts, black powder weapons, aging characters, aging superheroes, and Chaos Earth',
    games: ['Any'],
    official: 'Yes',
    tags: ['race']
  },
  {
    id: '165',
    article: 'Wand Magic',
    author: ['Kevin Christensen'],
    artist: ['Kent Burles'],
    page: '25-28',
    issue: rifter19,
    issueTitle: 'The Rifter #19',
    image: './images/rifter19.jpg',
    summary: 'Cool ideas about how magic wands are created, their powers and design elements, along with four Famous Wands of Lore.',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['magic']
  },
  {
    id: '166',
    article: "The Magic of Ophid's Grasslands",
    author: ['Nicholas Mueller'],
    artist: ['Kent Burles'],
    page: '29-32',
    issue: rifter19,
    issueTitle: 'The Rifter #19',
    image: './images/rifter19.jpg',
    summary: "Interesting and clever spells designed specifically for Ophid's Grasslands",
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['magic', 'spell', 'location']
  },
  {
    id: '167',
    article: 'By Lance and Speed of Wing',
    author: ['Richard Thomassen'],
    artist: ['Michael Wilson'],
    page: '33-36',
    issue: rifter19,
    issueTitle: 'The Rifter #19',
    image: './images/rifter19.jpg',
    summary: 'Special techniques, training and bonuses to riding a winged mount like a Pegasus. Rules, bonuses, and the Great Gryphon.',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['skill', 'rules']
  },
  {
    id: '168',
    article: 'Go Mental',
    author: ['John Charles Philpott'],
    artist: ['Mike Wilson', 'Kent Burles'],
    page: '37-42',
    issue: rifter19,
    issueTitle: 'The Rifter #19',
    image: './images/rifter19.jpg',
    summary: "'Mental' skills like memorization, philosophy, puzzles and others, as well as some new physical skills and optional rules to tame the physical skill junkie.",
    games: ['Any'],
    official: 'No',
    tags: ['skill', 'rules']
  },
  {
    id: '169',
    article: "We're Not All Mind Readers, You Know",
    author: ['Ed Sauerland'],
    artist: ['Freddie Williams II'],
    page: '43-53',
    issue: rifter19,
    issueTitle: 'The Rifter #19',
    image: './images/rifter19.jpg',
    summary: "New 'Eruptor' psionic character classes, including the Blaster, the Freezer, and the Soaker. Each is accompanied by a number of specific abilities, bonuses and penalties.",
    games: ['Rifts'],
    official: 'No',
    tags: ['pcc', 'p.c.c.']
  },
  {
    id: '170',
    article: 'Coalition Support Vehicles',
    author: ['Wayne Field'],
    artist: ['Apollo Okamura'],
    page: '54-65',
    issue: rifter19,
    issueTitle: 'The Rifter #19',
    image: './images/rifter19.jpg',
    summary: 'Workhorse vehicles behind the scenes that keep the Coalition Army on its feet and in the trenches. Six new vehicles in all - completely described, statted out and illustrated.',
    games: ['Rifts'],
    official: 'No',
    tags: ['vehicle', 'cs', 'coalition']
  },
  {
    id: '171',
    article: 'Fort Folsom',
    author: ['Todd Yoho'],
    artist: ['Tyler Walpole'],
    page: '72-80',
    issue: rifter19,
    issueTitle: 'The Rifter #19',
    image: './images/rifter19.jpg',
    summary: "A small but important stronghold against 'the bugs' located in West Virginia. An overview, key leaders, and adventure ideas.",
    games: ['Systems Failure'],
    official: 'No',
    tags: ['adventure', 'monster', 'npc', 'location']
  },
  {
    id: '172',
    article: 'Demon Hunters',
    author: ['Mike Richardson'],
    artist: ['Wayne Breaux Jr.'],
    page: '81-90',
    issue: rifter19,
    issueTitle: 'The Rifter #19',
    image: './images/rifter19.jpg',
    summary: "Completely fleshed out Demon Hunter O.C.C., as well as a villain called 'The Dark Rider'.",
    games: ['Nightbane'],
    official: 'No',
    tags: ['occ', 'npc']
  },
  {
    id: '173',
    article: 'Chaos Earth RPG Part Three: Magic and Magic O.C.C.s',
    author: ['Kevin Siembieda'],
    artist: ['Mike Wilson'],
    page: '91-111',
    issue: rifter19,
    issueTitle: 'The Rifter #19',
    image: './images/rifter19.jpg',
    summary: "Excerpts from the Journal of Lieutenant General Lindsey Sawyer. A glimpse of life in Chicago and General Sawyer's personal experiences and fears. A section about the emergence of magic in Chaos Earth and a few new Magic O.C.C.s. Plus more hints about NEMA and a bit on psychics.",
    games: ['Chaos Earth'],
    official: 'No',
    tags: ['npc', 'occ', 'magic']
  },
  {
    id: '174',
    article: 'Questions and Answers',
    author: ['Rodney Stott', 'Shawn Merrow', 'Kevin Siembieda'],
    artist: [''],
    page: '16-17',
    issue: rifter20,
    issueTitle: 'The Rifter #20',
    image: './images/rifter20.jpg',
    summary: 'Questions about Horror Factor, Nightbane and things that go bump in the night.',
    games: ['Any'],
    official: 'No',
    tags: ['qa', 'rules', 'tips']
  },
  {
    id: '175',
    article: 'A Last Street Adventure',
    author: ['Todd Yoho'],
    artist: ['Todd Yoho'],
    page: '20-31',
    issue: rifter20,
    issueTitle: 'The Rifter #20',
    image: './images/rifter20.jpg',
    summary: 'A sinister adventure set in 1930 Chicago. Zombies, study of the arcane, time travel, and intrigue',
    games: ['Beyond the Supernatural'],
    official: 'No',
    tags: ['adventure', 'magic', 'location']
  },
  {
    id: '176',
    article: 'Optional Morphus Tables',
    author: ['Ed Woodward III'],
    artist: ['Wayne Breaux Jr.', 'Kevin Long', 'Vince Martin', 'Ed Woodward III'],
    page: '32-66',
    issue: rifter20,
    issueTitle: 'The Rifter #20',
    image: './images/rifter20.jpg',
    summary: "A variety of novel, bizarre, horrific and downright crazy ideas for Nightbane characters based on a 'theme' such as The Chosen, Chimera, Dinosaur, Medieval, and Science Fiction.",
    games: ['Nightbane'],
    official: 'No',
    tags: ['morphus', 'equipment']
  },
  {
    id: '177',
    article: 'From the Shadows',
    author: ['Sonny Rice'],
    artist: ['Apollo Okamura'],
    page: '67-82',
    issue: rifter20,
    issueTitle: 'The Rifter #20',
    image: './images/rifter20.jpg',
    summary: 'Where do Shadow Beasts come from? More about Shadow Magic and the Shadow Realm. New Shadow Monsters like the Shadow Giant, Winged Shades, Shadow Entity, Shadow Serpents, Shadowmorphs, and more. Optional Shade Mage O.C.C. and 26 new Shadow Magic spells.',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['occ', 'magic', 'spell']
  },
  {
    id: '178',
    article: 'Thunderbolt',
    author: ['Owen Johnson'],
    artist: ['Freddie Williams II'],
    page: '88-97',
    issue: rifter20,
    issueTitle: 'The Rifter #20',
    image: './images/rifter20.jpg',
    summary: "An adventure involving the Coalition, an experimental aircraft, pre-Rifts technology, espionage and fun. Includes stats for the Thunderbolt jet aircraft, notable NPCs, and Hamilton's Creepers, an elite mercenary group.",
    games: ['Rifts'],
    official: 'No',
    tags: ['npc', 'adventure', 'cs', 'coalition']
  },
  {
    id: '179',
    article: 'A Few Hook, Line and Sinkers',
    author: ['Jeremy Clements'],
    artist: ['Kent Burles'],
    page: '98-103',
    issue: rifter20,
    issueTitle: 'The Rifter #20',
    image: './images/rifter20.jpg',
    summary: 'Seven different adventure ideas for your consideration. The CS, demons, Erin Tarn, swamps, and spaceships.',
    games: ['Rifts'],
    official: 'No',
    tags: ['adventure', 'cs', 'coalition']
  },
  {
    id: '180',
    article: 'P.P.E. Channeling',
    author: ['Jason Richards'],
    artist: ['Apollo Okamura'],
    page: '15-17',
    issue: rifter21,
    issueTitle: 'The Rifter #21',
    image: './images/rifter21.jpg',
    summary: 'Approaches to drawing on and using Potential Psychic Energy to work magic.',
    games: ['Any'],
    official: 'No',
    tags: ['ppe', 'magic']
  },
  {
    id: '181',
    article: 'The Motherframe',
    author: ['Joseph Larsen'],
    artist: ['Brendan Smith'],
    page: '18-26',
    issue: rifter21,
    issueTitle: 'The Rifter #21',
    image: './images/rifter21.jpg',
    summary: "A strange and unique type of psionic augmentation via the artificial intelligence known as 'Motherframe.' The Info Junkie O.C.C.",
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['occ', 'psionic']
  },
  {
    id: '182',
    article: 'Familiars of Rifts Earth',
    author: ['C.N. Constantin'],
    artist: ['Apollo Okamura'],
    page: '27-39',
    issue: rifter21,
    issueTitle: 'The Rifter #21',
    image: './images/rifter21.jpg',
    summary: 'A unique view of familiars found on Rifts Earth: The Action Golem, Book Wyrm, Clarion Crawler, Compies, MiniBane and Pet Rock. Familiar Wrangler O.C.C., spells, and other stuff.',
    games: ['Rifts'],
    official: 'No',
    tags: ['occ', 'spell', 'magic', 'monster']
  },
  {
    id: '183',
    article: 'Techno-Wizardry: Form and Function',
    author: ['Shawn Therrien'],
    artist: ['Brian Manning'],
    page: '40-46',
    issue: rifter21,
    issueTitle: 'The Rifter #21',
    image: './images/rifter21.jpg',
    summary: 'A look at the form, function and synergy of Techno-Wizardry with information about trying new things, making and testing prototypes, creation guidelines, terms, bonuses and penalties.',
    games: ['Rifts'],
    official: 'No',
    tags: ['technowizard', 'tw', 'tools', 'gm']
  },
  {
    id: '184',
    article: 'The Long Forgotten Quest',
    author: ['Andrew Rusling'],
    artist: ['Kent Burles'],
    page: '54-92',
    issue: rifter21,
    issueTitle: 'The Rifter #21',
    image: './images/rifter21.jpg',
    summary: 'An epic adventure with intrigue, twists, turns, action, and surprises. Starts in the Western Empire and weaves its way from one bit of trouble to the next.',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['adventure']
  },
  {
    id: '185',
    article: 'Questions and Answers',
    author: ['Rodney Stott', 'Shawn Merrow', 'Kevin Siembieda'],
    artist: [''],
    page: '14-16',
    issue: rifter22,
    issueTitle: 'The Rifter #22',
    image: './images/rifter22.jpg',
    summary: 'Children, their heightened P.P.E., levels, ability to use magic, age restrictions (and death) for getting Juicer and M.O.M. augmentation, bionics and kids, and other good stuff.',
    games: ['Any'],
    official: 'No',
    tags: ['ppe', 'mom', 'qa', 'rules', 'tips']
  },
  {
    id: '186',
    article: 'Mage Armor',
    author: ['Brian Manning', 'Kevin Siembieda'],
    artist: ['Brian Manning'],
    page: '17',
    issue: rifter22,
    issueTitle: 'The Rifter #22',
    image: './images/rifter22.jpg',
    summary: 'The latest in Mega-Damage body armor for spell casters and sorcerers of every stripe.',
    games: ['Rifts'],
    official: 'No',
    tags: ['armor', 'magic']
  },
  {
    id: '186a',
    article: 'Building a Better Super-Soldier',
    author: ['John Polojac'],
    artist: ['Kent Burles', 'Mike Majestic', 'Ka Xiong'],
    page: '18-24',
    issue: rifter22,
    issueTitle: 'The Rifter #22',
    image: './images/rifter22.jpg',
    summary: 'Optional rules for expanding and developing different types of Super-Soldiers for use in Heroes Unlimited.',
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['rules', 'power']
  },
  {
    id: '187',
    article: 'New Ludicrous Magic',
    author: ['Daniel Denis'],
    artist: ['Brian Manning'],
    page: '25-46',
    issue: rifter22,
    issueTitle: 'The Rifter #22',
    image: './images/rifter22.jpg',
    summary: 'More ludicrous magic spells. Stuff like Boo, Butter Fingers, Create (and Play) Theme Song, Ugly Kid Joe, Balloon Fight, Bigger Guns, Create Dough-Boy Golem, and more.',
    games: ['Rifts'],
    official: 'No',
    tags: ['spell', 'magic']
  },
  {
    id: '188',
    article: 'Medieval Army Combat Rules',
    author: ['Dan Felkins'],
    artist: ['Mark Dudley', 'Ka Xiong'],
    page: '47-61',
    issue: rifter22,
    issueTitle: 'The Rifter #22',
    image: './images/rifter22.jpg',
    summary: 'Optional rules for creating and running entire armies, using archers and cavalry companies, defending fortified positions, breaching enemy defenses, typical training, and an example of army units.',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['rules', 'combat']
  },
  {
    id: '189',
    article: 'Flashing Blades: Fencing in Palladium Fantasy',
    author: ['Richard Thomassen'],
    artist: ['Ryan Csaszar'],
    page: '62-66',
    issue: rifter22,
    issueTitle: 'The Rifter #22',
    image: './images/rifter22.jpg',
    summary: 'Optional rules for a host of fencing skills, rules, bonuses, dueling and more.',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['rules', 'skill']
  },
  {
    id: '190',
    article: 'Flynn and Company',
    author: ['R.L. Newman'],
    artist: ['Brian Manning'],
    page: '67-81',
    issue: rifter22,
    issueTitle: 'The Rifter #22',
    image: './images/rifter22.jpg',
    summary: 'A unique short story that combines the worlds and characters of Nightbane and Heroes Unlimited.',
    games: ['Nightbane', 'Heroes Unlimited'],
    official: 'No',
    tags: ['story']
  },
  {
    id: '191',
    article: 'The Games Palladium Plays',
    author: ['Wayne Breaux Jr.'],
    artist: ['Wayne Breaux Jr.'],
    page: '82-88',
    issue: rifter22,
    issueTitle: 'The Rifter #22',
    image: './images/rifter22.jpg',
    summary: 'A series of articles in which Palladium creators feature one of their own campaign characters as an example of the thought process we go through in creating our own characters.',
    games: ['Any'],
    official: 'No',
    tags: ['gm', 'tips']
  },
  {
    id: '192',
    article: 'The Spell Breather',
    author: ['Ed Woodward III'],
    artist: ['Ed Woodward III'],
    page: '17-22',
    issue: rifter23,
    issueTitle: 'The Rifter #23',
    image: './images/rifter23.jpg',
    summary: 'A new, cool O.C.C. for Nightbane, the conjurer of Living Magic. Includes special abilities, a special appearance table and other pertinent data.',
    games: ['Nightbane'],
    official: 'No',
    tags: ['occ', 'magic', 'spell']
  },
  {
    id: '193',
    article: 'Palladium Astronomy',
    author: ['Carl Gleba'],
    artist: ['Apollo Okamura'],
    page: '23-28',
    issue: rifter23,
    issueTitle: 'The Rifter #23',
    image: './images/rifter23.jpg',
    summary: "What the night sky over the Palladium world might look like. Includes Palladium's first true telescope/Star Scope, and Temples in the Sky.",
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['gm']
  },
  {
    id: '194',
    article: 'The Blade Mage',
    author: ['A.J. Pickett'],
    artist: [''],
    page: '29-40',
    issue: rifter23,
    issueTitle: 'The Rifter #23',
    image: './images/rifter23.jpg',
    summary: 'An optional O.C.C. called The Blade Mage. Complete with a Hand to Hand Combat: Blade Master skill, weapon expertise and 37 Blade Magic spells.',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['occ', 'magic', 'spell', 'combat']
  },
  {
    id: '195',
    article: 'Mesozoic Land: Part One',
    author: ['Todd Yoho'],
    artist: ['Brian Manning'],
    page: '41-59',
    issue: rifter23,
    issueTitle: 'The Rifter #23',
    image: './images/rifter23.jpg',
    summary: 'A background for genetic mutants that are dinosaurs. Mutant dinosaurs with creation steps, background table, and 14 dinos completely statted out.',
    games: ['After the Bomb', 'Heroes Unlimited'],
    official: 'No',
    tags: ['mutant', 'gm']
  },
  {
    id: '196',
    article: 'The Faerie Harvest',
    author: ['Ted Dimitry'],
    artist: ['Apollo Okamura'],
    page: '60-73',
    issue: rifter23,
    issueTitle: 'The Rifter #23',
    image: './images/rifter23.jpg',
    summary: 'A number of new Splugorth Bio-Wizard vehicles, weapons and devices that incorporate Faerie Folk as their source of power. Plus, the Faerie War, Faerie Knight and Ley Wasp.',
    games: ['Rifts'],
    official: 'No',
    tags: ['magic', 'monster', 'biowizard', 'weapon']
  },
  {
    id: '197',
    article: 'CS Target Acquisition Groups',
    author: ['John Stevens'],
    artist: [''],
    page: '74-76',
    issue: rifter23,
    issueTitle: 'The Rifter #23',
    image: './images/rifter23.jpg',
    summary: 'A new area of special training in sniping for the Coalition Army. Includes the C-10S Laser Sniper Rifle.',
    games: ['Rifts'],
    official: 'No',
    tags: ['weapon', 'cs', 'coalition']
  },
  {
    id: '198',
    article: 'Modern Army Combat Rules',
    author: ['Dan Felkins'],
    artist: ['Wayne Breaux Jr.', 'Freddie Williams', 'Mike Wilson'],
    page: '77-91',
    issue: rifter23,
    issueTitle: 'The Rifter #23',
    image: './images/rifter23.jpg',
    summary: 'Mass army combat rules, tips, and suggestions. Includes some typical modern army units and army creation rules based on those for creating a Mercenary Company.',
    games: ['Rifts'],
    official: 'No',
    tags: ['rules', 'combat', 'tips']
  },
  {
    id: '199',
    article: 'Questions and Answers',
    author: ['Rodney Stott', 'Shawn Merrow', 'Kevin Siembieda'],
    artist: [''],
    page: '18-24',
    issue: rifter24,
    issueTitle: 'The Rifter #24',
    image: './images/rifter24.jpg',
    summary: 'Second Edition Fantasy conversions for Yin-Sloth Jungles.',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['conversion', 'location', 'qa', 'rules', 'tips']
  },
  {
    id: '200',
    article: 'Mesozoic Land: Part Two',
    author: ['Todd Yoho'],
    artist: ['Brian Manning', 'Allen Manning'],
    page: '27-47',
    issue: rifter24,
    issueTitle: 'The Rifter #24',
    image: './images/rifter24.jpg',
    summary: 'Maps, key locations, key characters, villains, weapons, and more. Plus, Hook, Line, and Sinker adventures.',
    games: ['After the Bomb', 'Heroes Unlimited'],
    official: 'No',
    tags: ['adventure', 'map', 'npc', 'weapon']
  },
  {
    id: '201',
    article: 'Media in Rifts Earth',
    author: ['Patrick Nowak'],
    artist: ['Mark Dudley', 'Brandon C. Clark', 'Sharard Jackson'],
    page: '48-71',
    issue: rifter24,
    issueTitle: 'The Rifter #24',
    image: './images/rifter24.jpg',
    summary: 'A look at arts, sports, and entertainment common to the Coalition States and North America. Takes a look at the CS Media machine, radio and television, movie production and the Black Market, Gladiator sports and arenas. Entertainment skills, the Performer O.C.C., Field Reporter O.C.C., Rifts Bard O.C.C. and a comprehensive look at the Rifts Gladiator',
    games: ['Rifts'],
    official: 'No',
    tags: ['occ', 'cs', 'coalition', 'skill']
  },
  {
    id: '202',
    article: 'The Metabolic Juicer',
    author: ['Eric Thompson'],
    artist: ['Brian Manning'],
    page: '72-81',
    issue: rifter24,
    issueTitle: 'The Rifter #24',
    image: './images/rifter24.jpg',
    summary: 'A variant Juicer O.C.C.',
    games: ['Rifts'],
    official: 'No',
    tags: ['occ']
  },
  {
    id: '203',
    article: 'Card Magic',
    author: ['Chris Matthys'],
    artist: ['Liz Rehfus'],
    page: '89-96',
    issue: rifter24,
    issueTitle: 'The Rifter #24',
    image: './images/rifter24.jpg',
    summary: 'Optional O.C.C. and rules for a new type of magic, more impressive and dangerous than one might think at first glance.',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['occ', 'magic', 'spell']
  },
  {
    id: '204',
    article: 'Guns for Hire',
    author: ['John C. Philpott'],
    artist: ['Brian Manning', 'Allan Manning'],
    page: '14-39',
    issue: rifter25,
    issueTitle: 'The Rifter #25',
    image: './images/rifter25.jpg',
    summary: 'Optional rules, skills, Skill Programs and ideas for running modern day military campaigns using Ninjas and Superspies and adaptable to Heroes Unlimited. Includes a wide range of new and modified Skill Programs, Real World Special Forces Units, and other material for those looking for more realistic military-style campaigns.',
    games: ['Ninjas and Superspies', 'Heroes Unlimited'],
    official: 'No',
    tags: ['skill', 'qa', 'rules', 'tips', 'gm']
  },
  {
    id: '205',
    article: 'The Lost Art of Golemancy',
    author: ['Sonny Rice'],
    artist: ['Apollo Okamura'],
    page: '40-44',
    issue: rifter25,
    issueTitle: 'The Rifter #25',
    image: './images/rifter25.jpg',
    summary: 'Optional rules and tables that expand on the Golem as a monster and villain, presenting unique features and characteristics, bizarre traits and self-awareness.',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['rules', 'monster']
  },
  {
    id: '206',
    article: 'The Fires of Korath, Part One',
    author: ['Michael Long'],
    artist: ['Kent Burles', 'Michael Long', 'Wayne Smith'],
    page: '45-66',
    issue: rifter25,
    issueTitle: 'The Rifter #25',
    image: './images/rifter25.jpg',
    summary: 'An epic fantasy adventure involving the dreaded Old Ones, ancient artifacts, dragons, gods, and intrigue. Best suited for mid-to-high-range characters with the hearts of lions and the cunning of vipers.',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['adventure', 'monster']
  },
  {
    id: '207',
    article: 'Enthralled (Psionics)',
    author: ['Levi Johnstone'],
    artist: ['Mark Dudley', 'Brandon C. Clark'],
    page: '67-82',
    issue: rifter25,
    issueTitle: 'The Rifter #25',
    image: './images/rifter25.jpg',
    summary: 'Several new psionic powers and psychic character classes for the Rifts Earth setting. Shared Perception, Hypnotic Control, Enhance Reflexes, Alter Memory. New O.C.C.s: Enthraller, Intuitive Warrior, Kinetic Master and Telepath.',
    games: ['Rifts'],
    official: 'No',
    tags: ['occ', 'pcc', 'psionic', 'P.C.C.']
  },
  {
    id: '208',
    article: 'Phage World',
    author: ['Mark Hall'],
    artist: ['Apollo Okamura'],
    page: '89-91',
    issue: rifter25,
    issueTitle: 'The Rifter #25',
    image: './images/rifter25.jpg',
    summary: 'Psi-Stalkers turned into vampires by a mysterious virus.',
    games: ['Rifts'],
    official: 'No',
    tags: ['story', 'monster']
  },
  {
    id: '209',
    article: 'Questions and Answers',
    author: ['Rodney Stott', 'Shawn Merrow', 'Kevin Siembieda'],
    artist: [''],
    page: '92-93',
    issue: rifter25,
    issueTitle: 'The Rifter #25',
    image: './images/rifter25.jpg',
    summary: "A diverse selection of questions about magic, then diving into Fantasy conversions for 'Lost Magic' and the Yin-Sloth Jungles.",
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['magic', 'qa', 'rules', 'tips', 'spell']
  },
  {
    id: '210',
    article: 'Fleas',
    author: ['Joseph Larsen'],
    artist: ['Apollo Okamura'],
    page: '14-18',
    issue: rifter26,
    issueTitle: 'The Rifter #26',
    image: './images/rifter26.jpg',
    summary: "A new kind of alien insect and danger, but one that can be used against the invading Bugs. Adventure ideas, the Fleas, some new 'bug bombs', and other good stuff.",
    games: ['Systems Failure'],
    official: 'No',
    tags: ['adventure', 'monster', 'weapon']
  },
  {
    id: '211',
    article: 'Construct Animation Magic',
    author: ['Evan Cooney'],
    artist: ['Brian Manning', 'Allen Manning'],
    page: '31-39',
    issue: rifter26,
    issueTitle: 'The Rifter #26',
    image: './images/rifter26.jpg',
    summary: 'Optional rules and clever ideas for a new type of magic that dates back to the early days of the Elf-Dwarf War - animating inanimate objects like a mystical puppet master. This practitioner of magic is known as the Animator, and how his/her powers and creations work is all laid out.',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['rules', 'magic', 'spell', 'occ', 'O.C.C.']
  },
  {
    id: '212',
    article: 'Unknown Depths',
    author: ['Andrew Rusling'],
    artist: ['Apollo Okamura'],
    page: '40-46',
    issue: rifter26,
    issueTitle: 'The Rifter #26',
    image: './images/rifter26.jpg',
    summary: 'An in-depth look at the misunderstood Lizard men of the Palladium world. This race of tribal people inhabits the swamps and woodlands of the Yin-Sloth Jungles and are considered to be primitive savages by the rest of the world. Learn about how their reptilian minds and society really work.',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['monster', 'location']
  },
  {
    id: '213',
    article: 'The Fires of Korath, Part Two',
    author: ['Michael Long'],
    artist: ['Kent Burles', 'Michael Long', 'Wayne Smith'],
    page: '47-64',
    issue: rifter26,
    issueTitle: 'The Rifter #26',
    image: './images/rifter26.jpg',
    summary: 'The conclusion to this epic adventure. More mystery, intrigue and treachery involving the Old Ones, dark gods and insane cultists. Perils include evil wizards, dark priests, necromancers, thieves, goblins, serpent rats and the ultimate villain: Minoth Soulbreaker, among others.',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['adventure', 'npc']
  },
  {
    id: '214',
    article: 'Mutants of Rifts Earth',
    author: ['Jason Richards'],
    artist: ['Brian Manning', 'Allen Manning'],
    page: '66-82',
    issue: rifter26,
    issueTitle: 'The Rifter #26',
    image: './images/rifter26.jpg',
    summary: 'New ideas and approaches for a host of different mutants living on Rifts Earth. Optional rules enable players to create Mutants of all kinds - Super Mutants, Psychic Mutants, Mutant Animals, and Mutant Humans. Includes Mutant Characteristics, Mutant Abilities, Mutoids, some notable NPCs, and ideas for incorporating them into your gams.',
    games: ['Rifts'],
    official: 'No',
    tags: ['rules', 'npc', 'mutant']
  },
  {
    id: '215',
    article: 'Lord of the Deep',
    author: ['Chris Fox'],
    artist: [''],
    page: '83-85',
    issue: rifter26,
    issueTitle: 'The Rifter #26',
    image: './images/rifter26.jpg',
    summary: "A nice short story involving the legendary being known only as the 'Lord of the Deep.'",
    games: ['Rifts'],
    official: 'No',
    tags: ['story']
  },
  {
    id: '216',
    article: 'Britain in Chaos',
    author: ['Alex Tulloch'],
    artist: ['Apollo Okamura'],
    page: '16-28',
    issue: rifter27,
    issueTitle: 'The Rifter #27',
    image: './images/rifter27.jpg',
    summary: 'Life in Britain after the Great Cataclysm. Great optional source material for Rifts Chaos Earth. Includes an overview of the Cataclysm, a handful of new O.C.C.s and some unique equipment of the SFE.',
    games: ['Chaos Earth'],
    official: 'No',
    tags: ['occ', 'equipment']
  },
  {
    id: '217',
    article: 'Running a Character Driven Mercenary Campaign',
    author: ['Ian Schroen'],
    artist: ['Freddie Williams II'],
    page: '30-38',
    issue: rifter27,
    issueTitle: 'The Rifter #27',
    image: './images/rifter27.jpg',
    summary: 'A guide for running a Rifts mercenary campaign.',
    games: ['Rifts'],
    official: 'No',
    tags: ['tools', 'gm', 'tips']
  },
  {
    id: '218',
    article: 'The Palladium Orient',
    author: ['Greg Diaczyk'],
    artist: ['Kent Burles'],
    page: '39-56',
    issue: rifter27,
    issueTitle: 'The Rifter #27',
    image: './images/rifter27.jpg',
    summary: 'A fun look at bringing the Orient to the Palladium Fantasy world. Includes four O.C.C.s, magic weapons, and adventure ideas.',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['occ', 'weapon', 'adventure', 'magic', 'weapon', 'location']
  },
  {
    id: '219',
    article: 'The Pros and Cons of Studying Magic',
    author: ['Ed Woodward III'],
    artist: ['Ed Woodward III'],
    page: '57-63',
    issue: rifter27,
    issueTitle: 'The Rifter #27',
    image: './images/rifter27.jpg',
    summary: 'A look at handling magic in the Nightbane world setting. A variety of random tables full of good ideas.',
    games: ['Nightbane'],
    official: 'No',
    tags: ['magic', 'tips']
  },
  {
    id: '220',
    article: 'The Software Valley War',
    author: ['Todd Yoho'],
    artist: ['Brian Manning', 'Allen Manning'],
    page: '64-75',
    issue: rifter27,
    issueTitle: 'The Rifter #27',
    image: './images/rifter27.jpg',
    summary: 'Optional setting and four adventures for Heroes Unlimited. A corrupt corporation, hired guns, and intrigue await.',
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['adventure']
  },
  {
    id: '221',
    article: 'Fallen Angels',
    author: ['K.G. Carlson'],
    artist: ['Brian Manning', 'Allen Manning'],
    page: '76-89',
    issue: rifter27,
    issueTitle: 'The Rifter #27',
    image: './images/rifter27.jpg',
    summary: 'A short story that is sure to give Game Masters ideas for their own games.',
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['story']
  },
  {
    id: '222',
    article: 'The Soul Tree',
    author: ['Joseph Larsen'],
    artist: ['Kent Burles'],
    page: '17-22',
    issue: rifter28,
    issueTitle: 'The Rifter #28',
    image: './images/rifter28.jpg',
    summary: 'Source material and stats for the Soul Tree, an ethereal tree that thrives in graveyards, devouring the knowledge and memories of the dead, and tormenting and corrupting the living. Includes pacts with the tree, evil fruit, Protecting Wraiths, Spy Minions, Poltergeists and Seeds',
    games: ['Beyond the Supernatural'],
    official: 'No',
    tags: ['magic', 'monster', 'undead']
  },
  {
    id: '223',
    article: 'Power Up the Vote',
    author: ['Brandon Aten'],
    artist: ['Taylor White'],
    page: '23-33',
    issue: rifter28,
    issueTitle: 'The Rifter #28',
    image: './images/rifter28.jpg',
    summary: 'A piece on superhumans running for office. Outlines how to start political platforms, campaign finances, running mates, campaign workers, follow through, the public eye, some appropriate new skills, a couple of candidates, and tables for rolling up a Political Party.',
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['skill', 'rules', 'npc']
  },
  {
    id: '224',
    article: "The Arrows of Ith'arian",
    author: ['Edwin Emmer'],
    artist: ['Kent Burles'],
    page: '34-40',
    issue: rifter28,
    issueTitle: 'The Rifter #28',
    image: './images/rifter28.jpg',
    summary: 'Eight different Rune Arrows complete with curses, history, and dazzling powers. Some ancient spells and a monster from the time of the Elf-Dwarf Wars.',
    games: ['Rifts'],
    official: 'No',
    tags: ['weapon', 'magic', 'rune']
  },
  {
    id: '225',
    article: 'The Geofront',
    author: ['Todd Yoho', 'Kevin Siembieda'],
    artist: ['Brandon C. Clark'],
    page: '41-54',
    issue: rifter28,
    issueTitle: 'The Rifter #28',
    image: './images/rifter28.jpg',
    summary: 'What got cut out of Rifts China 2. An expanded history of the Geofront - the best chances humans have for defeating the Yama Kings and reclaiming even part of China for humankind. Geo-Scout O.C.C., important NPCs.',
    games: ['Rifts'],
    official: 'Yes',
    tags: ['occ', 'npc']
  },
  {
    id: '226',
    article: 'Creatures of the Horror Forest',
    author: ['Todd Yoho'],
    artist: ['Apollo Okamura', 'Kent Burles'],
    page: '55-64',
    issue: rifter28,
    issueTitle: 'The Rifter #28',
    image: './images/rifter28.jpg',
    summary: 'Complete overview of Dinosaur Swamp. New O.C.C.s, Eco-Magic, and more. Civil War Specters known as the Wraith Brigade, plus Wraith Soldiers, Carnosuchids, Lepidosaurs, Razormouth Frogs, and Gruesome Tarbids.',
    games: ['Rifts'],
    official: 'Yes',
    tags: ['occ', 'magic', 'location', 'monster', 'spell']
  },
  {
    id: '227',
    article: 'The Janissary Project',
    author: ['Erick Fackler'],
    artist: ['Brian Manning', 'Allen Manning'],
    page: '65-81',
    issue: rifter28,
    issueTitle: 'The Rifter #28',
    image: './images/rifter28.jpg',
    summary: 'Takes us back to 104 P.A. to reveal an incident involving the nefarious Doctor Desmond Bradford and the notorious Lone Star Complex in something called The Janissary Project. Genetic experimentation, super-soldiers, madness and folly.',
    games: ['Rifts'],
    official: 'No',
    tags: ['npc', 'coalition', 'cs']
  },
  {
    id: '228',
    article: 'Shadow Realms',
    author: ['Carl Gleba'],
    artist: ['Apollo Okamura'],
    page: '82-92',
    issue: rifter28,
    issueTitle: 'The Rifter #28',
    image: './images/rifter28.jpg',
    summary: 'An exploration into the realm and magic of the Shadow Beasts. The Shadow Forest, The Shadow Fortress, Lord Gray, Shadow Lord R.C.C., and more.',
    games: ['Rifts'],
    official: 'No',
    tags: ['rcc', 'magic', 'spell', 'monster', 'npc']
  },
  {
    id: '229',
    article: 'The Magic of War',
    author: ['Kevin Christensen'],
    artist: ['Kent Burles'],
    page: '13-42',
    issue: rifter29,
    issueTitle: 'The Rifter #29',
    image: './images/rifter29.jpg',
    summary: 'A comprehensive article on magic designed specifically with war in mind. Arken Warrior O.C.C., spells.',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['occ', 'magic', 'spell']
  },
  {
    id: '230',
    article: 'New Types of Mutants',
    author: ['Caleb Goodson'],
    artist: ['Apollo Okamura'],
    page: '43-59',
    issue: rifter29,
    issueTitle: 'The Rifter #29',
    image: './images/rifter29.jpg',
    summary: 'A variety of strange and twisted mutants. Arachnids, Annelid Mutants, Gastropods, and ocean critters. Genetic Chimeras, Throwbacks and Purebreds.',
    games: ['After the Bomb', 'Heroes Unlimited'],
    official: 'No',
    tags: ['mutant']
  },
  {
    id: '231',
    article: "Fractures: A sequel to 'Fallen Angels'",
    author: ['Brian Manning', 'Allen Manning'],
    artist: ['K.G. Carlson'],
    page: '60-73',
    issue: rifter29,
    issueTitle: 'The Rifter #29',
    image: './images/rifter29.jpg',
    summary: "A sequel to 'Fallen Angels.' Starts with the funeral of a friend and spirals into trouble, turmoil, and emotional discord.",
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['story']
  },
  {
    id: '232',
    article: 'Crime and Punishment in Rifts Japan',
    author: ['Dan Felkins'],
    artist: ['Brian Manning', 'Allen Manning'],
    page: '74-92',
    issue: rifter29,
    issueTitle: 'The Rifter #29',
    image: './images/rifter29.jpg',
    summary: "The seedy underworld of Yakuza and Rifts Japan's criminal organizations. Includes background info, Splugorth involvement, the use if Juicer and M.O.M./Crazies technology, current clans and operations, notable street gangs, magical Dragon Tattoos, and more. Yakuza Clansman O.C.C., Cyber-Ninja O.C.C., Police Officer O.C.C., Ninja Juicer variants, New equipment, Kittani technology, robot drones, and more.",
    games: ['Rifts'],
    official: 'No',
    tags: ['location', 'mom', 'occ', 'equipment', 'magic', 'tattoo']
  },
  {
    id: '233',
    article: 'A Cut Above',
    author: ['Levi Johnstone', 'John C. Philpott'],
    artist: ['Kent Burles'],
    page: '16-46',
    issue: rifter30,
    issueTitle: 'The Rifter #30',
    image: './images/rifter30.jpg',
    summary: "Optional rules and rules modifications for Palladium's Megaversal Game System.",
    games: ['Any'],
    official: 'No',
    tags: ['rules', 'gm', 'tips', 'skill', 'magic', 'npc', 'combat', 'martial', 'weapon', 'armor']
  },
  {
    id: '234',
    article: 'New War Mounts',
    author: ['Chris Kluge'],
    artist: ['Drunken Style Studio'],
    page: '47-67',
    issue: rifter30,
    issueTitle: 'The Rifter #30',
    image: './images/rifter30.jpg',
    summary: 'A host of very cool and fun War Mounts for the Splicers RPG, including the Abomination, Black Talon War Hawk, Tunnel Rats, and others. Hook, line and sinker adventures.',
    games: ['Splicers'],
    official: 'No',
    tags: ['adventure', 'monster']
  },
  {
    id: '235',
    article: 'Blue Zone Demons',
    author: ['Josh Sinsapaugh'],
    artist: ['Apollo Okamura'],
    page: '68-82',
    issue: rifter30,
    issueTitle: 'The Rifter #30',
    image: './images/rifter30.jpg',
    summary: 'A horde of new, compelling demons to add to your Chaos Earth or Rifts campaigns.',
    games: ['Chaos Earth', 'Rifts'],
    official: 'No',
    tags: ['monster']
  },
  {
    id: '236',
    article: 'Candle Magic',
    author: ['Samson Blackwell', 'Josh Blackwell'],
    artist: ['Brian Manning', 'Allen Manning'],
    page: '83-90',
    issue: rifter30,
    issueTitle: 'The Rifter #30',
    image: './images/rifter30.jpg',
    summary: 'A new and strange type of magic.',
    games: ['Rifts'],
    official: 'No',
    tags: ['magic', 'spell']
  },
  {
    id: '237',
    article: 'Rooms with a Skew',
    author: ['K.G. Carlson'],
    artist: ['Brian Manning', 'Allen Manning'],
    page: '16-22',
    issue: rifter31,
    issueTitle: 'The Rifter #31',
    image: './images/rifter31.jpg',
    summary: 'Mutant, killer plants, weird and dangerous animals, space aliens, and all kinds of trouble are unleashed by the Dread Micro-Wizards of Chaos.',
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['monster', 'mutant']
  },
  {
    id: '238',
    article: 'A Shadow from the Past - The Quest for Castlerake',
    author: ['Edwin Emmer'],
    artist: ['Kent Burles'],
    page: '23-59',
    issue: rifter31,
    issueTitle: 'The Rifter #31',
    image: './images/rifter31.jpg',
    summary: 'A fantasy adventure inspired by the legendary rune weapon known as Castlerake. Part one of an epic quest to retrieve the scatter and magical pieces of this great rune weapon.',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['adventure', 'rune', 'weapon']
  },
  {
    id: '239',
    article: 'A Komplex Problem',
    author: ['Brandon Aten', 'Taylor White'],
    artist: ['Apollo Okamura'],
    page: '61-78',
    issue: rifter31,
    issueTitle: 'The Rifter #31',
    image: './images/rifter31.jpg',
    summary: 'A story of intrigue, secrets, and conspiracy. The discovery of a secret military base where Gargoyles, Brodkil, and other monster races are captures, tortured, and cruelly experimented upon. A handful of NPCs, the Triax Research Scientist O.C.C., a few new Triax weapons, and the X-5001 Devastator Mk II.',
    games: ['Rifts'],
    official: 'No',
    tags: ['story', 'occ', 'weapon', 'triax', 'monster', 'npc']
  },
  {
    id: '240',
    article: 'Sunhammer Consolidated Freightways, Ltd.',
    author: ['Jason Marker'],
    artist: ['Brian Manning', 'Allen Manning'],
    page: '79-89',
    issue: rifter31,
    issueTitle: 'The Rifter #31',
    image: './images/rifter31.jpg',
    summary: 'Details an independent trans-galactic freight company in the Three Galaxies, some of their ships and notable crew members, and a few villains.',
    games: ['Phase World'],
    official: 'No',
    tags: ['npc']
  },
  {
    id: '241',
    article: 'The Squatter',
    author: ['Steven Dawes'],
    artist: ['Michael Dubisch'],
    page: '14-19',
    issue: rifter32,
    issueTitle: 'The Rifter #32',
    image: './images/rifter32.jpg',
    summary: "An adventure for Beyond the Supernatural based one one of the new creatures from the BTS-2 sourcebook 'Tome Grotesque.'",
    games: ['Beyond the Supernatural'],
    official: 'No',
    tags: ['adventure']
  },
  {
    id: '242',
    article: 'The Wastes',
    author: ['Chris Kluge'],
    artist: ['Brian Manning', 'Allen Manning'],
    page: '20-33',
    issue: rifter32,
    issueTitle: 'The Rifter #32',
    image: './images/rifter32.jpg',
    summary: 'Wicked and sinister O.C.C.s, beasts, and trouble for Splicers. The Deliveryman is a Splicer O.C.C. who wanders the Wastes and battles a trio of Waste Crawlers. Includes special Slicer bio-equipment like Stealth Sheets, Second Skin, and the Extractor, as well as an adventure.',
    games: ['Splicers'],
    official: 'No',
    tags: ['occ', 'adventure']
  },
  {
    id: '243',
    article: 'A Shadow from the Past - The Quest for Castlerake - Part Two',
    author: ['Edwin Emmer'],
    artist: ['Kent Burles'],
    page: '34-69',
    issue: rifter32,
    issueTitle: 'The Rifter #32',
    image: './images/rifter32.jpg',
    summary: 'The conclusion of this epic fantasy adventure inspired by the legendary rune weapon known as Castlerake. Part Two takes place in the Land of the Damned where our heroes must battle a host of undead, vampires. Slag Hags, Lava Goblins, and other hideous creatures to defeat the evil arch-mage, Vortan the Undying.',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['adventure', 'npc', 'monster', 'rune', 'weapon']
  },
  {
    id: '244',
    article: 'Mega-Steel Chef - Cooking for Rifts',
    author: ['Erin Lindsey'],
    artist: ['Brian Manning', 'Allen Manning', 'Erin Lindsey'],
    page: '70-86',
    issue: rifter32,
    issueTitle: 'The Rifter #32',
    image: './images/rifter32.jpg',
    summary: 'A delightful menu of fun and useful rules and recipes for preparing exotic Mega-Damage cuisine. Includes weird side effects, preparing the exotic, magic meals, M.D. and TW tools of the trade, three Chef O.C.C.s, and more.',
    games: ['Rifts'],
    official: 'No',
    tags: ['rules', 'technowizard', 'occ', 'tw']
  },
  {
    id: '245',
    article: 'The Legacy of Blood',
    author: ['Evan Cooney'],
    artist: ['Kent Burles'],
    page: '17-28',
    issue: rifter33,
    issueTitle: 'The Rifter #33',
    image: './images/rifter33.jpg',
    summary: 'A new O.C.C., a brewing war that could threaten the entire Palladium world, ancient weapons, magic items, and history that date back to the Elf-Dwarf War. Also, Spells of Legend from the forgotten mystic arts of Apocalypse Magic.',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['occ', 'weapon', 'magic', 'spell']
  },
  {
    id: '246',
    article: 'S.C.R.E.T. Revisited and Revised',
    author: ['Glen A. Evans'],
    artist: ['Drunken Style Studio'],
    page: '29-49',
    issue: rifter33,
    issueTitle: 'The Rifter #33',
    image: './images/rifter33.jpg',
    summary: "Learn about S.C.R.E.T.'s origins and parent agency, G.I.G.M.A. Includes experimental weapons, vehicles, aircraft and superhuman holding facilities, the typical S.C.R.E.T. agent and a quintet of elemental based villains (and the mysterious David Slave).",
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['scret', 'gigma', 'weapon', 'vehicle', 'npc']
  },
  {
    id: '247',
    article: 'D-Bees of the Eastern Wilds - New Races and R.C.C.s',
    author: ['Josh Sinsapaugh'],
    artist: ['Apollo Okamura'],
    page: '50-67',
    issue: rifter33,
    issueTitle: 'The Rifter #33',
    image: './images/rifter33.jpg',
    summary: 'Includes the Acisse Tribal Hunter, Adna Nomad, Bayou Ursine, the strange and mysterious Forest Wardens, Idie Swamp Men, and the Two-Horned Techno-Men.',
    games: ['Rifts'],
    official: 'No',
    tags: ['dbee', 'rcc', 'location']
  },
  {
    id: '248',
    article: 'Air Combat',
    author: ['Edward A. May'],
    artist: ['Brian Manning', 'Allen Manning', 'Kevin Long'],
    page: '68-89',
    issue: rifter33,
    issueTitle: 'The Rifter #33',
    image: './images/rifter33.jpg',
    summary: 'A massive set of optional rules and things to consider involving air combat. Includes piloting rules, mishap tables, damage tables, formation flying, weather and environmental modifiers, airstrips, air bases, repairs and maintenance, air-to-ground attacks, air-to-air combat, dogfights, and much more.',
    games: ['Rifts'],
    official: 'No',
    tags: ['rules', 'combat']
  },
  {
    id: '249',
    article: 'The Skin Thief',
    author: ['Steven Dawes'],
    artist: ['Nick Bradshaw'],
    page: '14-18',
    issue: rifter34,
    issueTitle: 'The Rifter #34',
    image: './images/rifter34.jpg',
    summary: 'A new monster for Beyond the Supernatural.',
    games: ['Beyond the Supernatural'],
    official: 'No',
    tags: ['monster']
  },
  {
    id: '250',
    article: 'Troglodytes',
    author: ['Mark Hall'],
    artist: ['Kevin Siembieda'],
    page: '19-26',
    issue: rifter34,
    issueTitle: 'The Rifter #34',
    image: './images/rifter34.jpg',
    summary: 'A detailed look at the often-misunderstood race known as Troglodytes, their appearance, society, weapons, warrens, technology, crops, digging speed, and more.',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['race', 'monster']
  },
  {
    id: '251',
    article: 'The Star of Horus, Part One',
    author: ['Aaron Corley', 'Allen Gardner'],
    artist: ['Brian Manning', 'Allen Manning'],
    page: '27-39',
    issue: rifter34,
    issueTitle: 'The Rifter #34',
    image: './images/rifter34.jpg',
    summary: "An exciting tale of adventure, magic and wonderment in the Palladium Fantasy setting. Tentacled monsters, flying ships and islands floating in the air. It's all part of the quest for the Star of Horus, an ancient work of Dwarven jewelry lost for many thousands of years.",
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['adventure', 'story']
  },
  {
    id: '252',
    article: 'The Maqui Knouldum',
    author: ['Samson Blackwell'],
    artist: ['Nick Bradshaw'],
    page: '40-46',
    issue: rifter34,
    issueTitle: 'The Rifter #34',
    image: './images/rifter34.jpg',
    summary: 'A new, weird race of aliens from the Three Galaxies known as the Maqui Knouldum. They call themselves the Travelers because they are a dimension-spanning race who love to explore. History, motives and R.C.C.s.',
    games: ['Phase World'],
    official: 'No',
    tags: ['rcc']
  },
  {
    id: '253',
    article: 'Galactic Tracer Starship Creation',
    author: ['Eric Fackler'],
    artist: ['Nick Bradshaw'],
    page: '47-56',
    issue: rifter34,
    issueTitle: 'The Rifter #34',
    image: './images/rifter34.jpg',
    summary: 'A point-based creation system for making personal spacecraft for the Galactic Tracer O.C.C. from the pages of Phase World. Categories for creation include Ship Type, Origin, Age, Manufacturer, Weapons, Sensors and more.',
    games: ['Phase World'],
    official: 'No',
    tags: ['occ', 'weapon', 'rules']
  },
  {
    id: '254',
    article: 'CS Operation Holy House',
    author: ['Kevin Siembieda', 'Jason Richards'],
    artist: ['Apollo Okamura', 'Chuck Walton'],
    page: '57-72',
    issue: rifter34,
    issueTitle: 'The Rifter #34',
    image: './images/rifter34.jpg',
    summary: 'A CS mission to assess the real level of danger represented by the undead under the auspices of Operation Holy House, near Arzno. General Loni Kashbrook has been put in charge to study the situation and develop counter-measures to the vampire threat. Includes background on the Operation, the CS Vampire Hunter M.O.S., and Coalition vampire hunting teams of note.',
    games: ['Rifts'],
    official: 'Yes',
    tags: ['coalition', 'cs', 'undead', 'mos']
  },
  {
    id: '255',
    article: 'Mad Machiavelli',
    author: ['Jason Richards'],
    artist: ['Kent Burles'],
    page: '73-81',
    issue: rifter34,
    issueTitle: 'The Rifter #34',
    image: './images/rifter34.jpg',
    summary: "Discover the secrets of Arzno's legendary Techno-Wizard genius, Eman Machiavelli. Includes stats on Mad Machiavelli and his incredible 'Think Tank', adventure notes, and a handful of other TW devices.",
    games: ['Rifts'],
    official: 'Yes',
    tags: ['tw', 'technowizard', 'npc', 'adventure']
  },
  {
    id: '256',
    article: 'On Patrol',
    author: ['Paul Carr'],
    artist: [''],
    page: '82-84',
    issue: rifter34,
    issueTitle: 'The Rifter #34',
    image: './images/rifter34.jpg',
    summary: 'A handful of Hook, Line, and Sinker adventures involving Coalition soldiers and other menaces for action in Rifts North America.',
    games: ['Rifts'],
    official: 'No',
    tags: ['adventure', 'cs', 'coalition']
  },
  {
    id: '257',
    article: 'Tabletop Terrain',
    author: ['Leslie Furness'],
    artist: [''],
    page: '91-97',
    issue: rifter34,
    issueTitle: 'The Rifter #34',
    image: './images/rifter34.jpg',
    summary: 'Tips, diagrams and instructions on how to make tabletop terrain settings to bring your role-playing adventures to 3-D life.',
    games: ['Any'],
    official: 'No',
    tags: ['gm', 'tips']
  },
  {
    id: '258',
    article: 'Swimsuit Spectacular: Opening Illustration',
    author: [''],
    artist: ['Wayne Breaux Jr.', 'Scott Johnson'],
    page: '1',
    issue: rifter35,
    issueTitle: 'The Rifter #35',
    image: './images/rifter35.jpg',
    summary: 'A reprint',
    games: ['Any'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '259',
    article: 'Swimsuit Spectacular',
    author: [''],
    artist: ['David Martin'],
    page: '21',
    issue: rifter35,
    issueTitle: 'The Rifter #35',
    image: './images/rifter35.jpg',
    summary: "One of the Palladium staff's favorites. Could depict a moment from Palladium Fantasy, Rifts, or the Three Galaxies.",
    games: ['Palladium Fantasy', 'Rifts', 'Phase World'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '260',
    article: 'Swimsuit Spectacular',
    author: [''],
    artist: ['Larry Elmore'],
    page: '22',
    issue: rifter35,
    issueTitle: 'The Rifter #35',
    image: './images/rifter35.jpg',
    summary: "Represents After the Bomb and everybody's favorite mutant animals.",
    games: ['After the Bomb'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '261',
    article: 'Swimsuit Spectacular',
    author: [''],
    artist: ['Jeffrey Russell'],
    page: '23',
    issue: rifter35,
    issueTitle: 'The Rifter #35',
    image: './images/rifter35.jpg',
    summary: 'A Ley Line Walker',
    games: ['Rifts'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '262',
    article: 'Swimsuit Spectacular',
    author: [''],
    artist: ['Comfort Deborah Love'],
    page: '24',
    issue: rifter35,
    issueTitle: 'The Rifter #35',
    image: './images/rifter35.jpg',
    summary: 'An undead maiden having fun with a human visitor at one of the Blood Pools in the Vampire Kingdoms.',
    games: ['Rifts'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '263',
    article: 'Swimsuit Spectacular',
    author: [''],
    artist: ['Allen Manning'],
    page: '25',
    issue: rifter35,
    issueTitle: 'The Rifter #35',
    image: './images/rifter35.jpg',
    summary: 'A lovely Asian master of martial arts.',
    games: ['Ninjas and Superspies'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '265',
    article: 'Swimsuit Spectacular',
    author: [''],
    artist: ['Ramon Perez'],
    page: '26',
    issue: rifter35,
    issueTitle: 'The Rifter #35',
    image: './images/rifter35.jpg',
    summary: 'Fun at the beach with our favorite cadre of adventurers from his Rifts comic strip.',
    games: ['Rifts'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '266',
    article: 'Swimsuit Spectacular',
    author: [''],
    artist: ['Christopher Bourassa'],
    page: '27',
    issue: rifter35,
    issueTitle: 'The Rifter #35',
    image: './images/rifter35.jpg',
    summary: "A friendly Coalition maiden standing guard at a 'Humans Only' CS beach.",
    games: ['Rifts'],
    official: 'No',
    tags: ['swimsuit', 'coalition', 'cs']
  },
  {
    id: '267',
    article: 'Swimsuit Spectacular',
    author: [''],
    artist: ['Nick Bradshaw'],
    page: '28',
    issue: rifter35,
    issueTitle: 'The Rifter #35',
    image: './images/rifter35.jpg',
    summary: 'A Sphinx prowling the beach to pick up hot babes.',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '268',
    article: 'Swimsuit Spectacular',
    author: [''],
    artist: ['Freddie Williams II'],
    page: '29',
    issue: rifter35,
    issueTitle: 'The Rifter #35',
    image: './images/rifter35.jpg',
    summary: 'A hot momma from Dyval (or is it Hades).',
    games: ['Rifts'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '269',
    article: 'Swimsuit Spectacular',
    author: [''],
    artist: ['Michael Wilson'],
    page: '30',
    issue: rifter35,
    issueTitle: 'The Rifter #35',
    image: './images/rifter35.jpg',
    summary: 'A jungle maiden.',
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '270',
    article: 'Swimsuit Spectacular',
    author: [''],
    artist: ['Michael Dubisch'],
    page: '31',
    issue: rifter35,
    issueTitle: 'The Rifter #35',
    image: './images/rifter35.jpg',
    summary: 'The supernatural horrors from Beyond the Supernatural even haunt the dark corners of our beaches and seas.',
    games: ['Beyond the Supernatural'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '271',
    article: 'Swimsuit Spectacular',
    author: [''],
    artist: ['Jeff Easley'],
    page: '32',
    issue: rifter35,
    issueTitle: 'The Rifter #35',
    image: './images/rifter35.jpg',
    summary: 'A playful succubus from the pits of Hades.',
    games: ['Palladium Fantasy', 'Beyond the Supernatural'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '272',
    article: 'Swimsuit Spectacular',
    author: [''],
    artist: ['Dirk Johnson'],
    page: '33',
    issue: rifter35,
    issueTitle: 'The Rifter #35',
    image: './images/rifter35.jpg',
    summary: 'Dirk Johnson is an old artist buddy. His work can be seen in RDF Accelerated Training Program sourcebook.',
    games: ['Robotech'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '273',
    article: 'Swimsuit Spectacular',
    author: [''],
    artist: ['Mark Evans'],
    page: '34',
    issue: rifter35,
    issueTitle: 'The Rifter #35',
    image: './images/rifter35.jpg',
    summary: 'Depicts a Coalition Military Specialist with a specialty in slaying demons.',
    games: ['Rifts'],
    official: 'No',
    tags: ['cs', 'coalition', 'swimsuit']
  },
  {
    id: '274',
    article: 'Swimsuit Spectacular',
    author: [''],
    artist: ['Adam Withers'],
    page: '35',
    issue: rifter35,
    issueTitle: 'The Rifter #35',
    image: './images/rifter35.jpg',
    summary: 'A super-hottie and friends.',
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '275',
    article: 'Swimsuit Spectacular',
    author: [''],
    artist: ['Mark Dudley'],
    page: '36',
    issue: rifter35,
    issueTitle: 'The Rifter #35',
    image: './images/rifter35.jpg',
    summary: 'A dynamic illustration of a robot pilot out for a little sun and relations on the beach.',
    games: ['Rifts'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '276',
    article: 'Swimsuit Spectacular',
    author: [''],
    artist: ['Chris Bourassa'],
    page: '37',
    issue: rifter35,
    issueTitle: 'The Rifter #35',
    image: './images/rifter35.jpg',
    summary: "A little darlin' for all you RECON fans.",
    games: ['RECON'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '277',
    article: 'Swimsuit Spectacular',
    author: [''],
    artist: ['John Zeleznik'],
    page: '38-39',
    issue: rifter35,
    issueTitle: 'The Rifter #35',
    image: './images/rifter35.jpg',
    summary: 'A depiction of Tera, the pinup girl of the Coalition Army.',
    games: ['Rifts'],
    official: 'No',
    tags: ['swimsuit', 'coalition', 'cs']
  },
  {
    id: '278',
    article: 'Swimsuit Spectacular',
    author: [''],
    artist: ['Larry Elmore'],
    page: '40',
    issue: rifter35,
    issueTitle: 'The Rifter #35',
    image: './images/rifter35.jpg',
    summary: 'A bathing beauty.',
    games: ['Palladium Fantasy', 'Rifts'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '279',
    article: 'Swimsuit Spectacular',
    author: [''],
    artist: ['Kevin Siembieda'],
    page: '41',
    issue: rifter35,
    issueTitle: 'The Rifter #35',
    image: './images/rifter35.jpg',
    summary: 'Kevin Siembieda at a tropical resort - Michigan.',
    games: ['Any'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '280',
    article: 'Swimsuit Spectacular',
    author: [''],
    artist: ['Erin Lindsey'],
    page: '42',
    issue: rifter35,
    issueTitle: 'The Rifter #35',
    image: './images/rifter35.jpg',
    summary: 'A pair of exotic beauties, one bionic and the other a ninja assassin.',
    games: ['Ninjas and Superspies', 'Heroes Unlimited', 'Rifts'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '281',
    article: 'Swimsuit Spectacular',
    author: [''],
    artist: ['Brian Manning'],
    page: '43',
    issue: rifter35,
    issueTitle: 'The Rifter #35',
    image: './images/rifter35.jpg',
    summary: "A super-heroine chillin' at the beach, using her super abilities to take down a pair of bad guys.",
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '282',
    article: 'Swimsuit Spectacular',
    author: [''],
    artist: ['Ben Rodriguez'],
    page: '44',
    issue: rifter35,
    issueTitle: 'The Rifter #35',
    image: './images/rifter35.jpg',
    summary: 'A Splicer pilot stepping out of her organic, Splicer, bio-armor for some fun at the beach.',
    games: ['Splicers'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '283',
    article: 'Swimsuit Spectacular',
    author: [''],
    artist: ['Wayne Smith'],
    page: '45',
    issue: rifter35,
    issueTitle: 'The Rifter #35',
    image: './images/rifter35.jpg',
    summary: 'Wayne Smith going for the glamour-shot.',
    games: ['Any'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '284',
    article: 'Swimsuit Spectacular',
    author: [''],
    artist: ['Kent Burles'],
    page: '46',
    issue: rifter35,
    issueTitle: 'The Rifter #35',
    image: './images/rifter35.jpg',
    summary: 'Cosmic babe, waves and a living surf-board.',
    games: ['Any'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '285',
    article: 'Swimsuit Spectacular',
    author: [''],
    artist: ['Alex Marciniszyn'],
    page: '47',
    issue: rifter35,
    issueTitle: 'The Rifter #35',
    image: './images/rifter35.jpg',
    summary: 'Palladium Editor Alex Marciniszyn mugging for the camera with a muscleman pose.',
    games: ['Any'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '286',
    article: 'Swimsuit Spectacular',
    author: [''],
    artist: ['Bill Bryan'],
    page: '48',
    issue: rifter35,
    issueTitle: 'The Rifter #35',
    image: './images/rifter35.jpg',
    summary: "Bill's idea of a 'fantasy' illustration.",
    games: ['Any'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '287',
    article: 'Swimsuit Spectacular',
    author: [''],
    artist: ['Julius Rosenstein'],
    page: '49',
    issue: rifter35,
    issueTitle: 'The Rifter #35',
    image: './images/rifter35.jpg',
    summary: 'Julius Rosenstein in a traditional gi and samurai sword.',
    games: ['Any'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '289',
    article: 'Swimsuit Spectacular',
    author: [''],
    artist: ['Wayne Breaux Jr.'],
    page: '50',
    issue: rifter35,
    issueTitle: 'The Rifter #35',
    image: './images/rifter35.jpg',
    summary: 'Depiction of super-vixen Undine.',
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '290',
    article: 'Swimsuit Spectacular',
    author: [''],
    artist: ['Henry Siembieda'],
    page: '51',
    issue: rifter35,
    issueTitle: 'The Rifter #35',
    image: './images/rifter35.jpg',
    summary: "Kevin Siembieda's father.",
    games: ['Any'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '291',
    article: 'Swimsuit Spectacular',
    author: [''],
    artist: ['Mike Mumah'],
    page: '52',
    issue: rifter35,
    issueTitle: 'The Rifter #35',
    image: './images/rifter35.jpg',
    summary: 'Midnight bathing beauty.',
    games: ['Beyond the Supernatural', 'Rifts'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '292',
    article: 'Swimsuit Spectacular',
    author: [''],
    artist: ['Mike Mumah'],
    page: '53',
    issue: rifter35,
    issueTitle: 'The Rifter #35',
    image: './images/rifter35.jpg',
    summary: 'A bionic charm.',
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '293',
    article: 'Swimsuit Spectacular',
    author: [''],
    artist: ['Edward Woodward III'],
    page: '54',
    issue: rifter35,
    issueTitle: 'The Rifter #35',
    image: './images/rifter35.jpg',
    summary: 'Little Necrophim from Nightbane.',
    games: ['Nightbane'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '294',
    article: 'Swimsuit Spectacular',
    author: [''],
    artist: ['Apollo Okamura'],
    page: '55',
    issue: rifter35,
    issueTitle: 'The Rifter #35',
    image: './images/rifter35.jpg',
    summary: "The New German Republic's anime version of Erin Tarn as she muses on the beach writing 'Traversing Our Modern World.'",
    games: ['Rifts'],
    official: 'No',
    tags: ['swimsuit', 'ngr', 'triax']
  },
  {
    id: '295',
    article: 'Swimsuit Spectacular',
    author: [''],
    artist: ['Apollo Okamura'],
    page: '56',
    issue: rifter35,
    issueTitle: 'The Rifter #35',
    image: './images/rifter35.jpg',
    summary: 'The real-life Erin Tarn.',
    games: ['Rifts'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '296',
    article: 'Swimsuit Spectacular',
    author: [''],
    artist: ['Kevin Siembieda'],
    page: '57',
    issue: rifter35,
    issueTitle: 'The Rifter #35',
    image: './images/rifter35.jpg',
    summary: 'Unpublished pencil illustration.',
    games: ['Any'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '297',
    article: 'Swimsuit Spectacular',
    author: [''],
    artist: [''],
    page: '58',
    issue: rifter35,
    issueTitle: 'The Rifter #35',
    image: './images/rifter35.jpg',
    summary: 'A photo array of the Palladium crew.',
    games: ['Any'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '298',
    article: 'The Army of Scorched Earth',
    author: ['Josh Sinsapaugh'],
    artist: ['Brian Manning', 'Allen Manning'],
    page: '61-72',
    issue: rifter35,
    issueTitle: 'The Rifter #35',
    image: './images/rifter35.jpg',
    summary: 'Another perspective on the people, heroes, and dangers of ravaged Chaos Earth during the Great Cataclysm. Demons, rebel army, Marine Commandos, new weapons, new vehicles, adventure ideas, and more.',
    games: ['Chaos Earth'],
    official: 'No',
    tags: ['story', 'adventure', 'weapon', 'vehicle']
  },
  {
    id: '299',
    article: 'The Star of Horus, Part Two',
    author: ['Aaron Corley', 'Allen Gardner'],
    artist: ['Comfort Deborah Love', 'Adam Withers'],
    page: '73-88',
    issue: rifter35,
    issueTitle: 'The Rifter #35',
    image: './images/rifter35.jpg',
    summary: 'An exciting and wonderful tale of adventure, magic and wonderment in the Fantasy setting.',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['story']
  },
  {
    id: '300',
    article: 'Nain Rouge, the Red Dwarf',
    author: ['Jeffry Scott Hansen'],
    artist: ['Mark Dudley'],
    page: '10-12',
    issue: rifter36,
    issueTitle: 'The Rifter #36',
    image: './images/rifter36.jpg',
    summary: 'Description of a nasty, little fella. Inspired from the real world, mythical figure said to be a demonic imp and harbinger of disaster.',
    games: ['Beyond the Supernatural'],
    official: 'No',
    tags: ['monster', 'npc']
  },
  {
    id: '301',
    article: 'The Hoarse Whisperer',
    author: ['Steven Dawes'],
    artist: ['Mark Dudley'],
    page: '15-19',
    issue: rifter36,
    issueTitle: 'The Rifter #36',
    image: './images/rifter36.jpg',
    summary: 'A detailed look at a scary supernatural being known as the Hoarse Whisperer (a Lesser Demon/Supernatural Predator).',
    games: ['Beyond the Supernatural'],
    official: 'No',
    tags: ['monster', 'adventure']
  },
  {
    id: '302',
    article: 'The Dark Brotherhood',
    author: ['Ed Emmer'],
    artist: ['Kent Burles'],
    page: '20-46',
    issue: rifter36,
    issueTitle: 'The Rifter #36',
    image: './images/rifter36.jpg',
    summary: 'A Beyond the Supernatural adventure involving a death cult working to bring about the end of the world.',
    games: ['Beyond the Supernatural'],
    official: 'No',
    tags: ['adventure']
  },
  {
    id: '303',
    article: 'Ellios: Epoch of Legends',
    author: ['Steven Smigielski'],
    artist: ['Kent Burles'],
    page: '47-61',
    issue: rifter36,
    issueTitle: 'The Rifter #36',
    image: './images/rifter36.jpg',
    summary: 'A fantasy level setting with a twist. An Earth-like realm where the gods walk the planet. A fun twist on the Fantasy setting with Heroes Unlimited type powers and more.',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['location', 'power']
  },
  {
    id: '304',
    article: 'Into the Dark Woods: An Introduction to Rifts Deep South',
    author: ['Josh Sinsapaugh'],
    artist: [''],
    page: '62-70',
    issue: rifter36,
    issueTitle: 'The Rifter #36',
    image: './images/rifter36.jpg',
    summary: 'A short, spooky story that gives you an advanced look at the upcoming Rifts Sourcebook, Rifts Deep South.',
    games: ['Rifts'],
    official: 'No',
    tags: ['story']
  },
  {
    id: '305',
    article: 'Madhaven: Into the Ruins',
    author: ['Brandon Aten', 'Taylor White'],
    artist: ['Brian Manning', 'Allen Manning'],
    page: '71-90',
    issue: rifter36,
    issueTitle: 'The Rifter #36',
    image: './images/rifter36.jpg',
    summary: 'More background and info about Madhaven, including notable finds, key locations within the ruins, Edgetowns, Newar Psi-Stalker Tribe, a random treasure table, Reconciler O.C.C., the Excavator O.C.C., excavation tools, some new Techno-Wizard equipment and clarifications.',
    games: ['Rifts'],
    official: 'Yes',
    tags: ['location', 'occ', 'techno-wizard', 'tw']
  },
  {
    id: '306',
    article: 'The Expanded Mega-Hero',
    author: ['Greg Diaczyk'],
    artist: ['Brian Manning', 'Allen Manning'],
    page: '17-39',
    issue: rifter37,
    issueTitle: 'The Rifter #37',
    image: './images/rifter37.jpg',
    summary: "Optional source material and ideas for playing Mega-Heroes in Heroes Unlimited. Includes super ability power increases, new Mega-Powers, new Achilles' Heels, Power Category-Specific Mega-Heroes, Dual Classes, plus Secret Base Creation Rules and ideas!",
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['ability', 'power', 'rules']
  },
  {
    id: '307',
    article: 'Great House Shiva',
    author: ['Todd Yoho'],
    artist: ['Brian Manning', 'Allen Manning'],
    page: '40-57',
    issue: rifter37,
    issueTitle: 'The Rifter #37',
    image: './images/rifter37.jpg',
    summary: 'The history behind House Shiva, its government, goals, dreams, and war machine. Also includes notable NPCs, a pair of new O.C.C.s, the Naga Dancer and Pariah, plus the host armor of the new O.C.C.s and a few new weapons.',
    games: ['Splicers'],
    official: 'Yes',
    tags: ['npc', 'weapon', 'occ', 'location', 'armor', 'weapons']
  },
  {
    id: '308',
    article: 'Abernathy Pass',
    author: ['Zachary Houghton'],
    artist: ['Ramon Perez'],
    page: '58-60',
    issue: rifter37,
    issueTitle: 'The Rifter #37',
    image: './images/rifter37.jpg',
    summary: 'The New West boomtown of Abernathy Pass.',
    games: ['Rifts'],
    official: 'No',
    tags: ['location']
  },
  {
    id: '309',
    article: 'The RCSG, Ft. Laredo, and the East St. Louis Rift',
    author: ['Matthew Olfson'],
    artist: ['Apollo Okamura'],
    page: '61-82',
    issue: rifter37,
    issueTitle: 'The Rifter #37',
    image: './images/rifter37.jpg',
    summary: "Optional source material and adventure involving the St. Louis Rift, better known as Devil's Gate and the Coalition Army outpost that guards it. Includes notable NPCs, history of the Rift, Fort Laredo, and ideas for adventure.",
    games: ['Rifts'],
    official: 'No',
    tags: ['npc', 'location', 'coalition', 'cs']
  },
  {
    id: '310',
    article: 'Family Business',
    author: ['Jason Marker'],
    artist: ['Apollo Okamura'],
    page: '83-90',
    issue: rifter37,
    issueTitle: 'The Rifter #37',
    image: './images/rifter37.jpg',
    summary: 'A touching, short story about Dog Boys and the hardship of life on Rifts Earth.',
    games: ['Rifts'],
    official: 'No',
    tags: ['story']
  },
  {
    id: '311',
    article: 'Great House Shiva, Part Two',
    author: ['Todd Yoho'],
    artist: ['Brian Manning', 'Allen Manning'],
    page: '14-24',
    issue: rifter38,
    issueTitle: 'The Rifter #38',
    image: './images/rifter38.jpg',
    summary: 'The War Mounts of House Shiva include the Agni Plasma Bird, Ganesh Personnel Carrier, Swoop Dragon, Naga Serpent and Nihilist Suicide Beast.',
    games: ['Splicers'],
    official: 'Yes',
    tags: ['monster', 'location']
  },
  {
    id: '312',
    article: 'The Art of Role-Playing - Game Master and Player Tips',
    author: ['Craig Hatler', 'Todd V. Ehrenfels'],
    artist: ['Comfort Deborah Love'],
    page: '25-30',
    issue: rifter38,
    issueTitle: 'The Rifter #38',
    image: './images/rifter38.jpg',
    summary: 'The first of an ongoing series of tips, advice and suggestions to make your gaming experience that much better.',
    games: ['Any'],
    official: 'No',
    tags: ['tips', 'gm']
  },
  {
    id: '313',
    article: 'Warbirds',
    author: ['Justin Kugler'],
    artist: [''],
    page: '31-38',
    issue: rifter38,
    issueTitle: 'The Rifter #38',
    image: './images/rifter38.jpg',
    summary: "The freedom fighters and Bug hunters of Earth decimated by the invasion of the 'Bugs,' with a host of aircraft. Stats for 12 aircraft, plus Flyboys and Barnstormers, a few bands of heroes and a couple NPCs.",
    games: ['Systems Failure'],
    official: 'No',
    tags: ['npc', 'vehicle']
  },
  {
    id: '314',
    article: 'Laser Mage',
    author: ['Dennis Glover'],
    artist: ['Benjamin Rodriguez'],
    page: '39-44',
    issue: rifter38,
    issueTitle: 'The Rifter #38',
    image: './images/rifter38.jpg',
    summary: 'Optional source material in the form of the Priests of the Divine Illumination and Light Magic. Includes Laser Mage O.C.C., and 21 spells like Mirage, Crystal Bomb, Material Light, Shining Armor, and more.',
    games: ['Rifts'],
    official: 'No',
    tags: ['occ', 'magic', 'spell']
  },
  {
    id: '315',
    article: 'Slavery',
    author: ['Mark Hall'],
    artist: ['Mark Dudley'],
    page: '45-56',
    issue: rifter38,
    issueTitle: 'The Rifter #38',
    image: './images/rifter38.jpg',
    summary: 'Takes a look at the elements of slavery in the Palladium world. Includes Slavery and Alignments, Slavery Around the World, Slave Marks, Slave Prices, The Slaver O.C.C., new skills and more.',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['occ']
  },
  {
    id: '316',
    article: 'A Walk on the Wild Side - Barbarians and Savages of the Palladium World, Part One',
    author: ['John C. Philpott'],
    artist: ['Brian Manning', 'Allen Manning'],
    page: '57-79',
    issue: rifter38,
    issueTitle: 'The Rifter #38',
    image: './images/rifter38.jpg',
    summary: 'A look at a wide range of barbarians and primitive people of the Palladium World; their culture, habits and way of life.',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['race']
  },
  {
    id: '317',
    article: 'Darkvare and Astral Plane',
    author: ['Joseph Larsen'],
    artist: ['Adam Withers'],
    page: '80-88',
    issue: rifter38,
    issueTitle: 'The Rifter #38',
    image: './images/rifter38.jpg',
    summary: 'A new, foul entity from the Astral Plane, the dreaded Darkvare.',
    games: ['Rifts', 'Chaos Earth'],
    official: 'No',
    tags: ['monster']
  },
  {
    id: '318',
    article: 'The Moons of Jupiter',
    author: ['Mike Ferguson'],
    artist: ['Apollo Okamura'],
    page: '16-22',
    issue: rifter39,
    issueTitle: 'The Rifter #39',
    image: './images/rifter39.jpg',
    summary: 'Life and adventure away from decimated Chaos Earth during the Great Cataclysm. Alien life forms, mad scientists, and adventure campaign ideas.',
    games: ['Chaos Earth'],
    official: 'No',
    tags: ['adventure', 'location']
  },
  {
    id: '319',
    article: 'Megaera',
    author: ['Irvin L. Jackson'],
    artist: ['Apollo Okamura'],
    page: '24-26',
    issue: rifter39,
    issueTitle: 'The Rifter #39',
    image: './images/rifter39.jpg',
    summary: 'Megaera',
    games: ['Nightbane'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '320',
    article: 'Aquaria',
    author: ['Mark Oberle'],
    artist: ['Mike Mumah'],
    page: '27-30',
    issue: rifter39,
    issueTitle: 'The Rifter #39',
    image: './images/rifter39.jpg',
    summary: 'Aquaria',
    games: ['Nightbane'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '321',
    article: 'Doctor Lillian Campbell',
    author: ['Jason Marker'],
    artist: ['Michael Dubisch'],
    page: '31-34',
    issue: rifter39,
    issueTitle: 'The Rifter #39',
    image: './images/rifter39.jpg',
    summary: 'Doctor Lillian Campbell',
    games: ['Nightbane'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '322',
    article: 'La Llorona',
    author: ['Josh Sinsapaugh'],
    artist: ['Mike Mumah'],
    page: '35-38',
    issue: rifter39,
    issueTitle: 'The Rifter #39',
    image: './images/rifter39.jpg',
    summary: 'La Llorona',
    games: ['Beyond the Supernatural'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '323',
    article: 'Nimbus and Madam Steel',
    author: ['Carl Gleba'],
    artist: ['Bill Bryan'],
    page: '39-42',
    issue: rifter39,
    issueTitle: 'The Rifter #39',
    image: './images/rifter39.jpg',
    summary: 'Nimbus and Madam Steel',
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '324',
    article: 'Beatbox',
    author: ['Todd Yoho'],
    artist: ['Mark Dudley'],
    page: '43-46',
    issue: rifter39,
    issueTitle: 'The Rifter #39',
    image: './images/rifter39.jpg',
    summary: 'Beatbox',
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '325',
    article: 'Stormwitch',
    author: ['Julius Rosenstein'],
    artist: ['Comfort Deborah Love'],
    page: '47-49',
    issue: rifter39,
    issueTitle: 'The Rifter #39',
    image: './images/rifter39.jpg',
    summary: 'Stormwitch',
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '326',
    article: 'Scarlet Albany',
    author: ['Levi Johnstone'],
    artist: ['Allen Manning'],
    page: '50-52',
    issue: rifter39,
    issueTitle: 'The Rifter #39',
    image: './images/rifter39.jpg',
    summary: 'Scarlet Alban',
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '327',
    article: 'Shock',
    author: ['Wayne Breaux Jr.'],
    artist: ['Wayne Breaux Jr.'],
    page: '53-54',
    issue: rifter39,
    issueTitle: 'The Rifter #39',
    image: './images/rifter39.jpg',
    summary: 'Shock',
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '328',
    article: '1st Lt. Nicole Bradshaw',
    author: ['Carl Gleba'],
    artist: ['Nick Bradshaw'],
    page: '55-56',
    issue: rifter39,
    issueTitle: 'The Rifter #39',
    image: './images/rifter39.jpg',
    summary: '1st Lt. Nicole Bradshaw',
    games: ['Mechanoids'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '329',
    article: 'Alyssa Peknamovic',
    author: ['Taylor White'],
    artist: ['Chris Bourassa'],
    page: '57-59',
    issue: rifter39,
    issueTitle: 'The Rifter #39',
    image: './images/rifter39.jpg',
    summary: "'Center Spread' Girl of the Year - Circa 109 P.A.",
    games: ['Rifts'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '330',
    article: 'Beata Olga Von Strauss',
    author: ['Brandon Aten'],
    artist: ['Jeff Russell'],
    page: '60-61',
    issue: rifter39,
    issueTitle: 'The Rifter #39',
    image: './images/rifter39.jpg',
    summary: 'Beata Olga Von Strauss',
    games: ['Rifts'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '331',
    article: 'Sirina the Anchian',
    author: ['Jason Richards'],
    artist: ['Michael Dubisch'],
    page: '62-66',
    issue: rifter39,
    issueTitle: 'The Rifter #39',
    image: './images/rifter39.jpg',
    summary: 'Sirina the Anchian',
    games: ['Rifts'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '332',
    article: 'Lucretia Anteri',
    author: ['Braden Campbell'],
    artist: ['Kent Burles'],
    page: '67-68',
    issue: rifter39,
    issueTitle: 'The Rifter #39',
    image: './images/rifter39.jpg',
    summary: 'Lucretia Anteri - Wormwood',
    games: ['Rifts'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '333',
    article: "The Slingin' Banditas",
    author: ['Josh Sinsapaugh'],
    artist: ['Brian Manning', 'Mike Mumah'],
    page: '69-78',
    issue: rifter39,
    issueTitle: 'The Rifter #39',
    image: './images/rifter39.jpg',
    summary: "The Slingin' Banditas",
    games: ['Rifts'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '334',
    article: 'Artemis',
    author: ['John C. Philpott'],
    artist: ['John Zeleznik'],
    page: '79-81',
    issue: rifter39,
    issueTitle: 'The Rifter #39',
    image: './images/rifter39.jpg',
    summary: 'Artemis',
    games: ['Rifts'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '335',
    article: 'Nysha Karillith',
    author: ['Levi Johnstone'],
    artist: ['Adam Withers'],
    page: '82-83',
    issue: rifter39,
    issueTitle: 'The Rifter #39',
    image: './images/rifter39.jpg',
    summary: 'Nysha Karillith',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '336',
    article: 'La Mort Venus',
    author: ['Kevin Siembieda'],
    artist: ['David Martin'],
    page: '84-88',
    issue: rifter39,
    issueTitle: 'The Rifter #39',
    image: './images/rifter39.jpg',
    summary: 'La Mort Venus',
    games: ['Any'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '337',
    article: 'A Walk on the Wild Side - Barbarians, Part Two',
    author: ['John C. Philpott'],
    artist: ['Brian Manning', 'Allen Manning'],
    page: '16-37',
    issue: rifter40,
    issueTitle: 'The Rifter #40',
    image: './images/rifter40.jpg',
    summary: 'More interesting O.C.C.s, facts about barbarian society, stigmas, Hand to Hand: Wild, new Shamantic Chants, new skills, new abilities and more. Includes Berserker O.C.C., Savage Warrior O.C.C., Native Tribesman O.C.C., and Wild Man O.C.C.',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['occ', 'combat', 'skill']
  },
  {
    id: '338',
    article: 'The Devil Muse',
    author: ['Josh Sinsapaugh'],
    artist: ['Kent Burles'],
    page: '38-41',
    issue: rifter40,
    issueTitle: 'The Rifter #40',
    image: './images/rifter40.jpg',
    summary: 'A delightfully wicked and vile creature.',
    games: ['Beyond the Supernatural'],
    official: 'No',
    tags: ['monster']
  },
  {
    id: '340',
    article: 'Your Guide to the Zombie Apocalypse',
    author: ['Josh Hilden', 'Joshua Sanford'],
    artist: ['Mike Mumah', 'Mark Dudley'],
    page: '42-54',
    issue: rifter40,
    issueTitle: 'The Rifter #40',
    image: './images/rifter40.jpg',
    summary: 'Dead Reign previews. The basic concept, setting, key types of zombies.',
    games: ['Dead Reign'],
    official: 'No',
    tags: ['monster']
  },
  {
    id: '340A',
    article: 'Spell Books of the Megaverse',
    author: ['S.E. Gibbons'],
    artist: ['Kent Burles'],
    page: '57-68',
    issue: rifter40,
    issueTitle: 'The Rifter #40',
    image: './images/rifter40.jpg',
    summary: 'An epic and wide-ranging look at how magic spell books are used across the Megaverse. Presents all the whos, wheres, whys, hows, dangers, advantages and more behind spell books.',
    games: ['Rifts', 'Palladium Fantasy'],
    official: 'No',
    tags: ['spell', 'magic']
  },
  {
    id: '341',
    article: 'Circus! Circus!',
    author: ['Jason Marker'],
    artist: ['Mike Mumah'],
    page: '69-78',
    issue: rifter40,
    issueTitle: 'The Rifter #40',
    image: './images/rifter40.jpg',
    summary: 'A poignant story in the Rifts Earth setting.',
    games: ['Rifts'],
    official: 'No',
    tags: ['story']
  },
  {
    id: '342',
    article: 'The Spoils of War, Part One',
    author: ['Ed Emmer'],
    artist: ['Comfort Deborah Love', 'Adam Withers', 'Nick Bradshaw'],
    page: '79-119',
    issue: rifter40,
    issueTitle: 'The Rifter #40',
    image: './images/rifter40.jpg',
    summary: "An epic adventure that puts players at odds with Coalition soldiers, pirates, slavers and demons, and pits them against the Xiticix and rival forces. It's all part of a quest for treasure and magic that starts at New Lazlo and leaders to danger.",
    games: ['Rifts'],
    official: 'No',
    tags: ['adventure', 'cs', 'coalition', 'monster']
  },
  {
    id: '343',
    article: 'Hades, Pits of Hell - Source material',
    author: ['Carl Gleba'],
    artist: ['Jeffrey Russell'],
    page: '126-128',
    issue: rifter40,
    issueTitle: 'The Rifter #40',
    image: './images/rifter40.jpg',
    summary: 'A handful of characters who had to be chopped out of the Hades book due to space limitations. Includes Warlord Thantu, leader of the Brass Guard II, as well as other Baal-Rogs on the team.',
    games: ['Rifts'],
    official: 'Yes',
    tags: ['npc']
  },
  {
    id: '344',
    article: 'Characters with Character (personality that is)',
    author: ['Todd V. Ehrenfels', 'Craig Hatler'],
    artist: ['Mark Dudley'],
    page: '15-20',
    issue: rifter41,
    issueTitle: 'The Rifter #41',
    image: './images/rifter41.jpg',
    summary: 'A variety of character archetypes and subsets within those types to help you create unique and interesting characters.',
    games: ['Any'],
    official: 'No',
    tags: ['gm', 'tool']
  },
  {
    id: '345',
    article: 'The City of Filly',
    author: ['Erin Lindsey'],
    artist: ['Erin Lindsey'],
    page: '21-44',
    issue: rifter41,
    issueTitle: 'The Rifter #41',
    image: './images/rifter41.jpg',
    summary: 'A tour de force of information, detail, adventure ideas, new mutant animals and fun with this source material about the Rodent Cartel and Filly Proper.',
    games: ['After the Bomb', 'Heroes Unlimited'],
    official: 'No',
    tags: ['adventure', 'npc', 'mutant', 'location']
  },
  {
    id: '346',
    article: 'The Spoils of War, Part Two',
    author: ['Ed Emmer'],
    artist: ['Kent Burles', 'Brian Manning', 'Allen Manning', 'Ed Emmer'],
    page: '45-86',
    issue: rifter41,
    issueTitle: 'The Rifter #41',
    image: './images/rifter41.jpg',
    summary: 'This epic adventure takes place just after the fall of Tolkeen. The tale comes to a conclusion that introduces the UAR-2 Subjugator and all manner of menaces, twists and turns.',
    games: ['Rifts'],
    official: 'No',
    tags: ['adventure', 'occ']
  },
  {
    id: '347',
    article: 'The Order of Light',
    author: ['Carl Gleba'],
    artist: ['Nick Bradshaw'],
    page: '91-97',
    issue: rifter41,
    issueTitle: 'The Rifter #41',
    image: './images/rifter41.jpg',
    summary: 'Outtakes from Dimension Book 10: Hades, Pits of Hell. Angels in Hades?! Yes, an entire secret underground organization working to undermine the Lords of Hades.',
    games: ['Rifts'],
    official: 'Yes',
    tags: ['adventure']
  },
  {
    id: '348',
    article: 'S.C.R.E.T. Around the World',
    author: ['Glen Evans'],
    artist: ['Brian Manning', 'Allen Manning'],
    page: '12-37',
    issue: rifter42,
    issueTitle: 'The Rifter #42',
    image: './images/rifter42.jpg',
    summary: 'Ideas about S.C.R.E.T. - the Superbeing Control, Retrieval, and Elimination Team, and how S.C.R.E.T. agencies around the world operate to keep super-villains and rogue heroes under control.',
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['scret']
  },
  {
    id: '349',
    article: 'The Wormwood Addenda',
    author: ['Braden Campbell'],
    artist: ['Kent Burles'],
    page: '38-44',
    issue: rifter42,
    issueTitle: 'The Rifter #42',
    image: './images/rifter42.jpg',
    summary: 'A fascinating look at the world and history of the hellish dimensional realm known as Wormwood.',
    games: ['Rifts'],
    official: 'No',
    tags: ['location']
  },
  {
    id: '350',
    article: 'The Coalition Edge',
    author: ['Matt Olfson'],
    artist: ['Charles Walton', 'Mark Dudley'],
    page: '45-66',
    issue: rifter42,
    issueTitle: 'The Rifter #42',
    image: './images/rifter42.jpg',
    summary: 'A look at the advantages held by the Coalition States over other nations and organizations.',
    games: ['Rifts'],
    official: 'No',
    tags: ['cs', 'coalition']
  },
  {
    id: '351',
    article: 'The Torque Amemait',
    author: ['Aaron Corley'],
    artist: ['Kent Burles'],
    page: '67-73',
    issue: rifter42,
    issueTitle: 'The Rifter #42',
    image: './images/rifter42.jpg',
    summary: "The tale of the chaos god, Amemait, also known as 'The Devourer,' and how the ancient relic of this dark god affects any who try to use it.",
    games: ['Any'],
    official: 'No',
    tags: ['npc', 'story']
  },
  {
    id: '352',
    article: 'Warlords of Boston',
    author: ['Dale. W. Glaser'],
    artist: ['Mike Mumah'],
    page: '74-83',
    issue: rifter42,
    issueTitle: 'The Rifter #42',
    image: './images/rifter42.jpg',
    summary: 'Information on a notable Nightbane gang operating in Boston. Stats of key individuals as well as their motives and aspirations. Adventure ideas, morphus tables, NPCs.',
    games: ['Nightbane'],
    official: 'No',
    tags: ['adventure', 'location', 'morphus']
  },
  {
    id: '353',
    article: 'Under the Skin',
    author: ['Joseph Larsen'],
    artist: ['Nick Bradshaw'],
    page: '84-92',
    issue: rifter42,
    issueTitle: 'The Rifter #42',
    image: './images/rifter42.jpg',
    summary: 'A fascinating look at the disgusting and strange craft of using the hides of demons and other creatures to create enchanted leather armor and items. Plus a look at Bio-Alchemy and the mysterious and mystical human(?) beings known as the Kezel.',
    games: ['Palladium Fantasy', 'Rifts'],
    official: 'No',
    tags: ['magic']
  },
  {
    id: '354',
    article: 'Femme Fatale Pinups start here! Doctor Feral and his Sex Kittens/Wildcats',
    author: ['Kevin Siembieda'],
    artist: ['Kevin Siembieda'],
    page: '18-20',
    issue: rifter43,
    issueTitle: 'The Rifter #43',
    image: './images/rifter43.jpg',
    summary: "Doctor Feral was one of Erick Wujcik's favorite villains, so we thought we'd start off with this latest feat in genetic engineering.",
    games: ['After the Bomb', 'Heroes Unlimited', 'Ninjas and Superspies'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '355',
    article: 'Sumaiya',
    author: ['Mark Hall'],
    artist: ['Mike Mumah'],
    page: '21-23',
    issue: rifter43,
    issueTitle: 'The Rifter #43',
    image: './images/rifter43.jpg',
    summary: 'Sumaiya',
    games: ['After the Bomb'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '356',
    article: 'B.E. Vollbier',
    author: ['Jason Marker'],
    artist: ['Brian Manning'],
    page: '24-25',
    issue: rifter43,
    issueTitle: 'The Rifter #43',
    image: './images/rifter43.jpg',
    summary: 'B.E. Vollbier',
    games: ['After the Bomb'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '357',
    article: 'Shelly Shocks',
    author: ['Erin Lindsey'],
    artist: ['Erin Lindsey'],
    page: '26-27',
    issue: rifter43,
    issueTitle: 'The Rifter #43',
    image: './images/rifter43.jpg',
    summary: 'Shelly Shocks',
    games: ['After the Bomb'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '358',
    article: 'Candy Roux',
    author: ['Scott Leopold'],
    artist: ['Scott Leopold'],
    page: '28-32',
    issue: rifter43,
    issueTitle: 'The Rifter #43',
    image: './images/rifter43.jpg',
    summary: 'New mutant animal description: Candiru',
    games: ['After the Bomb'],
    official: 'No',
    tags: ['swimsuit', 'mutant']
  },
  {
    id: '359',
    article: 'Thump',
    author: ['Josh Hilden'],
    artist: ['Jared Trulock'],
    page: '33-34',
    issue: rifter43,
    issueTitle: 'The Rifter #43',
    image: './images/rifter43.jpg',
    summary: 'Thump',
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '360',
    article: 'Crimson Waters',
    author: ['Josh Hilden'],
    artist: ['Mark Evans'],
    page: '35-37',
    issue: rifter43,
    issueTitle: 'The Rifter #43',
    image: './images/rifter43.jpg',
    summary: 'Crimson Waters',
    games: ['Ninjas and Superspies'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '361',
    article: 'Shujumi and Hezikiah',
    author: ['Brandon Aten'],
    artist: ['Apollo Okamura'],
    page: '38-40',
    issue: rifter43,
    issueTitle: 'The Rifter #43',
    image: './images/rifter43.jpg',
    summary: 'Shujumi and Hezikiah',
    games: ['Ninjas and Superspies'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '362',
    article: 'Hanayome Ichibetsu',
    author: ['Todd Yoho'],
    artist: ['Amy L. Ashbaugh'],
    page: '41-43',
    issue: rifter43,
    issueTitle: 'The Rifter #43',
    image: './images/rifter43.jpg',
    summary: 'Hanayome Ichibetsu',
    games: ['Ninjas and Superspies'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '363',
    article: 'Pyxee',
    author: ['Mark Oberle'],
    artist: ['Mike Mumah'],
    page: '43-45',
    issue: rifter43,
    issueTitle: 'The Rifter #43',
    image: './images/rifter43.jpg',
    summary: 'Pyxee',
    games: ['Nightbane'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '364',
    article: 'Mevka',
    author: ['Jason Richards'],
    artist: ['Michael Dubisch'],
    page: '46-49',
    issue: rifter43,
    issueTitle: 'The Rifter #43',
    image: './images/rifter43.jpg',
    summary: 'Mevka',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '365',
    article: 'Ma',
    author: ['Mark Hall'],
    artist: ['Michael Wilson'],
    page: '50-51',
    issue: rifter43,
    issueTitle: 'The Rifter #43',
    image: './images/rifter43.jpg',
    summary: 'Ma',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '366',
    article: 'Cana Laurel and Jarrow the Basilisk',
    author: ['Todd Yoho'],
    artist: ['Kent Burles'],
    page: '52-55',
    issue: rifter43,
    issueTitle: 'The Rifter #43',
    image: './images/rifter43.jpg',
    summary: 'Cana Laurel and Jarrow the Basilisk',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '367',
    article: 'Jinx and Alexander',
    author: ['Carl Gleba'],
    artist: ['Larry Elmore'],
    page: '56-57',
    issue: rifter43,
    issueTitle: 'The Rifter #43',
    image: './images/rifter43.jpg',
    summary: 'Jinx and Alexander',
    games: ['Rifts'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '368',
    article: 'Evie',
    author: ['Mark Oberle'],
    artist: ['Mike Leonard'],
    page: '58-61',
    issue: rifter43,
    issueTitle: 'The Rifter #43',
    image: './images/rifter43.jpg',
    summary: 'Evie',
    games: ['Rifts'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '369',
    article: 'Shana the Twin Axe',
    author: ['Josh Sinsapaugh'],
    artist: ['Mike Leonard'],
    page: '62-64',
    issue: rifter43,
    issueTitle: 'The Rifter #43',
    image: './images/rifter43.jpg',
    summary: 'Shana the Twin Axe',
    games: ['Rifts'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '370',
    article: 'Shui Nu Ling',
    author: ['Taylor White'],
    artist: ['Larry Elmore'],
    page: '65-67',
    issue: rifter43,
    issueTitle: 'The Rifter #43',
    image: './images/rifter43.jpg',
    summary: 'Shui Nu Ling, Chinese Water Maiden Spirit',
    games: ['Rifts'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '371',
    article: 'Mara and Xiang',
    author: ['John C. Philpott'],
    artist: ['Chuck Walton'],
    page: '62-72',
    issue: rifter43,
    issueTitle: 'The Rifter #43',
    image: './images/rifter43.jpg',
    summary: "Mara's Demons, Zhong Xiang",
    games: ['Rifts'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '372',
    article: 'Calla',
    author: ['Josh Hilden'],
    artist: ['Allen Manning'],
    page: '73-75',
    issue: rifter43,
    issueTitle: 'The Rifter #43',
    image: './images/rifter43.jpg',
    summary: 'Calla. Aten, the Lesser Rune Weapon.',
    games: ['Rifts'],
    official: 'No',
    tags: ['swimsuit', 'rune']
  },
  {
    id: '373',
    article: 'Captain Moi Tse Hun',
    author: ['Mark Dudley', 'Joseph Cain', 'Julius Rosenstein'],
    artist: ['Mark Dudley'],
    page: '76-78',
    issue: rifter43,
    issueTitle: 'The Rifter #43',
    image: './images/rifter43.jpg',
    summary: "'Hong Ying' Red Falcon flying power armor.",
    games: ['Rifts'],
    official: 'No',
    tags: ['swimsuit', 'armor']
  },
  {
    id: '374',
    article: 'Queen Rahela of Worldgate',
    author: ['Braden Campbell'],
    artist: ['Mike Mumah'],
    page: '79-80',
    issue: rifter43,
    issueTitle: 'The Rifter #43',
    image: './images/rifter43.jpg',
    summary: 'In Rifts Wormwood',
    games: ['Rifts'],
    official: 'No',
    tags: ['swimsuit']
  },
  {
    id: '375',
    article: 'Senator Nicole Teigs',
    author: ['Chris Kluge', 'Charles Walton'],
    artist: ['Charles Walton'],
    page: '81-85',
    issue: rifter43,
    issueTitle: 'The Rifter #43',
    image: './images/rifter43.jpg',
    summary: 'Medusa Host Armor',
    games: ['Splicers'],
    official: 'No',
    tags: ['swimsuit', 'armor']
  },
  {
    id: '376',
    article: 'Crystal and the Trans-D Tavern',
    author: ['Kevin Siembieda'],
    artist: ['Nick Bradshaw'],
    page: '86-92',
    issue: rifter43,
    issueTitle: 'The Rifter #43',
    image: './images/rifter43.jpg',
    summary: "The Trans-D Tavern, Crystal (a goddess), 'Tank' (mutant turtle), 'Hot Dog' (Metal Morph), Edylwin (Eylor Imp)",
    games: ['Rifts', 'Phase World', 'After the Bomb'],
    official: 'No',
    tags: ['location', 'npc']
  },
  {
    id: '377',
    article: 'The Wormwood Addenda',
    author: ['Braden Campbell'],
    artist: ['Kent Burles'],
    page: '16-20',
    issue: rifter44,
    issueTitle: 'The Rifter #44',
    image: './images/rifter44.jpg',
    summary: 'Optional source material for Rifts Dimension Book One: Wormwood. Background about the Eastern Dominion, its history, government, military, society, Lost Ezud, Worldgate, the Great Wall, the Drop, and much more. New Wormwood O.C.C.s, including the Eastern Templar and Long Bowman, plus a few new weapons and equipment.',
    games: ['Rifts'],
    official: 'No',
    tags: ['occ', 'location', 'weapon', 'equipment']
  },
  {
    id: '378',
    article: 'Your Morphus and You',
    author: ['Edward Sauerland'],
    artist: ['Stephen Fox'],
    page: '21-44',
    issue: rifter44,
    issueTitle: 'The Rifter #44',
    image: './images/rifter44.jpg',
    summary: 'Optional rules and source material, Psychology in the Shadows, new Morphus Tables, new talents, Talent Shaper O.C.C. and more.',
    games: ['Nightbane'],
    official: 'No',
    tags: ['occ', 'morphus']
  },
  {
    id: '379',
    article: 'Telekinesis and Ectoplasm',
    author: ['Mark Hall'],
    artist: [''],
    page: '45-51',
    issue: rifter44,
    issueTitle: 'The Rifter #44',
    image: './images/rifter44.jpg',
    summary: 'A closer look at the psionic powers of Telekinesis and Ectoplasm and new uses and applications for these powers.',
    games: ['Rifts'],
    official: 'No',
    tags: ['psionic']
  },
  {
    id: '380',
    article: 'The Scaring Crow',
    author: ['Steven Dawes'],
    artist: ['Kent Burles'],
    page: '52-59',
    issue: rifter44,
    issueTitle: 'The Rifter #44',
    image: './images/rifter44.jpg',
    summary: 'A frightening, new demonic fiend, the Scaring Crow, that thrives on fear.',
    games: ['Beyond the Supernatural'],
    official: 'No',
    tags: ['monster']
  },
  {
    id: '381',
    article: 'Chrysalis',
    author: ['Mike Leonard'],
    artist: ['Mike Leonard'],
    page: '60-61',
    issue: rifter44,
    issueTitle: 'The Rifter #44',
    image: './images/rifter44.jpg',
    summary: 'A frightening romp in the world of demons and Rifts.',
    games: ['Rifts'],
    official: 'No',
    tags: ['story']
  },
  {
    id: '382',
    article: 'Megaversal Monster Showdown - Sansarakhaana',
    author: ['Todd Yoho'],
    artist: ['Brian Manning'],
    page: '62-66',
    issue: rifter44,
    issueTitle: 'The Rifter #44',
    image: './images/rifter44.jpg',
    summary: 'Sansarakhaana',
    games: ['Splicers'],
    official: 'No',
    tags: ['monster']
  },
  {
    id: '383',
    article: "Megaversal Monster Showdown - The Eldritch Spider of the Devil's Tower",
    author: ['Allen Manning', 'Josh Sinsapaugh'],
    artist: ['Allen Manning'],
    page: '67-69',
    issue: rifter44,
    issueTitle: 'The Rifter #44',
    image: './images/rifter44.jpg',
    summary: "The Eldritch Spider of the Devil's Tower",
    games: ['Rifts', 'Heroes Unlimited'],
    official: 'No',
    tags: ['monster']
  },
  {
    id: '384',
    article: 'Megaversal Monster Showdown - Gulgoth',
    author: ['Brandon Aten'],
    artist: ['Nick Bradshaw'],
    page: '70-71',
    issue: rifter44,
    issueTitle: 'The Rifter #44',
    image: './images/rifter44.jpg',
    summary: 'Gulgoth',
    games: ['Rifts'],
    official: 'No',
    tags: ['monster']
  },
  {
    id: '385',
    article: 'Megaversal Monster Showdown - Philly Brood Gulper',
    author: ['Irvin Jackson'],
    artist: ['Nick Bradshaw'],
    page: '72-74',
    issue: rifter44,
    issueTitle: 'The Rifter #44',
    image: './images/rifter44.jpg',
    summary: 'Philly Brood Gulper',
    games: ['Rifts'],
    official: 'No',
    tags: ['monster']
  },
  {
    id: '386',
    article: 'Megaversal Monster Showdown - Sauradon',
    author: ['Jeffry Scott Hansen', 'Brandon Aten'],
    artist: ['Allen Manning'],
    page: '75-76',
    issue: rifter44,
    issueTitle: 'The Rifter #44',
    image: './images/rifter44.jpg',
    summary: 'Sauradon',
    games: ['Rifts'],
    official: 'No',
    tags: ['monster']
  },
  {
    id: '387',
    article: 'Megaversal Monster Showdown - The Nayk Star Spider',
    author: ['Mark Hall'],
    artist: ['Michael Wilson'],
    page: '77',
    issue: rifter44,
    issueTitle: 'The Rifter #44',
    image: './images/rifter44.jpg',
    summary: 'The Nayk Star Spider',
    games: ['Rifts'],
    official: 'No',
    tags: ['monster']
  },
  {
    id: '388',
    article: 'Megaversal Monster Showdown - Quiserraica',
    author: ['Chris Kluge'],
    artist: ['Charles Walton II'],
    page: '78-81',
    issue: rifter44,
    issueTitle: 'The Rifter #44',
    image: './images/rifter44.jpg',
    summary: 'Quiserraica',
    games: ['Rifts', 'Phase World'],
    official: 'No',
    tags: ['monster']
  },
  {
    id: '389',
    article: 'Megaversal Monster Showdown - Mora',
    author: ['Carl Gleba'],
    artist: ['Mike Mumah'],
    page: '82-84',
    issue: rifter44,
    issueTitle: 'The Rifter #44',
    image: './images/rifter44.jpg',
    summary: 'Mora',
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['monster']
  },
  {
    id: '390',
    article: 'Megaversal Monster Showdown - Scolopendra-Ginamo',
    author: ['John C. Philpott'],
    artist: ['Brian Manning'],
    page: '85-87',
    issue: rifter44,
    issueTitle: 'The Rifter #44',
    image: './images/rifter44.jpg',
    summary: 'Scolopendra-Ginamo',
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['monster']
  },
  {
    id: '391',
    article: 'Megaversal Monster Showdown - Tyrannus',
    author: ['Mark Oberle'],
    artist: ['Daniel Krus'],
    page: '88-91',
    issue: rifter44,
    issueTitle: 'The Rifter #44',
    image: './images/rifter44.jpg',
    summary: 'Tyrannus',
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['monster']
  },
  {
    id: '392',
    article: 'Another World of Zombies',
    author: ['Kevin Siembieda'],
    artist: ['Stephen Fox'],
    page: '17-31',
    issue: rifter45,
    issueTitle: 'The Rifter #45',
    image: './images/rifter45.jpg',
    summary: 'Explanation of why Dead Reign went in a different direction and presents some of the original Dead Reign material as an alternative time-line setting.',
    games: ['Dead Reign'],
    official: 'No',
    tags: ['story', 'gm', 'location']
  },
  {
    id: '393',
    article: 'Of Bows and Arrows',
    author: ['Travis Guerrero'],
    artist: ['Brian Manning'],
    page: '32-44',
    issue: rifter45,
    issueTitle: 'The Rifter #45',
    image: './images/rifter45.jpg',
    summary: 'An in-depth look at the art of Archery in the Fantasy setting as well as three new Archer O.C.C.s: the Psi-Archer, Demon Archer, and Circus Bowman. Also, Hand-to-Hand: Performance Archery, Hand-to-Hand: Bow Combat, archery proficiency tables, and archery combat.',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['occ', 'skill']
  },
  {
    id: '394',
    article: 'The Order of the Mystic Knights',
    author: ['Ian Schroen', 'Brian Weber'],
    artist: ['Kent Burles'],
    page: '45-71',
    issue: rifter45,
    issueTitle: 'The Rifter #45',
    image: './images/rifter45.jpg',
    summary: 'A tour of the Mystic Knights, their history, their hierarchy, ranks, houses of the order, off-shoot groups, and their plans of villainy. Also, an expanded and revised take on the Mystic Knight O.C.C.',
    games: ['Rifts'],
    official: 'No',
    tags: ['occ', 'magic']
  },
  {
    id: '395',
    article: 'The Court of Tarot',
    author: ['Scott Gastineau'],
    artist: ['Nick Bradshaw'],
    page: '72-92',
    issue: rifter45,
    issueTitle: 'The Rifter #45',
    image: './images/rifter45.jpg',
    summary: 'A very interesting group of investigators into the unknown, the Court of Tarot. They are rivals and competitors of the Lazlo Society. The organization, notable NPCs, and history.',
    games: ['Beyond the Supernatural'],
    official: 'No',
    tags: ['npc']
  },
  {
    id: '396',
    article: 'Rifts Dyval and The Minion War',
    author: ['Carl Gleba'],
    artist: ['Nick Bradshaw'],
    page: '16-23',
    issue: rifter46,
    issueTitle: 'The Rifter #46',
    image: './images/rifter46.jpg',
    summary: 'The Quick Roll NPC villain for Dyval in a series of random tables that includes Race (Deevil or not), Rank, Powers and Abilities, Alignment, Motivation, Minions and Wealth. Followed up by groups of shady Deevil henchmen known as the Double Dealers and Chaos Legion.',
    games: ['Rifts'],
    official: 'Yes',
    tags: ['npc', 'tools', 'gm', 'monster']
  },
  {
    id: '397',
    article: 'The Wormwood Addenda - Part Three: The Free City of Worldgate',
    author: ['Braden Campbell'],
    artist: ['Brian Manning', 'Allen Manning'],
    page: '24-36',
    issue: rifter46,
    issueTitle: 'The Rifter #46',
    image: './images/rifter46.jpg',
    summary: 'Explores the City of Worldgate, its army, their flintlock weapons, various O.C.C.s, and places of note.',
    games: ['Rifts'],
    official: 'No',
    tags: ['location', 'occ']
  },
  {
    id: '398',
    article: 'Dragons in Society',
    author: ['J. Woodman'],
    artist: ['Nick Bradshaw'],
    page: '37-38',
    issue: rifter46,
    issueTitle: 'The Rifter #46',
    image: './images/rifter46.jpg',
    summary: 'Examines how dragons adapt and behave together in large numbers in general and at key locations on Rifts Earth, including Lazlo, Dragcona, Lagarto, and Freehold.',
    games: ['Rifts'],
    official: 'No',
    tags: ['monster', 'location']
  },
  {
    id: '399',
    article: 'Rebel Waltz - Brodkil Society',
    author: ['Mark Hall'],
    artist: ['Mark Dudley'],
    page: '39-42',
    issue: rifter46,
    issueTitle: 'The Rifter #46',
    image: './images/rifter46.jpg',
    summary: "A comprehensive, funny and insightful look at how the bionics loving Brodkil Sub-Demons live, function and get along (or don't). Read about Brodkil society, battle for dominance, what creates a Brodkil leader, how new Brodkil are created, bionics. The Gearhead Brodkil R.C.C., plus uses of Brodkil in Necromancy.",
    games: ['Rifts'],
    official: 'No',
    tags: ['rcc', 'monster', 'magic']
  },
  {
    id: '400',
    article: 'Weird Mutants',
    author: ['B. Caleb Goodson'],
    artist: ['Mike Mumah'],
    page: '43-48',
    issue: rifter46,
    issueTitle: 'The Rifter #46',
    image: './images/rifter46.jpg',
    summary: 'An array of disturbing (and fun to play) mutants for your After the Bomb and Heroes Unlimited campaigns. Human Mutants, Fungal Genetic Chimeras, Plant Genetic Chimeras, Rules for creating Genetic Chimeras.',
    games: ['After the Bomb', 'Heroes Unlimited'],
    official: 'No',
    tags: ['mutant', 'rules']
  },
  {
    id: '401',
    article: 'The Scurry Scree and Scurry Talus',
    author: ['Steven Dawes'],
    artist: ['Brian Manning'],
    page: '49-52',
    issue: rifter46,
    issueTitle: 'The Rifter #46',
    image: './images/rifter46.jpg',
    summary: 'Two new demonic servants for Beyond the Supernatural: Scurry Scree and Scurry Talus.',
    games: ['Beyond the Supernatural'],
    official: 'No',
    tags: ['monster', 'npc']
  },
  {
    id: '401a',
    article: 'Why Magic is Still Alive',
    author: ['Russ Brin'],
    artist: ['Nick Bradshaw'],
    page: '53-67',
    issue: rifter46,
    issueTitle: 'The Rifter #46',
    image: './images/rifter46.jpg',
    summary: 'A look at magic and mages in the modern world of Heroes Unlimited. Includes methods of acquiring new spells, success or failure table, heightened perception and familiar link, skill knowledge, and special equipment. The New Age Oracle includes methods of divination, including Tarot, Numerology, etc.',
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['magic', 'Spell', 'rules', 'skill', 'equipment']
  },
  {
    id: '402',
    article: 'The Hawaiian Supernatural',
    author: ['Chris Perrin'],
    artist: ['Paula Porter', 'Mark Dudley'],
    page: '68-74',
    issue: rifter46,
    issueTitle: 'The Rifter #46',
    image: './images/rifter46.jpg',
    summary: 'The magic and spirit world of Hawaii, including lore, Talk with Aumakua, Life After Death, Uhane and Kahunas as NPCs, and much more. The Kahuna O.C.C., and A Typical Uhane.',
    games: ['Any'],
    official: 'No',
    tags: ['npc', 'occ', 'magic']
  },
  {
    id: '403',
    article: 'The Dark Realm of Netosa',
    author: ['Aaron Corley', 'Aaron Deskins'],
    artist: ['Paula Porter', 'Mark Dudley'],
    page: '75-86',
    issue: rifter46,
    issueTitle: 'The Rifter #46',
    image: './images/rifter46.jpg',
    summary: 'A short story full of excitement and betrayal.',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['story']
  },
  {
    id: '404',
    article: 'The Way Station',
    author: ['Mark Vernon'],
    artist: ['Apollo Okamura'],
    page: '87-91',
    issue: rifter46,
    issueTitle: 'The Rifter #46',
    image: './images/rifter46.jpg',
    summary: 'A wealth of information about Chaos Wizards and Zone Wizards, and the struggle to learn magic and create a safe haven in Blue Zones.',
    games: ['Chaos Earth'],
    official: 'No',
    tags: ['magic', 'spell', 'location']
  },
  {
    id: '405',
    article: 'Rifts Cargo Cults',
    author: ['John C. Philpott'],
    artist: ['Kent Burles'],
    page: '15-42',
    issue: rifter47,
    issueTitle: 'The Rifter #47',
    image: './images/rifter47.jpg',
    summary: "A walk on the bizarre and wild side of 'Cargo Cults' on Rifts Earth. Part religion, part magic and all strange. The Cargo Priest O.C.C., Cargo Magic, Supercargo Spells, Cargo Engineering Projects.",
    games: ['Rifts'],
    official: 'No',
    tags: ['occ', 'magic', 'spell']
  },
  {
    id: '406',
    article: 'The N.O.R.A.D. Duology, Part One: The Fall of N.O.R.A.D.',
    author: ['Ed Emmer'],
    artist: ['Nick Bradshaw'],
    page: '43-82',
    issue: rifter47,
    issueTitle: 'The Rifter #47',
    image: './images/rifter47.jpg',
    summary: 'A mind-boggling journey that starts out in the first few days of the Great Cataclysm. This adventure takes a look at what happened to N.O.R.A.D. when the Cataclysm struck. Various U.S.A.F. O.C.C.s, weapons, armor, vehicles, psionics and magic.',
    games: ['Chaos Earth', 'Rifts'],
    official: 'No',
    tags: ['occ', 'weapon', 'norad', 'adventure', 'armor', 'weapon', 'vehicle', 'psionic']
  },
  {
    id: '407',
    article: 'The Chain Letter',
    author: ['Greg Spivey'],
    artist: ['Amy L. Ashbaugh'],
    page: '83-92',
    issue: rifter47,
    issueTitle: 'The Rifter #47',
    image: './images/rifter47.jpg',
    summary: 'Another example of thinking outside the box and taking something we all know about and running with it in strange and unusual ways.',
    games: ['Any'],
    official: 'No',
    tags: ['gm']
  },
  {
    id: '408',
    article: 'Nightbane - Some Commonly Asked Questions',
    author: ['Mark Oberle', 'Irvin Jackson', 'Kevin Siembieda'],
    artist: [''],
    page: '22-24',
    issue: rifter48,
    issueTitle: 'The Rifter #48',
    image: './images/rifter48.jpg',
    summary: 'Answers to some commonly asked questions with official answers. Can Nightbane mate and reproduce? Horror Factor. Experience tables. Parrying supernatural strength.',
    games: ['Nightbane'],
    official: 'Yes',
    tags: ['qa', 'tips', 'rules']
  },
  {
    id: '409',
    article: 'The N.O.R.A.D. Duology, Part Two: Return to N.O.R.A.D.',
    author: ['Ed Emmer'],
    artist: ['Brian Manning', 'Allen Manning'],
    page: '25-63',
    issue: rifter48,
    issueTitle: 'The Rifter #48',
    image: './images/rifter48.jpg',
    summary: "The conclusion of an adventure that spans 300 years. A horror that has lurked in the belly of forgotten N.O.R.A.D. threatens the world again, and a new generation of heroes must put an end to the nightmare. N.O.R.A.D. maps, D'Yar R.C.C., Enoch R.C.C., A.R.C.H.I.E 2.5.",
    games: ['Chaos Earth', 'Rifts'],
    official: 'No',
    tags: ['adventure', 'rcc', 'archie', 'norad']
  },
  {
    id: '410',
    article: 'Scared Spitless',
    author: ['Winston Crutchfield'],
    artist: ['Kent Burles'],
    page: '64-76',
    issue: rifter48,
    issueTitle: 'The Rifter #48',
    image: './images/rifter48.jpg',
    summary: "Fascinating 'optional' Horror Factor rules that take the 'timid' out of intimidation. Covers monsters, but also skills that involve intimidation, reputation, environment, and combat.",
    games: ['Any'],
    official: 'No',
    tags: ['rules', 'gm', 'tips', 'skills']
  },
  {
    id: '411',
    article: 'Impersonator Zombies',
    author: ['Steven Dawes'],
    artist: ['Mike Mumah'],
    page: '77-79',
    issue: rifter48,
    issueTitle: 'The Rifter #48',
    image: './images/rifter48.jpg',
    summary: 'The eerie Zombie Aberration known as the Impersonator Zombie.',
    games: ['Dead Reign'],
    official: 'No',
    tags: ['monster', 'undead']
  },
  {
    id: '412',
    article: 'Of Cloth, Staff and Scripture',
    author: ['Reed Dees'],
    artist: [''],
    page: '80-92',
    issue: rifter48,
    issueTitle: 'The Rifter #48',
    image: './images/rifter48.jpg',
    summary: 'New and interesting ideas about clergy and religion in the Palladium Fantasy setting. New Priest class options include High Priest, Non-Spellcasting Priests, the Acolyte O.C.C., Spirit Monk, False Prophets and more.',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['occ', 'tips']
  },
  {
    id: '413',
    article: 'Evil GM Strats - Game Mastering suggestions and ideas',
    author: ['Chris Fox'],
    artist: ['Brian Manning', 'Allen Manning'],
    page: '20-21',
    issue: rifter49,
    issueTitle: 'The Rifter #49',
    image: './images/rifter49.jpg',
    summary: 'Some interesting strategies and ideas about leveling life and death situations at player characters and keeping the game fun and fair.',
    games: ['Any'],
    official: 'No',
    tags: ['gm', 'tips']
  },
  {
    id: '414',
    article: 'Princes of the Universe - Regomancy',
    author: ['Mark Hall'],
    artist: ['Mike Mumah'],
    page: '22-26',
    issue: rifter49,
    issueTitle: 'The Rifter #49',
    image: './images/rifter49.jpg',
    summary: 'A type of magic that benefits royalty and helps them in leading, protecting and influencing their people. What are the responsibilities of leaders? Can a sort of magic help them be better leaders?',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['magic']
  },
  {
    id: '415',
    article: 'The Free State of Lazlo',
    author: ['Jeff Woodman'],
    artist: ['Brian Manning', 'Allen Manning'],
    page: '27-35',
    issue: rifter49,
    issueTitle: 'The Rifter #49',
    image: './images/rifter49.jpg',
    summary: "A look at the history of the famed City-State of Lazlo, one of the great, magical kingdoms in Rifts North America. Details of its founding, its government, notable political factions, notable laws, Lazlo's Defense Force, and education.",
    games: ['Rifts'],
    official: 'No',
    tags: ['location']
  },
  {
    id: '416',
    article: 'Stage Magic Unlimited',
    author: ['Jake Marsh'],
    artist: ['Mike Mumah'],
    page: '36-42',
    issue: rifter49,
    issueTitle: 'The Rifter #49',
    image: './images/rifter49.jpg',
    summary: "A look at how Stage Magicians can use their powers to emulate true super abilities and psionics. Also looks at the value of having a Magician's assistant/partner, the use of trained animals, special gimmicks, and pyrotechnics.",
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['occ', 'psionics', 'magic']
  },
  {
    id: '417',
    article: 'Silent Saint',
    author: ['Frederic Christie'],
    artist: ['Mark Dudley'],
    page: '43-53',
    issue: rifter49,
    issueTitle: 'The Rifter #49',
    image: './images/rifter49.jpg',
    summary: 'A tale of chaos, demonic invasion, heroics, fame and adventure.',
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['story']
  },
  {
    id: '418',
    article: 'Vampires Revisited',
    author: ['Ed Woodward III'],
    artist: ['Nick Bradshaw', 'Kent Burles', 'Mike Mumah'],
    page: '54-90',
    issue: rifter49,
    issueTitle: 'The Rifter #49',
    image: './images/rifter49.jpg',
    summary: 'An in-depth look at, and optional rules, powers, and abilities for, vampires in the Nightbane setting. Types of vampires, Flawed Vampires, Near Vampires, weaknesses and limitations, natural abilities, optional rules, and tables.',
    games: ['Nightbane'],
    official: 'No',
    tags: ['rules', 'monster', 'undead', 'gm']
  },
  {
    id: '419',
    article: 'Taking Up the Mantle',
    author: ['Mark Oberle'],
    artist: ['Mark Dudley'],
    page: '15-26',
    issue: rifter50,
    issueTitle: 'The Rifter #50',
    image: './images/rifter50.jpg',
    summary: 'A look at the game, glory and infamy of super-heroes and the legacies they create for the next generation of heroes who try to follow in their footsteps. Tackles issues involving the purpose of legacies, passing the torch, types of legacies, the benefits, and possible detriments of legacies, building a legacy, fame, infamy, and more. Includes random tables.',
    games: ['Heroes Unlimited'],
    official: 'Yes',
    tags: ['gm', 'tips']
  },
  {
    id: '420',
    article: 'Mortificants, The Death Callers',
    author: ['Irvin L. Jackson'],
    artist: ['Kent Burles', 'Kathy Simmons', 'Kevin Siembieda', 'Wayne Smith'],
    page: '27-38',
    issue: rifter50,
    issueTitle: 'The Rifter #50',
    image: './images/rifter50.jpg',
    summary: 'A wicked, new magic O.C.C. known as the Mortificant, or Death Caller. They are a modern-day Necromancer who can animate corpses, create undead servants, and influence and control vampires. The Mortificant is also a master of Necromantic spells.',
    games: ['Nightbane'],
    official: 'Yes',
    tags: ['magic', 'occ', 'spell', 'undead']
  },
  {
    id: '421',
    article: 'The Free World Council',
    author: ['Braden Campbell'],
    artist: ['Apollo Okamura'],
    page: '39-45',
    issue: rifter50,
    issueTitle: 'The Rifter #50',
    image: './images/rifter50.jpg',
    summary: 'A look at the history, culture and machinations of the Free World Council (FWC), including their struggle to escape and remain free from Kreeghor domination, and the conflict around Axis-5. Data includes FWC Ranks, Heraldry and Uniforms, leader Rachael Klass, and an updated Freedom Fighter O.C.C.',
    games: ['Phase World'],
    official: 'Yes',
    tags: ['occ', 'npc']
  },
  {
    id: '422',
    article: 'Chaos Earth Psychics',
    author: ['Jason Richards'],
    artist: [''],
    page: '50-62',
    issue: rifter50,
    issueTitle: 'The Rifter #50',
    image: './images/rifter50.jpg',
    summary: "A continuation of the saga of the Great Cataclysm with a look at Chaos Earth psychics as an introduction to the much-awaited source book, 'Chaos Earth: Psychic Storm.' See how psionic powers and O.C.C.s emerge from the chaos and wreckage of a crumbling civilization. Charismatic O.C.C., Reactionary O.C.C., Teke Freak O.C.C.",
    games: ['Chaos Earth'],
    official: 'Yes',
    tags: ['occ', 'psionics']
  },
  {
    id: '423',
    article: 'Forced Choices',
    author: ['Brandon Aten', 'Matthew Orr'],
    artist: [''],
    page: '63-85',
    issue: rifter50,
    issueTitle: 'The Rifter #50',
    image: './images/rifter50.jpg',
    summary: 'Three new and unique types of Splicers and Bio-Armor. Gardener O.C.C. is a Splicer attuned to the forces of nature in general and plant life in particular. Tormentor O.C.C. is a new, menacing Splicer with the ability to inflict pain, extract the truth, and fight like a devil. The Geneticist O.C.C. is a Splicer much like a mobile Engineer or Gene-Pool; he can mutate, modify, and retool Splicer Bio-Armor and weapons, as well as create Splicer Homunculi. New Bio-Enhancements.',
    games: ['Splicers'],
    official: 'Yes',
    tags: ['occ', 'armor']
  },
  {
    id: '424',
    article: 'The Zodiac Mage',
    author: ['Carl Gleba'],
    artist: ['Amy L. Ashbaugh'],
    page: '86-99',
    issue: rifter50,
    issueTitle: 'The Rifter #50',
    image: './images/rifter50.jpg',
    summary: 'An intriguing Zodiac for the civilization of the Palladium World and a type of Elven magic to accompany it. Zodiac Mage, Star Magic.',
    games: ['Palladium Fantasy'],
    official: 'Yes',
    tags: ['occ', 'magic', 'spell']
  },
  {
    id: '425',
    article: 'A Challenger Has Appeared!',
    author: ['Taylor White'],
    artist: ['Nick Bradshaw'],
    page: '100-110',
    issue: rifter50,
    issueTitle: 'The Rifter #50',
    image: './images/rifter50.jpg',
    summary: 'Optional rules for Ninjas and Superspies. Includes many ideas and rules about how combat works, combat moves and modifiers for a vast array of situations and conditions, and more.',
    games: ['Ninjas and Superspies'],
    official: 'No',
    tags: ['adventure', 'combat', 'rules']
  },
  {
    id: '426',
    article: 'The Treasure Tree - A Rifts Logic Problem',
    author: ['Julius Rosenstein'],
    artist: [''],
    page: '111',
    issue: rifter50,
    issueTitle: 'The Rifter #50',
    image: './images/rifter50.jpg',
    summary: 'A fun little logic problem to tease your mind and test your ingenuity.',
    games: ['Rifts'],
    official: 'No',
    tags: ['gm']
  },
  {
    id: '427',
    article: 'Vehicle Construction Rules, Part One',
    author: ['Greg Diaczyk'],
    artist: ['Nick Bradshaw'],
    page: '112-122',
    issue: rifter50,
    issueTitle: 'The Rifter #50',
    image: './images/rifter50.jpg',
    summary: 'Part One of a comprehensive set of optional rules for spicing up your Rifts Operator and making custom vehicles.',
    games: ['Rifts'],
    official: 'No',
    tags: ['rules', 'occ', 'vehicle']
  },
  {
    id: '428',
    article: 'Role-Playing with Younger Players - Game Master Tips for All Game Systems',
    author: ['William Waymouth II'],
    artist: ['Mark Dudley'],
    page: '10-18',
    issue: rifter51,
    issueTitle: 'The Rifter #51',
    image: './images/rifter51.jpg',
    summary: 'Elements and aspects of role playing that should be considered when gaming with youngsters.',
    games: ['Any'],
    official: 'No',
    tags: ['tips', 'gm']
  },
  {
    id: '429',
    article: 'Living Weapons',
    author: ['Chris Kluge', 'Charles Walton'],
    artist: ['Charles Walton II'],
    page: '19-39',
    issue: rifter51,
    issueTitle: 'The Rifter #51',
    image: './images/rifter51.jpg',
    summary: "Includes two new O.C.C.s: the Metamorph, a Splicer shapeshifter, and the Swarm Lord, which utilizes insects as part of the armor's design and powers.",
    games: ['Splicers'],
    official: 'No',
    tags: ['occ', 'monster', 'armor']
  },
  {
    id: '430',
    article: "Mundane Doesn't Mean Boring!",
    author: ['Leamon Crafton Jr.'],
    artist: ['Mike Mumah'],
    page: '40-52',
    issue: rifter51,
    issueTitle: 'The Rifter #51',
    image: './images/rifter51.jpg',
    summary: 'Observations and tips on how to make what may seem like the mundane and ordinary, into an adventure that is challenging, clever, suspenseful, and fun. Includes new skills, scientists, attitude, skepticism, armor, trauma, and flexibility.',
    games: ['Any'],
    official: 'No',
    tags: ['gm', 'tips', 'skills', 'armor']
  },
  {
    id: '431',
    article: 'Wolf Blood',
    author: ['Shawn Arbuckle'],
    artist: ['Amy L. Ashbaugh'],
    page: '53-57',
    issue: rifter51,
    issueTitle: 'The Rifter #51',
    image: './images/rifter51.jpg',
    summary: 'A look at an ancient group of humans known as the Vulbund O.C.C., their culture, secret knowledge and abilities.',
    games: ['Rifts'],
    official: 'No',
    tags: ['occ']
  },
  {
    id: '432',
    article: 'Rifts Triax 2 Weapons Locker',
    author: ['Brandon Aten', 'Kevin Siembieda'],
    artist: ['Brian Manning', 'Allen Manning', 'Nicholas Maradin'],
    page: '58-71',
    issue: rifter51,
    issueTitle: 'The Rifter #51',
    image: './images/rifter51.jpg',
    summary: 'More Triax weapons, robot drones, and cyborgs to add to the wealth of weapons, gear and information already found in Rifts World Books 5 and 31.',
    games: ['Rifts'],
    official: 'Yes',
    tags: ['weapon', 'equipment']
  },
  {
    id: '433',
    article: 'Rifts Vehicle Construction Rules, Part 2',
    author: ['Greg Diaczyk'],
    artist: ['Mark Dudley'],
    page: '72-87',
    issue: rifter51,
    issueTitle: 'The Rifter #51',
    image: './images/rifter51.jpg',
    summary: 'More suggestions for making, building and modifying vehicles in the Rifts setting.',
    games: ['Rifts'],
    official: 'No',
    tags: ['tips', 'gm', 'vehicle']
  },
  {
    id: '434',
    article: 'The Crusaders and The Black Crusade (Tattoo Magic)',
    author: ['Andrew Lander'],
    artist: ['Nick Bradshaw'],
    page: '18-59',
    issue: rifter52,
    issueTitle: 'The Rifter #52',
    image: './images/rifter52.jpg',
    summary: 'A pair of short stories followed up with source material about True Atlanteans and Tattoo Magic. Additional O.C.C.s',
    games: ['Rifts'],
    official: 'No',
    tags: ['story', 'occ', 'magic', 'spell', 'tattoo']
  },
  {
    id: '435',
    article: 'Cannibal Magic',
    author: ['Paul Herbert'],
    artist: ['Kent Burles'],
    page: '60-63',
    issue: rifter52,
    issueTitle: 'The Rifter #52',
    image: './images/rifter52.jpg',
    summary: 'A recipe for murder and magic in the Palladium Fantasy setting - Cannibal Magic. Yum.',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['magic', 'spell']
  },
  {
    id: '436',
    article: 'From Ruins to Runes',
    author: ['Travis Guerrero'],
    artist: ['Kent Burles'],
    page: '64-89',
    issue: rifter52,
    issueTitle: 'The Rifter #52',
    image: './images/rifter52.jpg',
    summary: 'An array of ancient and powerful Rune Weapons from the days of the Elf-Dwarf War. Living Rune Weapons that transcend being mere magic items. Rune Weapons that not only contain an intelligence and personality, but a physical humanoid form and R.C.C.',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['rcc', 'rune', 'weapon', 'occ']
  },
  {
    id: '437',
    article: 'The Lucky Psychic',
    author: ['Steven Dawes'],
    artist: ['Joseph Lawn'],
    page: '17-24',
    issue: rifter53,
    issueTitle: 'The Rifter #53',
    image: './images/rifter53.jpg',
    summary: "An unusual, but fun and interesting new P.C.C. to consider in your Beyond the Supernatural campaigns. Includes special 'luck' abilities and plenty of cool ideas, plus an example of the Lucky Psychic as a NPC.",
    games: ['Beyond the Supernatural'],
    official: 'No',
    tags: ['pcc', 'psionic', 'npc']
  },
  {
    id: '438',
    article: 'Dark Day Chronicles, Volume One - Short Story for Nightbane',
    author: ['Jeremy Hutchins'],
    artist: ['Nick Bradshaw'],
    page: '25-31',
    issue: rifter53,
    issueTitle: 'The Rifter #53',
    image: './images/rifter53.jpg',
    summary: 'A dynamic story that will make your heart race and give you ideas for your own Nightbane campaign.',
    games: ['Nightbane'],
    official: 'No',
    tags: ['story']
  },
  {
    id: '439',
    article: 'A.R.C.H.I.E. Phase Two',
    author: ['Damon Sutton'],
    artist: ['Brian Manning', 'Allen Manning'],
    page: '32-44',
    issue: rifter53,
    issueTitle: 'The Rifter #53',
    image: './images/rifter53.jpg',
    summary: 'More of the twisted plots, plans, and brilliant madness of A.R.C.H.I.E. Three. Source material includes new schemes and plots, new androids, learning about the supernatural, fake magic and more.',
    games: ['Rifts'],
    official: 'No',
    tags: ['archie', 'magic', 'shemarrian']
  },
  {
    id: '440',
    article: 'On Faerie Folk',
    author: ['Michael P. Yocom'],
    artist: ['Nick Bradshaw', 'Kent Burles'],
    page: '45-60',
    issue: rifter53,
    issueTitle: 'The Rifter #53',
    image: './images/rifter53.jpg',
    summary: 'A fascinating collection of Faerie Folk, their cousins and a few unusual animals.',
    games: ['Rifts', 'Palladium Fantasy'],
    official: 'No',
    tags: ['monster']
  },
  {
    id: '441',
    article: 'Dawn of a New Era, Part One',
    author: ['Corey Livermore'],
    artist: ['Mike Mumah'],
    page: '61-87',
    issue: rifter53,
    issueTitle: 'The Rifter #53',
    image: './images/rifter53.jpg',
    summary: 'An epic adventure for Heroes Unlimited where the players will have to solve a mystery, smash a conspiracy, and nab the bad guys.',
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['adventure']
  },
  {
    id: '442',
    article: 'Ravages of Time - Game Master tips for long Rifts campaigns',
    author: ['S.E. Gibbons'],
    artist: ['Apollo Okamura'],
    page: '88-91',
    issue: rifter53,
    issueTitle: 'The Rifter #53',
    image: './images/rifter53.jpg',
    summary: 'Ideas, suggestions and techniques for playing through long campaign scenarios like the Coalition Wars: Siege on Tolkeen series.',
    games: ['Rifts'],
    official: 'No',
    tags: ['tips', 'gm']
  },
  {
    id: '443',
    article: 'A Megaversal Menagerie',
    author: ['Aaron Corley'],
    artist: ['Nick Bradshaw', 'Joseph Lawn'],
    page: '16-29',
    issue: rifter54,
    issueTitle: 'The Rifter #54',
    image: './images/rifter54.jpg',
    summary: 'A zoological menagerie of strange beings, monsters and a couple animals you can drop into your campaigns to shake things up.',
    games: ['Rifts', 'Palladium Fantasy'],
    official: 'No',
    tags: ['monster']
  },
  {
    id: '444',
    article: 'Dark Day Chronicles, Volume Two - A Short Story for Nightbane',
    author: ['Jeremy Hutchins'],
    artist: ['Mark Dudley'],
    page: '30-36',
    issue: rifter54,
    issueTitle: 'The Rifter #54',
    image: './images/rifter54.jpg',
    summary: 'A new story of angels, terror, self-discovery and adventure in the world of the Nightbane.',
    games: ['Nightbane'],
    official: 'No',
    tags: ['story']
  },
  {
    id: '445',
    article: 'Dawn of a New Era, Part Two',
    author: ['Corey Livermore'],
    artist: ['Mike Mumah'],
    page: '37-49',
    issue: rifter54,
    issueTitle: 'The Rifter #54',
    image: './images/rifter54.jpg',
    summary: 'The conclusion of this Heroes Unlimited setting in which the existence of super-beings and aliens has recently been revealed to the human population. Your heroes are framed for an attack on a space shuttle. They must prove their innocence by uncovering a conspiracy, finding the real culprit and bringing him to justice.',
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['adventure']
  },
  {
    id: '446',
    article: 'New Chillicothe',
    author: ['Matthew Olfson'],
    artist: ['Brian Manning', 'Allen Manning', 'Kent Burles'],
    page: '50-90',
    issue: rifter54,
    issueTitle: 'The Rifter #54',
    image: './images/rifter54.jpg',
    summary: 'Describes how a Coalition fortress city is built and operates. Also describes many notable characters, as well as consumer electronics galore, and other specialized tech gear.',
    games: ['Rifts'],
    official: 'No',
    tags: ['cs', 'npc', 'coalition', 'equipment']
  },
  {
    id: '447',
    article: 'Home Away from Home',
    author: ['Travis Guerrero'],
    artist: ['Mike Mumah'],
    page: '18-29',
    issue: rifter55,
    issueTitle: 'The Rifter #55',
    image: './images/rifter55.jpg',
    summary: 'Bold insight about the strange and magical race of beings known as the Quorians. An exploration of their roots, language, society, and culture which includes some surprises like the Quorian Riftlord R.C.C. Adventure ideas.',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['rcc', 'adventure']
  },
  {
    id: '448',
    article: 'Ancestral Mystic R.C.C.',
    author: ['Paul Herbert'],
    artist: ['Kent Burles'],
    page: '30-35',
    issue: rifter55,
    issueTitle: 'The Rifter #55',
    image: './images/rifter55.jpg',
    summary: "A lost mystic art from the Time of a Thousand Magicks known as Ancestral Mysticism. A magic that draws upon the knowledge and powers of the mage's ancestors.",
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['rcc', 'magic', 'spell']
  },
  {
    id: '449',
    article: 'Souls',
    author: ['Jonathan Farnham'],
    artist: ['Joseph Lawn'],
    page: '36-37',
    issue: rifter55,
    issueTitle: 'The Rifter #55',
    image: './images/rifter55.jpg',
    summary: 'A few new magic spells that draw upon or steal souls.',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['magic', 'spell']
  },
  {
    id: '450',
    article: 'Dark Day Chronicles, Volume Three - A Short Story for Nightbane',
    author: ['Jeremy Hutchins'],
    artist: ['Mike Leonard'],
    page: '38-46',
    issue: rifter55,
    issueTitle: 'The Rifter #55',
    image: './images/rifter55.jpg',
    summary: 'More tales of the Nightbane after Dark Day as they learn about their powers and the supernatural world of demons and evil that has leached into our world.',
    games: ['Nightbane'],
    official: 'No',
    tags: ['story']
  },
  {
    id: '451',
    article: 'Triax Update - Revised O.C.C.s from Rifts World Book 5',
    author: ['Brandon Aten'],
    artist: ['Kevin Long'],
    page: '47-60',
    issue: rifter55,
    issueTitle: 'The Rifter #55',
    image: './images/rifter55.jpg',
    summary: 'Updates to the Military O.C.C.s of the New German Republic, adding skills from Rifts Ultimate Edition plus a few new ones.',
    games: ['Rifts'],
    official: 'No',
    tags: ['occ', 'ngr', 'triax', 'skills']
  },
  {
    id: '452',
    article: 'The Cutting Room Floor: The CCW - Material for Rifts Thundercloud Galaxy',
    author: ['Braden Campbell', 'Kevin Siembieda'],
    artist: ['Mike Mumah'],
    page: '61-68',
    issue: rifter55,
    issueTitle: 'The Rifter #55',
    image: './images/rifter55.jpg',
    summary: "Some text and history that didn't make it into Rifts Dimension Book 14: Thundercloud Galaxy. Provides some insight about the Consortium of Civilized Worlds and their efforts in the Scramble for the Thundercloud.",
    games: ['Rifts', 'Phase World'],
    official: 'Yes',
    tags: ['ccw']
  },
  {
    id: '453',
    article: 'The Black Crusade, Part Two: The Methodeans',
    author: ['Andrew Lander'],
    artist: ['Joseph Lawn'],
    page: '69-85',
    issue: rifter55,
    issueTitle: 'The Rifter #55',
    image: './images/rifter55.jpg',
    summary: 'More dimension spanning intrigue, adventure ideas and alien races. Zuthxiou R.C.C.',
    games: ['Rifts', 'Phase World'],
    official: 'No',
    tags: ['rcc', 'adventure']
  },
  {
    id: '454',
    article: 'Sweet Vengeance',
    author: ['Glen Evans'],
    artist: ['Mark Dudley'],
    page: '86-92',
    issue: rifter55,
    issueTitle: 'The Rifter #55',
    image: './images/rifter55.jpg',
    summary: 'A thrilling tale of courage and survival set in the gladiatorial arenas of Atlantis.',
    games: ['Rifts'],
    official: 'No',
    tags: ['location', 'story']
  },
  {
    id: '455',
    article: 'The Solar System',
    author: ["Ovid 'O.J.' Pinckert"],
    artist: ['Mike Mumah'],
    page: '17-36',
    issue: rifter56,
    issueTitle: 'The Rifter #56',
    image: './images/rifter56.jpg',
    summary: "An expansion upon the orbital community around Rifts Earth and beyond. Not just the orbital community, but alien invaders and a few key places within the Earth's solar system.",
    games: ['Rifts'],
    official: 'No',
    tags: ['adventure', 'location']
  },
  {
    id: '456',
    article: 'Time Travel',
    author: ['Greg Spivey', 'Jason Smith'],
    artist: ['Nick Bradshaw', 'Kent Burles', 'Mark Dudley'],
    page: '37-72',
    issue: rifter56,
    issueTitle: 'The Rifter #56',
    image: './images/rifter56.jpg',
    summary: 'A new look at time travel and the associated dangers that come with it. Absconder O.C.C., Obrkah R.C.C., NPCs, Spells, Psionics, and more.',
    games: ['Rifts', 'Phase World', 'Heroes Unlimited'],
    official: 'No',
    tags: ['occ', 'rcc', 'npc', 'magic', 'spells', 'psionics']
  },
  {
    id: '457',
    article: 'The Tainted Martyr',
    author: ['Steven Dawes'],
    artist: ['Nick Bradshaw'],
    page: '73-85',
    issue: rifter56,
    issueTitle: 'The Rifter #56',
    image: './images/rifter56.jpg',
    summary: 'A truly unique and tortured hero for the world of Beyond the Supernatural. Tainted Martyr P.C.C., adventure.',
    games: ['Beyond the Supernatural'],
    official: 'No',
    tags: ['pcc', 'adventure']
  },
  {
    id: '458',
    article: 'Dark Day Chronicles, Volume IV - A Short Story for Nightbane',
    author: ['Jeremy M. Hutchins'],
    artist: ['Kent Burles'],
    page: '86-94',
    issue: rifter56,
    issueTitle: 'The Rifter #56',
    image: './images/rifter56.jpg',
    summary: 'More tales of the Nightbane after Dark Day as they learn about their powers and the supernatural world of demons, monsters and evil that has leached into our world.',
    games: ['Nightbane'],
    official: 'No',
    tags: ['story', 'monster']
  },
  {
    id: '459',
    article: 'The Rifter Creature Feature',
    author: ['Steven Dawes'],
    artist: ['Nick Bradshaw'],
    page: '20-33',
    issue: rifter57,
    issueTitle: 'The Rifter #57',
    image: './images/rifter57.jpg',
    summary: 'More supernatural monsters and disgusting creatures.',
    games: ['Beyond the Supernatural'],
    official: 'No',
    tags: ['monster']
  },
  {
    id: '460',
    article: 'Weapons and Tech of the Coalition States',
    author: ['Matt Olfson'],
    artist: ['Brian Manning', 'Allen Manning'],
    page: '34-49',
    issue: rifter57,
    issueTitle: 'The Rifter #57',
    image: './images/rifter57.jpg',
    summary: 'A few new vehicles and weapons developed by the CS Military Research and Development Department.',
    games: ['Rifts'],
    official: 'No',
    tags: ['weapon', 'coalition', 'cs']
  },
  {
    id: '461',
    article: 'Fantastic Creatures',
    author: ['Glen Evans'],
    artist: ['Nick Bradshaw', 'Kent Burles', 'Mike Mumah'],
    page: '50-75',
    issue: rifter57,
    issueTitle: 'The Rifter #57',
    image: './images/rifter57.jpg',
    summary: 'A wicked array of monsters and exotic creatures from the Palladium World - but also with Rifts stat conversions.',
    games: ['Palladium Fantasy', 'Rifts'],
    official: 'No',
    tags: ['monster']
  },
  {
    id: '462',
    article: 'The NGR Anthropological Field Operative',
    author: ['Michael Lord'],
    artist: ['Mike Mumah'],
    page: '76-78',
    issue: rifter57,
    issueTitle: 'The Rifter #57',
    image: './images/rifter57.jpg',
    summary: 'A new NGR O.C.C. that studies alien life forms and their customs.',
    games: ['Rifts'],
    official: 'No',
    tags: ['ngr', 'occ']
  },
  {
    id: '463',
    article: 'The Brodkil War Machinist',
    author: ['Michael Lord'],
    artist: ['Michael Wilson'],
    page: '79-81',
    issue: rifter57,
    issueTitle: 'The Rifter #57',
    image: './images/rifter57.jpg',
    summary: 'A unique look at an O.C.C. within the Brodkil sub-demons, a sort of demon mechanic.',
    games: ['Rifts'],
    official: 'No',
    tags: ['occ']
  },
  {
    id: '464',
    article: "Spacia's Bottles",
    author: ['N.D.T. Lyons'],
    artist: ['Mike Mumah'],
    page: '82-92',
    issue: rifter57,
    issueTitle: 'The Rifter #57',
    image: './images/rifter57.jpg',
    summary: 'A study on Dimensional Pocket Worlds and the tiny containers that can conceal them. Not to mention the dragon who specializes in such things, Spacia, Mistress of Dimensions.',
    games: ['Rifts'],
    official: 'No',
    tags: ['npc']
  },
  {
    id: '465',
    article: 'The Free State of Lazlo',
    author: ['J. Woodman'],
    artist: ['Kent Burles'],
    page: '17-35',
    issue: rifter58,
    issueTitle: 'The Rifter #58',
    image: './images/rifter58.jpg',
    summary: 'Information about the magic kingdom of Lazlo, its people, society, defenses and relationships with other political powers in North America.',
    games: ['Rifts'],
    official: 'No',
    tags: ['location']
  },
  {
    id: '466',
    article: 'New Faeries, People and Undead',
    author: ['Glen Evans'],
    artist: ['Mike Mumah', 'Mike Leonard', 'Mark Dudley'],
    page: '36-54',
    issue: rifter58,
    issueTitle: 'The Rifter #58',
    image: './images/rifter58.jpg',
    summary: 'Another array of strange and deadly people, Faerie Folk and monsters from the Palladium World.',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['monster', 'undead']
  },
  {
    id: '467',
    article: 'The Kezel',
    author: ['Joseph Larsen'],
    artist: ['Ben Rodriguez'],
    page: '55-67',
    issue: rifter58,
    issueTitle: 'The Rifter #58',
    image: './images/rifter58.jpg',
    summary: 'The strange and exotic Kezel, mysterious beings who seem to be human or of human origin but possess an array of superhuman and magical powers.',
    games: ['Rifts', 'Phase World'],
    official: 'No',
    tags: ['magic']
  },
  {
    id: '468',
    article: 'Dark Day Chronicles, Volume V - A Short Story for Nightbane',
    author: ['Jeremy M. Hutchins'],
    artist: ['Nick Bradshaw'],
    page: '68-74',
    issue: rifter58,
    issueTitle: 'The Rifter #58',
    image: './images/rifter58.jpg',
    summary: 'Another chapter in the life of the Nightbane in the aftermath of Dark Day.',
    games: ['Nightbane'],
    official: 'No',
    tags: ['story']
  },
  {
    id: '469',
    article: 'Lemuria O.C.C.s',
    author: ['Matthew Clements'],
    artist: ['Nick Bradshaw', 'Brian Manning', 'Allen Manning', 'Chuck Walton'],
    page: '75-84',
    issue: rifter58,
    issueTitle: 'The Rifter #58',
    image: './images/rifter58.jpg',
    summary: 'Character classes, symbiotes and Special O.C.C. Abilities for Rifts Lemuria. Academic O.C.C., Citizen O.C.C., Experimenter O.C.C., Healer O.C.C.',
    games: ['Rifts'],
    official: 'Yes',
    tags: ['occ']
  },
  {
    id: '470',
    article: 'Lemuria: Notable Creatures of the Sea',
    author: ['Greg Diaczyk', 'Kevin Siembieda'],
    artist: ['Nick Bradshaw'],
    page: '85-96',
    issue: rifter58,
    issueTitle: 'The Rifter #58',
    image: './images/rifter58.jpg',
    summary: 'Stats for a wide range of common animals along with some mutant variations.',
    games: ['Rifts'],
    official: 'Yes',
    tags: ['monster']
  },
  {
    id: '471',
    article: 'The Pack Mentality',
    author: ['Brandon Aten', 'Michael Orr'],
    artist: ['Charles Walton'],
    page: '18-29',
    issue: rifter59,
    issueTitle: 'The Rifter #59',
    image: './images/rifter59.jpg',
    summary: 'An in-depth look at Splicer Gorehounds and Packmasters, including new types of Bio-Enhancements, dominant breeds of Gorehounds, new Bio-Tech collars, barding and more.',
    games: ['Splicers'],
    official: 'No',
    tags: ['biotech', 'equipment', 'monster']
  },
  {
    id: '472',
    article: 'The Kezel, Continued',
    author: ['Joseph Larsen'],
    artist: [''],
    page: '30-40',
    issue: rifter59,
    issueTitle: 'The Rifter #59',
    image: './images/rifter59.jpg',
    summary: 'The conclusion of a two-part feature about the strange and mysterious Kezel, beings who seem to be human or of human origin but possess an array of superhuman and magical powers.',
    games: ['Rifts', 'Phase World'],
    official: 'No',
    tags: ['race', 'magic']
  },
  {
    id: '473',
    article: 'Creatures of the Xiticix Hivelands',
    author: ['Josh Sinsapaugh'],
    artist: ['Ben Rodriguez'],
    page: '41-49',
    issue: rifter59,
    issueTitle: 'The Rifter #59',
    image: './images/rifter59.jpg',
    summary: 'New information about the Xiticix, a new, different type of Xiticix, and other creatures, weapons and data found in the Hivelands.',
    games: ['Rifts'],
    official: 'No',
    tags: ['monster', 'xiticix', 'weapon']
  },
  {
    id: '474',
    article: 'Techno-Wizardry Throughout the Megaverse',
    author: ['Anthony Lovato'],
    artist: ['Joseph Lawn'],
    page: '50-71',
    issue: rifter59,
    issueTitle: 'The Rifter #59',
    image: './images/rifter59.jpg',
    summary: 'An extensive look at Techno-Wizardry across the Megaverse and a wealth of new Techno-Wizard weapons, armor and devices, as well as new Biomech animals and adventure ideas.',
    games: ['Rifts', 'Phase World'],
    official: 'No',
    tags: ['tw', 'technowizard', 'adventure', 'weapon', 'bio']
  },
  {
    id: '475',
    article: 'The Lion, The Ditch and The Warlock',
    author: ['Paul Herbert'],
    artist: [''],
    page: '72-89',
    issue: rifter59,
    issueTitle: 'The Rifter #59',
    image: './images/rifter59.jpg',
    summary: 'A fun adventure set during the Olympic-style games held on the island of Lopan.',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['adventure', 'location']
  },
  {
    id: '476',
    article: 'Explosives Data',
    author: ['Thomas Morrison'],
    artist: ['Mike Mumah'],
    page: '90-97',
    issue: rifter59,
    issueTitle: 'The Rifter #59',
    image: './images/rifter59.jpg',
    summary: 'A look at the many types of explosives, how they work, and optional rules for the damage they inflict (in game terms).',
    games: ['Rifts'],
    official: 'No',
    tags: ['weapon']
  },
  {
    id: '477',
    article: 'Kids Game: Something Wonderful!',
    author: ['Hendrik Harterich'],
    artist: [''],
    page: '20-24',
    issue: rifter60,
    issueTitle: 'The Rifter #60',
    image: './images/rifter60.jpg',
    summary: "A wonderful 'how to' for introducing young gamers (including girls) to the world of role-playing games.",
    games: ['Any'],
    official: 'No',
    tags: ['gm', 'tips']
  },
  {
    id: '478',
    article: 'House Pandorum',
    author: ['Kris Tipping'],
    artist: ['Mark Dudley', 'Chuck Walton', 'Mike Mumah'],
    page: '25-44',
    issue: rifter60,
    issueTitle: 'The Rifter #60',
    image: './images/rifter60.jpg',
    summary: 'A dynamic trip to the world of Splicers where we learn about House Pandorum and its history, goals, notable people. spliced creations, mutants, monsters and more.',
    games: ['Splicers'],
    official: 'No',
    tags: ['story', 'location', 'npc', 'monster']
  },
  {
    id: '479',
    article: 'Trust and Intimidation: A Way of Life',
    author: ['Liam Gray'],
    artist: ['Kent Burles'],
    page: '45-48',
    issue: rifter60,
    issueTitle: 'The Rifter #60',
    image: './images/rifter60.jpg',
    summary: 'An article about the M.A. (Mental Affinity) attribute and the use of trust and intimidation in role-playing.',
    games: ['Any'],
    official: 'No',
    tags: ['stat', 'rules', 'gm', 'tips']
  },
  {
    id: '480',
    article: "Sorcerer's Forge",
    author: ['Timothy Dorman', 'Kevin Siembieda'],
    artist: ['Brian Manning', 'Allen Manning', 'Ben Rodriguez'],
    page: '49-76',
    issue: rifter60,
    issueTitle: 'The Rifter #60',
    image: './images/rifter60.jpg',
    summary: "A comprehensive Rifts city-state set in North America. It's a little-known corner of the world where a hidden society of Techno-Wizards live in secret and security. The history, characters, and TW creations can make a fun addition to any game. Some O.C.C.s, D-Bees, TW weapons, vehicles and equipment.",
    games: ['Rifts'],
    official: 'No',
    tags: ['location', 'tw', 'technowizard', 'npc', 'occ', 'weapon', 'armor', 'vehicle', 'adventure', 'dbee']
  },
  {
    id: '481',
    article: 'CSV New Hope',
    author: ['Thomas Morrison'],
    artist: ['Joseph Lawn'],
    page: '77-93',
    issue: rifter60,
    issueTitle: 'The Rifter #60',
    image: './images/rifter60.jpg',
    summary: 'An epic adventure setting and outline that starts in outer space with a group of alien superheroes, and boldly goes where adventure abounds. Floor plans for the starship, CSV Hope.',
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['adventure']
  },
  {
    id: '482',
    article: 'Strange Things in the Bootheel - A Short Story',
    author: ['J.V. Adams'],
    artist: ['Mike Mumah'],
    page: '94-97',
    issue: rifter60,
    issueTitle: 'The Rifter #60',
    image: './images/rifter60.jpg',
    summary: 'A strange little tale of coincidence and things that go bump in the night.',
    games: ['Nightbane', 'Beyond the Supernatural', 'Heroes Unlimited'],
    official: 'No',
    tags: ['story']
  },
  {
    id: '483',
    article: 'The Crusaders and the Black Crusade Part 3: Vergence',
    author: ['Andrew Lander'],
    artist: ['Mark Dudley', 'Andrew Lander'],
    page: '17-37',
    issue: rifter61,
    issueTitle: 'The Rifter #61',
    image: './images/rifter61.jpg',
    summary: 'More setting and source material for Phase World and the Three Galaxies. World information, places of interest, new types of Atlanteans, and lots and lots of magic: magic staves, new magic tattoos, Stone Magic, and much more.',
    games: ['Rifts', 'Phase world'],
    official: 'No',
    tags: ['location', 'magic', 'tattoo']
  },
  {
    id: '484',
    article: 'The City of Charter',
    author: ['John Meyers'],
    artist: ['Kent Burles'],
    page: '38-47',
    issue: rifter61,
    issueTitle: 'The Rifter #61',
    image: './images/rifter61.jpg',
    summary: 'The City of Charter in Rifts New England. Background, key characters, notable places, more True Atlanteans, Techno-Wizardry and more.',
    games: ['Rifts'],
    official: 'No',
    tags: ['location', 'technowizard', 'tw', 'npc', 'armor']
  },
  {
    id: '485',
    article: 'Purebred Animals for Mutants in Avalon',
    author: ['Ian Herbert'],
    artist: ['Tanya Ramsey'],
    page: '48-65',
    issue: rifter61,
    issueTitle: 'The Rifter #61',
    image: './images/rifter61.jpg',
    summary: 'An array of unique mutant animals common to the British Isles and suitable as mutants, aliens, monsters and heroes.',
    games: ['After the Bomb', 'Heroes Unlimited'],
    official: 'No',
    tags: ['monster', 'mutant', 'location']
  },
  {
    id: '486',
    article: 'Defense of the Realm',
    author: ['Alex Tulloch'],
    artist: ['Joseph Lawn'],
    page: '66-79',
    issue: rifter61,
    issueTitle: 'The Rifter #61',
    image: './images/rifter61.jpg',
    summary: 'The superhero organization called C.A.M.E.L.O.T., the British equivalent of S.C.R.E.T. There is background info about the organization, its goals, key individuals, field agents, super vehicles, super-weapons, equipment and adventure ideas.',
    games: ['Rifts'],
    official: 'No',
    tags: ['scret', 'camelot', 'npc', 'adventure', 'weapon', 'armor', 'vehicle']
  },
  {
    id: '487',
    article: 'The Heart Taker',
    author: ['W. Bachman'],
    artist: [''],
    page: '80-87',
    issue: rifter61,
    issueTitle: 'The Rifter #61',
    image: './images/rifter61.jpg',
    summary: 'A pulse-pounding tale of adventure and intrigue.',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['story']
  },
  {
    id: '488',
    article: 'Charm and Impress: The Key to Success',
    author: ['Liam Gray', 'Kevin Siembieda'],
    artist: ['Benjamin Rodriguez'],
    page: '88-97',
    issue: rifter61,
    issueTitle: 'The Rifter #61',
    image: './images/rifter61.jpg',
    summary: 'A comprehensive article about the P.B. (Physical Beauty) attribute and the use of Charm and Impress (and a bit about the Seduction skill) for use in role-playing game adventures. Especially useful with the Rifts Black Market Sourcebook.',
    games: ['Rifts'],
    official: 'No',
    tags: ['stat', 'skill', 'gm', 'tips', 'blackmarket']
  },
  {
    id: '489',
    article: 'Deathspike and the Vampire Lands',
    author: ['Matthew Clements', 'Kevin Siembieda'],
    artist: ['Kent Burles', 'Nick Bradshaw', 'Kevin Long'],
    page: '20-35',
    issue: rifter62,
    issueTitle: 'The Rifter #62',
    image: './images/rifter62.jpg',
    summary: 'More official source material for your Rifts campaigns set in the Vampire Kingdoms and the Yucatan. Deathspike Infiltrator/Observer O.C.C., Deathspike Werewolf Agent O.C.C., Hook, Line and Sinker adventures.',
    games: ['Rifts'],
    official: 'Yes',
    tags: ['occ', 'adventure', 'location', 'vampire', 'undead']
  },
  {
    id: '490',
    article: 'Dark Magic - New Rifts Necromancy Spells',
    author: ['Jeff Duncan'],
    artist: ['Tanya J. Ramsey'],
    page: '36-45',
    issue: rifter62,
    issueTitle: 'The Rifter #62',
    image: './images/rifter62.jpg',
    summary: '26 new Necromancy spells and magic.',
    games: ['Rifts'],
    official: 'Yes',
    tags: ['magic', 'spell']
  },
  {
    id: '491',
    article: 'Experience Tables',
    author: ['Kevin Siembieda'],
    artist: [''],
    page: '46',
    issue: rifter62,
    issueTitle: 'The Rifter #62',
    image: './images/rifter62.jpg',
    summary: 'Unpublished experience tables for Rifts Black Market and Vampire Kingdoms',
    games: ['Rifts'],
    official: 'Yes',
    tags: ['tools', 'gm', 'blackmarket']
  },
  {
    id: '492',
    article: 'Rifts Northern Gun Preview',
    author: ['Matthew Clements', 'Kevin Siembieda'],
    artist: ['Charles Walton'],
    page: '47-49',
    issue: rifter62,
    issueTitle: 'The Rifter #62',
    image: './images/rifter62.jpg',
    summary: 'The Gunbot Robot-Killer. One of many new, cool robots, weapons, and gear in Rifts Northern Gun One.',
    games: ['Rifts'],
    official: 'Yes',
    tags: ['weapon', 'equipment']
  },
  {
    id: '493',
    article: 'World Association of Super-Humans',
    author: ['Thomas Morrison'],
    artist: [''],
    page: '50-60',
    issue: rifter62,
    issueTitle: 'The Rifter #62',
    image: './images/rifter62.jpg',
    summary: 'The international superhero organization WASH and how it works with other world agencies such as INTERPOL. Background info about the organization, its goals, key individuals, field agents, and place in the world.',
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['interpol', 'wash', 'npc']
  },
  {
    id: '494',
    article: 'Climbing Skill Expanded',
    author: ['Michael Strom'],
    artist: ['Benjamin Rodriguez'],
    page: '61-64',
    issue: rifter62,
    issueTitle: 'The Rifter #62',
    image: './images/rifter62.jpg',
    summary: 'A closer look at the Climbing skill and its many applications in the worlds of role-playing.',
    games: ['Any'],
    official: 'No',
    tags: ['skill', 'gm', 'tips', 'rules']
  },
  {
    id: '495',
    article: 'Castle Sturmgard',
    author: ['Michael Long'],
    artist: ['Michael Long'],
    page: '65-93',
    issue: rifter62,
    issueTitle: 'The Rifter #62',
    image: './images/rifter62.jpg',
    summary: 'The layout for a castle and sprawling castle compound, complete with descriptive notes and setting ideas.',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['location', 'map']
  },
  {
    id: '496',
    article: "Doc Reid's Vampire Survival Guide",
    author: ['Doc Reid'],
    artist: [''],
    page: '94-95',
    issue: rifter62,
    issueTitle: 'The Rifter #62',
    image: './images/rifter62.jpg',
    summary: 'Official source material for the Rifts Vampires Sourcebook.',
    games: ['Rifts'],
    official: 'Yes',
    tags: ['gm', 'vampire', 'undead', 'silly']
  },
  {
    id: '497',
    article: 'A Revisit to Timiro',
    author: ['Glen Evans', 'Kevin Siembieda'],
    artist: ['Mike Leonard'],
    page: '15-35',
    issue: rifter63,
    issueTitle: 'The Rifter #63',
    image: './images/rifter63.jpg',
    summary: 'A history of the Timiro Kingdom whose events provide background and adventure ideas for your Fantasy campaigns. There are also stats for a few notable leaders and scoundrels to use as a catalyst for more adventure and intrigue. Check out the Sword of Light Rune Sword.',
    games: ['Palladium Fantasy'],
    official: 'Yes',
    tags: ['adventure', 'npc', 'weapon', 'rune']
  },
  {
    id: '498',
    article: 'Mythic Beasts',
    author: ['Timothy A. Dorman'],
    artist: ['Tanya J. Ramsey'],
    page: '36-57',
    issue: rifter63,
    issueTitle: 'The Rifter #63',
    image: './images/rifter63.jpg',
    summary: 'A fascinating look at nine rare and mythic creatures of the Palladium World, and the mage-warriors who covet their power. Includes conversion stats for use in Rifts.',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['monster', 'conversion', 'stat', 'gm', 'tips']
  },
  {
    id: '499',
    article: 'Beyond the Supernatural Random Adventure Generator. ',
    author: ['Chai Gallahun'],
    artist: ['Charles Walton'],
    page: '58-67',
    issue: rifter63,
    issueTitle: 'The Rifter #63',
    image: './images/rifter63.jpg',
    summary: 'A number of fun, easy to use Random Tables for generating adventures and encounters for Beyond the Supernatural.',
    games: ['Beyond the Supernatural'],
    official: 'No',
    tags: ['gm', 'adventure', 'tips']
  },
  {
    id: '500',
    article: 'The Black Malice Legacy, Part One',
    author: ['Matt Olfson'],
    artist: ['Jeffrey A. Burke'],
    page: '68-89',
    issue: rifter63,
    issueTitle: 'The Rifter #63',
    image: './images/rifter63.jpg',
    summary: "The little known and dark underside of the Coalition Army's special forces in Psi-Battalion.",
    games: ['Rifts'],
    official: 'No',
    tags: ['cs', 'coalition']
  },
  {
    id: '501',
    article: 'Tinkers',
    author: ['Bryant Telfer'],
    artist: ['Benjamin Rodriguez'],
    page: '18-24',
    issue: rifter64,
    issueTitle: 'The Rifter #64',
    image: './images/rifter64.jpg',
    summary: 'A look at the Nightbane, past and present, and how many were gypsy-like wanderers throughout the ages. Tinker Con Artist O.C.C.',
    games: ['Nightbane'],
    official: 'No',
    tags: ['occ']
  },
  {
    id: '502',
    article: 'Gleaners',
    author: ['Matthew Clements'],
    artist: [''],
    page: '25-28',
    issue: rifter64,
    issueTitle: 'The Rifter #64',
    image: './images/rifter64.jpg',
    summary: 'The Gleaner, a wicked monstrosity, enslaves as many children as it can to whisk away to its dark dimension, where they are tormented, and it devours them. A dramatic Halloween adventure and gruesome Beyond the Supernatural monster.',
    games: ['Beyond the Supernatural'],
    official: 'Yes',
    tags: ['adventure', 'monster']
  },
  {
    id: '503',
    article: 'New Dead Reign Survivors',
    author: ['Jeff Duncan'],
    artist: ['Tanya J. Ramsey'],
    page: '29-34',
    issue: rifter64,
    issueTitle: 'The Rifter #64',
    image: './images/rifter64.jpg',
    summary: 'Eight new Survivor Occupations for your inclusion in the Dead Reign setting. Hook, line and sinker adventures.',
    games: ['Dead Reign'],
    official: 'No',
    tags: ['occ', 'adventure']
  },
  {
    id: '504',
    article: 'A Day in the Life of Scott Benter, G.A.',
    author: ['Glen Evans'],
    artist: ['Jeffrey A. Burke'],
    page: '35-47',
    issue: rifter64,
    issueTitle: 'The Rifter #64',
    image: './images/rifter64.jpg',
    summary: 'An unusual look into the world of superhumans.',
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['super']
  },
  {
    id: '505',
    article: 'Palladium Ice Dwellers',
    author: ['Matthew Clements'],
    artist: ['Charles Walton'],
    page: '48-51',
    issue: rifter64,
    issueTitle: 'The Rifter #64',
    image: './images/rifter64.jpg',
    summary: 'The Ice Bearmen are even more feral and barbaric than their brown Bearmem of the North cousins, and the Winterspent is a cousin to the Ice Dragon with a few special abilities and an affinity for Bearmen.',
    games: ['Palladium Fantasy', 'Rifts'],
    official: 'Yes',
    tags: ['monster']
  },
  {
    id: '506',
    article: 'Too Big to Fail',
    author: ['Michael Osborne'],
    artist: ['Benjamin Rodriguez'],
    page: '52-64',
    issue: rifter64,
    issueTitle: 'The Rifter #64',
    image: './images/rifter64.jpg',
    summary: 'A unique Fantasy adventure that can be undertaken by Giant player characters or pint-sized human ones. Embark on a quest that involves ancient secrets, dark magic and undead Trolls!',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['adventure', 'undead', 'magic']
  },
  {
    id: '507',
    article: 'A Cold Night, Dead Past - A Short Story for Rifts',
    author: ['Brett Caron'],
    artist: ['Charles Walton'],
    page: '65-79',
    issue: rifter64,
    issueTitle: 'The Rifter #64',
    image: './images/rifter64.jpg',
    summary: 'A chilling story of Coalition tenacity, bad choices and danger.',
    games: ['Rifts'],
    official: 'No',
    tags: ['story', 'cs', 'coalition']
  },
  {
    id: '508',
    article: 'The Black-Malice Legacy, Part Two',
    author: ['Matt Olfson', 'Will Hunter', 'Kevin Siembieda'],
    artist: ['Mike Mumah'],
    page: '80-93',
    issue: rifter64,
    issueTitle: 'The Rifter #64',
    image: './images/rifter64.jpg',
    summary: "The little known and dark underside of the Coalition Army's special forces in Psi-Battalion. Presents what the author calls 'The Black Arts.' Psychic Registration and training programs that groom CS citizens who have psionic powers for work in Psi-Battalion.",
    games: ['Rifts'],
    official: 'No',
    tags: ['psionic', 'cs', 'coalition']
  },
  {
    id: '509',
    article: 'The Well of Visions',
    author: ['Matthew Clements'],
    artist: [''],
    page: '94-96',
    issue: rifter64,
    issueTitle: 'The Rifter #64',
    image: './images/rifter64.jpg',
    summary: 'A story that gives viewers a glimpse into Rifts Northern Gun One, Two and Megaverse in Flames.',
    games: ['Rifts'],
    official: 'Yes',
    tags: ['story', 'ng']
  },
  {
    id: '510',
    article: 'Hollow Road - An adventure for Beyond the Supernatural',
    author: ['Anthony Uyl'],
    artist: ['Benjamin Rodriguez'],
    page: '17-30',
    issue: rifter65,
    issueTitle: 'The Rifter #65',
    image: './images/rifter65.jpg',
    summary: 'A psychological adventure of deception and horror that chills the soul. Introduces the Soul Merchant monster.',
    games: ['Beyond the Supernatural'],
    official: 'No',
    tags: ['adventure', 'monster']
  },
  {
    id: '511',
    article: 'Necromancy and the Power of Death',
    author: ['Eric Siems'],
    artist: ['Tanya J. Ramsey'],
    page: '31-49',
    issue: rifter65,
    issueTitle: 'The Rifter #65',
    image: './images/rifter65.jpg',
    summary: 'Offers 60 new Necromancy spells plus Necro-O.C.C.s, the Bone Merchant NPC and Necromancy-based magic items.',
    games: ['Rifts'],
    official: 'No',
    tags: ['occ', 'spell', 'magic', 'npc']
  },
  {
    id: '512',
    article: 'Rifts Black Market: Rise to Power',
    author: ['Maxwell Kautsch'],
    artist: ['Nick Bradshaw'],
    page: '50-67',
    issue: rifter65,
    issueTitle: 'The Rifter #65',
    image: './images/rifter65.jpg',
    summary: 'An interesting study of the rising to power within the cutthroat arena of the criminal Black Market. Also introduces the City State of Singer, New York, as a trade hub of one such rising faction.',
    games: ['Rifts'],
    official: 'No',
    tags: ['location', 'blackmarket']
  },
  {
    id: '513',
    article: 'Once More unto the Breach',
    author: ['Alex Tulloch'],
    artist: ['Allen Manning', 'Brian Manning'],
    page: '68-79',
    issue: rifter65,
    issueTitle: 'The Rifter #65',
    image: './images/rifter65.jpg',
    summary: 'More adventure ideas, C.A.M.E.L.O.T. background and a new batch of superhuman heroes, their HQ and some gadgets for your gaming enjoyment.',
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['adventure', 'camelot', 'npc', 'equipment']
  },
  {
    id: '514',
    article: 'Contemporary High-Tech Robotics and Other Gadgets',
    author: ['David F. Smith'],
    artist: ['Mike Mumah'],
    page: '80-88',
    issue: rifter65,
    issueTitle: 'The Rifter #65',
    image: './images/rifter65.jpg',
    summary: 'All kinds of ideas and high-tech devices for use in Heroes Unlimited based around a company/organization known as ICS (Integrated Cyber Systems).',
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['ics', 'equipment']
  },
  {
    id: '515',
    article: 'Chaos Eve',
    author: ['Shawn Merrow'],
    artist: [''],
    page: '89-97',
    issue: rifter65,
    issueTitle: 'The Rifter #65',
    image: './images/rifter65.jpg',
    summary: 'A story of the end of the old world and the Coming of the Rifts.',
    games: ['Chaos Earth'],
    official: 'No',
    tags: ['story']
  },
  {
    id: '516',
    article: 'Splicers: The Bestiary',
    author: ['Edward Sauerland'],
    artist: ['Charles Walton'],
    page: '15-38',
    issue: rifter66,
    issueTitle: 'The Rifter #66',
    image: './images/rifter66.jpg',
    summary: 'An array of 11 new M.D.C. creatures, plus tables and rules for the random creation of gene-spliced monstrosities and the Splicers Ranger O.C.C.',
    games: ['Splicers'],
    official: 'No',
    tags: ['occ', 'monster', 'rules']
  },
  {
    id: '517',
    article: 'Bite of the Snake Men',
    author: ['Glen Evans'],
    artist: ['Tanya J. Ramsey'],
    page: '39-53',
    issue: rifter66,
    issueTitle: 'The Rifter #66',
    image: './images/rifter66.jpg',
    summary: 'A Heroes Unlimited adventure with twists and turns, plus a new group of super-baddies with unique powers and abilities.',
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['adventure', 'power', 'npc']
  },
  {
    id: '518',
    article: 'Space Pirates',
    author: ['Braden Campbell'],
    artist: ['Mike Mumah'],
    page: '54-66',
    issue: rifter66,
    issueTitle: 'The Rifter #66',
    image: './images/rifter66.jpg',
    summary: 'A wealth of information about the space pirates of the Three Galaxies, their methods, their targets and even some of their spacecraft.',
    games: ['Phase World'],
    official: 'No',
    tags: ['npc', 'vehicle']
  },
  {
    id: '519',
    article: 'Skipping Stones',
    author: ['Brett Caron'],
    artist: ['Benjamin Rodriguez'],
    page: '67-79',
    issue: rifter66,
    issueTitle: 'The Rifter #66',
    image: './images/rifter66.jpg',
    summary: 'A story of intrigue and travel, as the lead characters go from Lazlo to the Splynn Dimensional Market on Atlantis.',
    games: ['Rifts'],
    official: 'No',
    tags: ['story']
  },
  {
    id: '520',
    article: 'Rifts Black Market Part 2: Rise to Power',
    author: ['Maxwell Kautsch'],
    artist: ['Allen Manning', 'Brian Manning'],
    page: '80-97',
    issue: rifter66,
    issueTitle: 'The Rifter #66',
    image: './images/rifter66.jpg',
    summary: 'Provides a Black Market town with notable shops, places and people, plus a handful of Techno-Wizard contraband.',
    games: ['Rifts'],
    official: 'No',
    tags: ['location', 'tw', 'technowizard', 'blackmarket']
  },
  {
    id: '521',
    article: 'House Pandorum: The Chaos Spreads',
    author: ['Kris Tipping'],
    artist: ['Charles Walton'],
    page: '16-42',
    issue: rifter67,
    issueTitle: 'The Rifter #67',
    image: './images/rifter67.jpg',
    summary: 'More background on House Pandorum, new O.C.C.s, an array of new bio-Enhancements, armor, venom, weapons and gear, as well as Biotics, adventure ideas and more.',
    games: ['Splicers'],
    official: 'No',
    tags: ['occ', 'weapon', 'adventure', 'bio', 'armor', 'weapon', 'equipment']
  },
  {
    id: '522',
    article: 'Outpost F279',
    author: ['Anthony Uyl'],
    artist: ['Nick Bradshaw'],
    page: '43-54',
    issue: rifter67,
    issueTitle: 'The Rifter #67',
    image: './images/rifter67.jpg',
    summary: 'An adventure centering around revenge and betrayal that could shake the very foundations of Lazlo and the Coalition States. Deception, treachery and a new Alien Intelligence are all part of this growing menace.',
    games: ['Rifts'],
    official: 'No',
    tags: ['adventure', 'cs', 'coalition', 'monster']
  },
  {
    id: '523',
    article: 'The Mutant Bees of Earth',
    author: ['Michael J. Osborne'],
    artist: ['Benjamin Rodriguez'],
    page: '55-65',
    issue: rifter67,
    issueTitle: 'The Rifter #67',
    image: './images/rifter67.jpg',
    summary: 'A representation of genetically altered, intelligent, humanoid mutant bees, martial artist bees at that. Alternative M.D.C. stats for Rifts.',
    games: ['After the Bomb', 'Rifts', 'Heroes Unlimited'],
    official: 'No',
    tags: ['adventured', 'mutant', 'stat', 'conversion']
  },
  {
    id: '524',
    article: 'Rifts Africa: Creatures and Monsters',
    author: ['Jeff Duncan'],
    artist: ['Tanya J. Ramsey'],
    page: '66-85',
    issue: rifter67,
    issueTitle: 'The Rifter #67',
    image: './images/rifter67.jpg',
    summary: 'An array of new supernatural beings and creatures of magic for the Rifts Africa setting.',
    games: ['Rifts'],
    official: 'No',
    tags: ['monster', 'magic', 'location']
  },
  {
    id: '525',
    article: 'Power Behind the Throne',
    author: ['Alex Tulloch'],
    artist: [''],
    page: '86-97',
    issue: rifter67,
    issueTitle: 'The Rifter #67',
    image: './images/rifter67.jpg',
    summary: 'A shadowy group of characters working for the UK government. Includes Hook, Line and Sinker adventures.',
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['adventure', 'npc']
  },
  {
    id: '526',
    article: 'Rifts Megaverse in Flames: Stand and Be Ready',
    author: ['Carl Gleba', 'Kevin Siembieda'],
    artist: ['Charles Walton'],
    page: '26-40',
    issue: rifter68,
    issueTitle: 'The Rifter #68',
    image: './images/rifter68.jpg',
    summary: 'A backstory filled with adventure hooks and ideas for your enjoyment. Includes official source material for Rifts World Book 35: Megaverse in Flames and the Minion War crossover series.',
    games: ['Rifts'],
    official: 'Yes',
    tags: ['adventure']
  },
  {
    id: '527',
    article: "'Brulyx?'",
    author: ['Steve Dawes'],
    artist: ['Tanya J. Ramsey'],
    page: '41-62',
    issue: rifter68,
    issueTitle: 'The Rifter #68',
    image: './images/rifter68.jpg',
    summary: 'A unique Beyond the Supernatural adventure inspired by the Alien Intelligence Brulyx, who is also the deity worshipped by death cultists described in the Dead Reign RPG and in The Rifter #45.',
    games: ['Beyond the Supernatural'],
    official: 'No',
    tags: ['adventure', 'npc', 'monster']
  },
  {
    id: '528',
    article: 'The Crusaders and the Black Crusade, Part 4: Arcadia',
    author: ['Andrew Lander'],
    artist: ['Andrew Lander'],
    page: '63-82',
    issue: rifter68,
    issueTitle: 'The Rifter #68',
    image: './images/rifter68.jpg',
    summary: 'More secrets and information about True Atlanteans, their other-dimensional hideouts, clans, O.C.C.s, R.C.C.s, new Magic Tattoos, and ideas for adventures.',
    games: ['Rifts', 'Phase World'],
    official: 'No',
    tags: ['occ', 'rcc', 'adventure', 'tattoo', 'adventure']
  },
  {
    id: '529',
    article: 'Band of Bothers',
    author: ['Branden Loizides'],
    artist: ['Benjamin Rodriguez'],
    page: '83-97',
    issue: rifter68,
    issueTitle: 'The Rifter #68',
    image: './images/rifter68.jpg',
    summary: "One of Century Station's most beloved superheroes has been assassinated. A fun, lighthearted adventure wherein the Band of Bothers, a band of misfit sidekicks, try to solve the mystery of his murder.",
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['adventure', 'awesome']
  },
  {
    id: '530',
    article: 'Rifts Arenas of Atlantis',
    author: ['Will Erwin'],
    artist: ['Amy L. Ashbaugh'],
    page: '24-31',
    issue: rifter69,
    issueTitle: 'The Rifter #69',
    image: './images/rifter69.jpg',
    summary: "An inside look at how the arenas of the Splugorth's Atlantis are managed and run. In addition to background information and details, there are plenty of adventure ideas too.",
    games: ['Rifts'],
    official: 'No',
    tags: ['monster', 'adventure']
  },
  {
    id: '531',
    article: 'The Long Gull Islands',
    author: ['Michael J. Osborne'],
    artist: ['Benjamin Rodriguez'],
    page: '32-49',
    issue: rifter69,
    issueTitle: 'The Rifter #69',
    image: './images/rifter69.jpg',
    summary: 'A unique After the Bomb setting to explore and enjoy new adventures. Long Island, Nantucket, and other areas in the State of New York after the cataclysm. New mutants and the background, history, and people behind these refuges for mutants and survivors.',
    games: ['After the Bomb'],
    official: 'No',
    tags: ['location', 'adventure', 'mutant']
  },
  {
    id: '532',
    article: 'Heroic Hot Spots',
    author: ['Glen Evans'],
    artist: ['Mike Mumah'],
    page: '50-63',
    issue: rifter69,
    issueTitle: 'The Rifter #69',
    image: './images/rifter69.jpg',
    summary: 'New people, places and hot spots in the District of Century Station for heroic adventures.',
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['location', 'npc']
  },
  {
    id: '533',
    article: 'Living Through the Great Cataclysm, one day at a time',
    author: ['Daniel Frederick'],
    artist: ['Charles Walton II'],
    page: '64-75',
    issue: rifter69,
    issueTitle: 'The Rifter #69',
    image: './images/rifter69.jpg',
    summary: 'The events of the Great Cataclysm and the Coming of the Rifts in a different part of the country - New Mexico.',
    games: ['Chaos Earth'],
    official: 'No',
    tags: ['location']
  },
  {
    id: '534',
    article: 'Dead Reign Tampa Bay',
    author: ['Eric Sturm'],
    artist: [''],
    page: '76-78',
    issue: rifter69,
    issueTitle: 'The Rifter #69',
    image: './images/rifter69.jpg',
    summary: 'A look at the Zombie Apocalypse in the Tampa Bay, Florida area, taking note of some key locations good for adventure ideas.',
    games: ['Dead Reign'],
    official: 'No',
    tags: ['location', 'undead']
  },
  {
    id: '535',
    article: 'Splicers: Blood and Iron',
    author: ['Brandon Aten'],
    artist: ['Charles Walton II'],
    page: '20-38',
    issue: rifter70,
    issueTitle: 'The Rifter #70',
    image: './images/rifter70.jpg',
    summary: 'A sneak preview of an upcoming Splicers sourcebook by sharing the much-expanded description, powers and abilities of the Technojacker O.C.C.',
    games: ['Splicers'],
    official: 'Yes',
    tags: ['occ', 'power']
  },
  {
    id: '536',
    article: '10 Tips for Game Masters',
    author: ['Chris Isberg'],
    artist: [''],
    page: '39-41',
    issue: rifter70,
    issueTitle: 'The Rifter #70',
    image: './images/rifter70.jpg',
    summary: 'Some excellent suggestions and advice that the Palladium crew all found fun and eminently playable.',
    games: ['Any'],
    official: 'No',
    tags: ['tips', 'gm']
  },
  {
    id: '537',
    article: 'The Unbidden',
    author: ['Josh Sinsapaugh'],
    artist: ['Tanya J. Ramsey'],
    page: '42-50',
    issue: rifter70,
    issueTitle: 'The Rifter #70',
    image: './images/rifter70.jpg',
    summary: 'A trio of transdimensional monsters that follow dimensional anomalies and weaknesses in the dimensional bleed to invade new worlds. Hell Pits are one such means of entry.',
    games: ['Rifts'],
    official: 'Yes',
    tags: ['monster']
  },
  {
    id: '538',
    article: 'The City of New Strawn',
    author: ['Travis Legge'],
    artist: [''],
    page: '51-57',
    issue: rifter70,
    issueTitle: 'The Rifter #70',
    image: './images/rifter70.jpg',
    summary: 'An outline of the independent City-State of New Strawn located in Kansas, along with some notable characters and adventure ideas.',
    games: ['Rifts'],
    official: 'No',
    tags: ['location', 'adventure', 'npc']
  },
  {
    id: '539',
    article: 'The Deep Frontier',
    author: ['Mark Temple'],
    artist: ['Benjamin Rodriguez'],
    page: '58-67',
    issue: rifter70,
    issueTitle: 'The Rifter #70',
    image: './images/rifter70.jpg',
    summary: 'The potential for adventures under the sea, and includes some notable communities, characters, and equipment, including underwater habitats, civilian submarines and a new aquatic O.C.C. (Freeland Aquanaut)',
    games: ['Rifts'],
    official: 'No',
    tags: ['occ', 'npc', 'equipment']
  },
  {
    id: '540',
    article: 'Frost Magic',
    author: ['Nathan Bingham', 'Kevin Siembieda'],
    artist: ['Tanya J. Ramsey'],
    page: '68-80',
    issue: rifter70,
    issueTitle: 'The Rifter #70',
    image: './images/rifter70.jpg',
    summary: 'A Wizard who specializes in frost and cold-based magic spells, along with 60+ spells; more than 40 of them completely brand new.',
    games: ['Rifts', 'Phase World', 'Palladium Fantasy', 'Heroes Unlimited'],
    official: 'Yes',
    tags: ['magic', 'spell']
  },
  {
    id: '541',
    article: 'Clean, Part Two - A story for Rifts',
    author: ['Irvin Jackson'],
    artist: ['Amy L. Ashbaugh'],
    page: '81-96',
    issue: rifter70,
    issueTitle: 'The Rifter #70',
    image: './images/rifter70.jpg',
    summary: 'The conclusion of this thrilling story of survival and adventure around the fortified city of Chi-Town.',
    games: ['Rifts'],
    official: 'No',
    tags: ['story', 'location']
  },
  {
    id: '542',
    article: 'Infinite Possibilities',
    author: ['Kevin Siembieda'],
    artist: [''],
    page: '21-23',
    issue: rifter71,
    issueTitle: 'The Rifter #71-72',
    image: './images/rifter71.jpg',
    summary: 'Kevin Siembieda talks about why he created a game system that can accommodate every genre and simple ways to convert them.',
    games: ['Any'],
    official: 'No',
    tags: ['gm']
  },
  {
    id: '543',
    article: 'Thoughts on Megaversal Adventures - If you can conceive of it, you can put it together',
    author: ['Julius Rosenstein'],
    artist: ['Mark Dudley'],
    page: '24-32',
    issue: rifter71,
    issueTitle: 'The Rifter #71-72',
    image: './images/rifter71.jpg',
    summary: 'Experiences, approach and conversions for running groups of characters that are wildly diverse from entirely different genres and settings.',
    games: ['Any'],
    official: 'Yes',
    tags: ['tools', 'gm', 'tips']
  },
  {
    id: '544',
    article: 'An Evening at the Improv Table',
    author: ['Glen Evans', 'Kevin Siembieda'],
    artist: ['Kevin Siembieda'],
    page: '33-40',
    issue: rifter71,
    issueTitle: 'The Rifter #71-72',
    image: './images/rifter71.jpg',
    summary: 'Insight and advice about improvisation at the gaming table, listening to your players and using their words and actions to build adventures you never imagined.',
    games: ['Any'],
    official: 'Yes',
    tags: ['gm', 'tips']
  },
  {
    id: '545',
    article: 'Yokai of Japan',
    author: ['Shawn Merrow'],
    artist: ['Mike Mumah'],
    page: '41-55',
    issue: rifter71,
    issueTitle: 'The Rifter #71-72',
    image: './images/rifter71.jpg',
    summary: 'A host of monsters (yokai) of Japan for the modern day setting of Beyond the Supernatural.',
    games: ['Beyond the Supernatural'],
    official: 'No',
    tags: ['monster', 'location']
  },
  {
    id: '546',
    article: 'Aboard the Pearl',
    author: ['Eric Sturm'],
    artist: ['Nick Bradshaw'],
    page: '56-59',
    issue: rifter71,
    issueTitle: 'The Rifter #71-72',
    image: './images/rifter71.jpg',
    summary: 'A setting of hope during the Zombie Apocalypse.',
    games: ['Dead Reign'],
    official: 'No',
    tags: ['location']
  },
  {
    id: '547',
    article: 'On a Wing and a Prayer',
    author: ['Paul Herbert'],
    artist: ['Angela Deland'],
    page: '60-85',
    issue: rifter71,
    issueTitle: 'The Rifter #71-72',
    image: './images/rifter71.jpg',
    summary: 'An adventure full of intrigue, spies, secrets, martial arts and danger.',
    games: ['Ninjas and Superspies'],
    official: 'Yes',
    tags: ['adventure', 'npc']
  },
  {
    id: '548',
    article: 'I Am Legion',
    author: ['Chris Kluge', 'Charles Walton II'],
    artist: ['Charles Walton II'],
    page: '86-137',
    issue: rifter71,
    issueTitle: 'The Rifter #71-72',
    image: './images/rifter71.jpg',
    summary: 'An episodic adventure ushering in a new rogue Nexus personality, Legion. Five years in the making. Designed as a special release. O.C.C.s, NPCs too.',
    games: ['Splicers'],
    official: 'Yes',
    tags: ['occ', 'npc', 'adventure', 'story']
  },
  {
    id: '549',
    article: 'The Town of Semjaw',
    author: ['Brett Caron'],
    artist: ['Benjamin Rodriguez'],
    page: '138-143',
    issue: rifter71,
    issueTitle: 'The Rifter #71-72',
    image: './images/rifter71.jpg',
    summary: 'A town struggling to survive in the wilderness of Canada. Semjaw was a quiet little place until pre-Rifts ruins were discovered.',
    games: ['Rifts'],
    official: 'No',
    tags: ['location']
  },
  {
    id: '550',
    article: 'Reaper Cell - A short story for Rifts',
    author: ['Dan Frederick'],
    artist: ['Mike Leonard'],
    page: '144-219',
    issue: rifter71,
    issueTitle: 'The Rifter #71-72',
    image: './images/rifter71.jpg',
    summary: 'A story about Coalition black ops, treachery, secret missions and fighting fire with fire. A prelude to Secrets of the Coalition States: The Disavowed Sourcebook.',
    games: ['Rifts'],
    official: 'No',
    tags: ['cs', 'coalition', 'story']
  },
  {
    id: '551',
    article: 'Bonus Maps',
    author: ['Will Erwin'],
    artist: ['Will Erwin'],
    page: '220-221',
    issue: rifter71,
    issueTitle: 'The Rifter #71-72',
    image: './images/rifter71.jpg',
    summary: 'A gift to Palladium Books and its fans.',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['map']
  },
  {
    id: '552',
    article: 'The Triumvirate Dragon',
    author: ['Glen Evans', 'Kevin Siembieda'],
    artist: ['Kevin Siembieda'],
    page: '16-25',
    issue: rifter73,
    issueTitle: 'The Rifter #73',
    image: './images/rifter73.jpg',
    summary: 'The iconic image of the three-headed dragon from the original cover of the 1983 Palladium Fantasy Role-Playing Game is described. It is the Triumvirate Dragon, not your typical dragon. ',
    games: ['Palladium Fantasy'],
    official: 'Yes',
    tags: ['monster']
  },
  {
    id: '553',
    article: 'Forest Children',
    author: ['Kevin Siembieda'],
    artist: ['Angela Deland-Baldwin', 'Michael Wilson'],
    page: '26-44',
    issue: rifter73,
    issueTitle: 'The Rifter #73',
    image: './images/rifter73.jpg',
    summary: 'An in-depth look at the deceptive power and dangers of the Forest Children - Faerie Folk.',
    games: ['Palladium Fantasy'],
    official: 'Yes',
    tags: ['monster']
  },
  {
    id: '554',
    article: 'The Nexus Born',
    author: ['Julius Rosenstein', 'Kevin Siembieda'],
    artist: ['Mike Leonard'],
    page: '45-50',
    issue: rifter73,
    issueTitle: 'The Rifter #73',
    image: './images/rifter73.jpg',
    summary: 'The power of ley lines and the secrets of Hidden Nexus Points are explored, and how being born on a Nexus Point provides the individual with an affinity and aptitude for magic. Such individuals are known as the Nexus Born.',
    games: ['Rifts'],
    official: 'Yes',
    tags: ['magic']
  },
  {
    id: '555',
    article: 'Dead Reign in Detroit',
    author: ['Thomas Morrison'],
    artist: ['Nick Bradshaw', 'Mike Mumah'],
    page: '51-62',
    issue: rifter73,
    issueTitle: 'The Rifter #73',
    image: './images/rifter73.jpg',
    summary: 'The fate of Detroit in the Zombie Apocalypse, and the danger that remains present but largely unknown.',
    games: ['Dead Reign'],
    official: 'Yes',
    tags: ['location']
  },
  {
    id: '556',
    article: 'I am Legion, Part Two',
    author: ['Chris Kluge', 'Lance Colley', 'Charles Walton II'],
    artist: ['Charles Walton II'],
    page: '63-96',
    issue: rifter73,
    issueTitle: 'The Rifter #73',
    image: './images/rifter73.jpg',
    summary: 'The next chapter of I Am Legion, an episodic adventure ushering in the new rogue Nexus personality, Legion.',
    games: ['Splicers'],
    official: 'Yes',
    tags: ['story', 'adventure']
  },
  {
    id: '557',
    article: 'The Town of Moorcroft, Wyoming',
    author: ['Julius Rosenstein'],
    artist: ['Mark Dudley', 'Mike Mumah'],
    page: '16-29',
    issue: rifter74,
    issueTitle: 'The Rifter #74',
    image: './images/rifter74.jpg',
    summary: 'The Town of Moorcroft is located on a hidden ley line and has a good number of Nexus Born practitioners of magic.',
    games: ['Rifts'],
    official: 'Yes',
    tags: ['location']
  },
  {
    id: '558',
    article: 'Ancient Weapons Master: Specialist',
    author: ['Robert Daley Jr.'],
    artist: ['Mark Dudley'],
    page: '30-35',
    issue: rifter74,
    issueTitle: 'The Rifter #74',
    image: './images/rifter74.jpg',
    summary: 'Optional rules and suggestions for making the Ancient Weapons Master in Heroes Unlimited a more focused, dedicated and deadly combatant.',
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['rules', 'gm', 'rules', 'occ', 'combat']
  },
  {
    id: '559',
    article: 'Wilderness Community - Karimyo',
    author: ['Brett Caron'],
    artist: ['Benjamin Rodriguez'],
    page: '36-39',
    issue: rifter74,
    issueTitle: 'The Rifter #74',
    image: './images/rifter74.jpg',
    summary: 'A small community in the Pecos Empire not far from Sabre Lasar territory.',
    games: ['Rifts'],
    official: 'No',
    tags: ['location']
  },
  {
    id: '560',
    article: 'I am Legion, Part Three',
    author: ['Chris Kluge', 'Lance Colley', 'Charles Walton II'],
    artist: ['Charles Walton II'],
    page: '40-74',
    issue: rifter74,
    issueTitle: 'The Rifter #74',
    image: './images/rifter74.jpg',
    summary: "The next chapter of 'I Am Legion,' an episodic adventure ushering in the new rogue Nexus personality.",
    games: ['Splicers'],
    official: 'Yes',
    tags: ['story', 'adventure']
  },
  {
    id: '561',
    article: 'Acceptance - A story for Rifts',
    author: ['S.E. Gibbons'],
    artist: ['Mike Leonard'],
    page: '75-',
    issue: rifter74,
    issueTitle: 'The Rifter #74',
    image: './images/rifter74.jpg',
    summary: "A story about a hardworking 'everyman' living in the 'Burbs who dreams of becoming a Coalition citizen. It's all he strives for, but fate seems to have other plans for him when his life takes an unexepected detour.",
    games: ['Rifts'],
    official: 'No',
    tags: ['story', 'coalition', 'cs']
  },
  {
    id: '562',
    article: 'How to Play Rifts, a Rifts Primer',
    author: ['Carl Gleba', 'Kevin Siembieda'],
    artist: ['Mark Dudley', 'Angela Deland-Baldwin'],
    page: '32-66',
    issue: rifter75,
    issueTitle: 'The Rifter #75',
    image: './images/rifter75.jpg',
    summary: 'A tour de force of information about Game Mastering games and creating adventures. Adventure included.',
    games: ['Rifts'],
    official: 'Yes',
    tags: ['tips', 'gm', 'adventure', 'npc']
  },
  {
    id: '563',
    article: 'I am Legion, Part Four',
    author: ['Chris Kluge', 'Lance Colley', 'Charles Walton II'],
    artist: ['Charles Walton II'],
    page: '67-89',
    issue: rifter75,
    issueTitle: 'The Rifter #75',
    image: './images/rifter75.jpg',
    summary: "The next chapter of 'I Am Legion', an episodic adventure ushering in the new rogue Nexus personality, Legion.",
    games: ['Splicers'],
    official: 'Yes',
    tags: ['story', 'adventure']
  },
  {
    id: '564',
    article: 'A Haven in the Wilderness',
    author: ['Scott Fowler'],
    artist: ['Mike Leonard'],
    page: '90-96',
    issue: rifter75,
    issueTitle: 'The Rifter #75',
    image: './images/rifter75.jpg',
    summary: 'A burgeoning community in Western Canada, Sherwood Park.',
    games: ['Rifts'],
    official: 'No',
    tags: ['location']
  },
  {
    id: '565',
    article: 'Elemental Primorda',
    author: ['Greg Diaczyk', 'Kevin Siembieda'],
    artist: ['Charles Walton II'],
    page: '22-40',
    issue: rifter76,
    issueTitle: 'The Rifter #76',
    image: './images/rifter76.jpg',
    summary: 'Four new mysterious people. They all travel the Megaverse and appear to be benign explorers, or is there something more sinister afoot?',
    games: ['Rifts', 'Phase World', 'Palladium Fantasy'],
    official: 'No',
    tags: ['npc', 'monster']
  },
  {
    id: '566',
    article: 'Blood Diamonds',
    author: ['Thomas Morrison'],
    artist: ['Mark Dudley', 'Charles Ferguson-Avery'],
    page: '62-',
    issue: rifter76,
    issueTitle: 'The Rifter #76',
    image: './images/rifter76.jpg',
    summary: 'The story, adventure hooks, and NPC villains for a tale of crime, greed, human slavery, and battle.',
    games: ['Heroes Unlimited', 'Ninjas and Superspies', 'Nightbane'],
    official: 'Yes',
    tags: ['adventure', 'npc', 'story']
  },
  {
    id: '567',
    article: 'Gohjjunk Wilderness Community',
    author: ['Brett Caron'],
    artist: [''],
    page: '62-70',
    issue: rifter76,
    issueTitle: 'The Rifter #76',
    image: './images/rifter76.jpg',
    summary: 'Another Rifts town set in the Pecos Badlands. It is part giant junkyard, part town, part catalyst for adventure.',
    games: ['Rifts'],
    official: 'No',
    tags: ['location']
  },
  {
    id: '568',
    article: 'I am Legion, Part Five',
    author: ['Chris Kluge', 'Lance Colley', 'Charles Walton II'],
    artist: ['Charles Walton II'],
    page: '67-89',
    issue: rifter76,
    issueTitle: 'The Rifter #76',
    image: './images/rifter76.jpg',
    summary: "The next chapter of 'I Am Legion', an episodic adventure ushering in the new rogue Nexus personality, Legion.",
    games: ['Splicers'],
    official: 'Yes',
    tags: ['story', 'adventure']
  },
  {
    id: '569',
    article: 'Nowhere',
    author: ['Brett Caron'],
    artist: ['Benjamin Rodriguez'],
    page: '16-38',
    issue: rifter77,
    issueTitle: 'The Rifter #77',
    image: './images/rifter77.jpg',
    summary: "The Pecos Empire towns in the previous few issues of 'The Rifter' all tie together with Nowhere, a town built around ambition, questionable technology, Techno-Wizardry and some enterprising business people. Nowhere is much more than it seems.",
    games: ['Rifts'],
    official: 'No',
    tags: ['location', 'technowizard', 'tw', 'npc']
  },
  {
    id: '570',
    article: 'I am Legion, Part Six',
    author: ['Chris Kluge', 'Lance Colley', 'Charles Walton II'],
    artist: ['Charles Walton II'],
    page: '67-89',
    issue: rifter77,
    issueTitle: 'The Rifter #77',
    image: './images/rifter77.jpg',
    summary: "The next chapter of 'I Am Legion', an episodic adventure ushering in the new rogue Nexus personality, Legion.",
    games: ['Splicers'],
    official: 'Yes',
    tags: ['story', 'adventure']
  },
  {
    id: '571',
    article: 'Khemennu - Wilderness Community',
    author: ['Ian Herbert'],
    artist: ['Kevin Long'],
    page: '63-84',
    issue: rifter77,
    issueTitle: 'The Rifter #77',
    image: './images/rifter77.jpg',
    summary: 'A unique city of the gods - specifically the gods of Light and Dark, resting place of the legendary Sun Disc. Khumennu - also known as the City of the Eighteen Cosmic Gods - is a stronghold of the Church of Light and Dark.',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['location']
  },
  {
    id: '572',
    article: 'Mutants on the Loose',
    author: ['Kevin Siembieda'],
    artist: ['Nick Bradshaw'],
    page: '85-96',
    issue: rifter77,
    issueTitle: 'The Rifter #77',
    image: './images/rifter77.jpg',
    summary: 'The latest machinations of the infamous Doctor Feral, complete with up-to-date stats and information.',
    games: ['After the Bomb', 'Heroes Unlimited'],
    official: 'Yes',
    tags: ['npc', 'mutant', 'adventure']
  },
  {
    id: '572a',
    article: 'Khemennu, Part Two (and conclusion)',
    author: ['Ian Herbert'],
    artist: ['Mike Mumah'],
    page: '85-96',
    issue: rifter78,
    issueTitle: 'The Rifter #78',
    image: './images/rifter78.jpg',
    summary: 'Conclusion of the source material for the mysterious city of Khemennu and its apparent legacy as a place for the gods.',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['location', 'spell', 'adventure']
  },
  {
    id: '573',
    article: 'I am Legion, Aftermath, Part Seven',
    author: ['Chris Kluge', 'Lance Colley', 'Charles Walton II'],
    artist: ['Charles Walton II'],
    page: '67-89',
    issue: rifter78,
    issueTitle: 'The Rifter #78',
    image: './images/rifter78.jpg',
    summary: "The next chapter of 'I Am Legion', an episodic adventure ushering in the new rogue Nexus personality, Legion.",
    games: ['Splicers'],
    official: 'Yes',
    tags: ['story']
  },
  {
    id: '574',
    article: 'The Nexus Zone',
    author: ['Carl Gleba'],
    artist: [''],
    page: '66-75',
    issue: rifter78,
    issueTitle: 'The Rifter #78',
    image: './images/rifter78.jpg',
    summary: "Some unique insight to a place overflowing with magic energy and danger. A place called the Nexus Zone - home to the mega-Rift known as the Devil's Gate at the St. Louis Archway, and other anomalies most people don't hear about.",
    games: ['Rifts'],
    official: 'No',
    tags: ['location', 'magic']
  },
  {
    id: '575',
    article: 'The Modern Necromancer',
    author: ['Greg Diaczyk', 'Kevin Siembieda'],
    artist: ['Kevin Long', 'Apollo Okamura', 'Michael Wilson'],
    page: '76-96',
    issue: rifter78,
    issueTitle: 'The Rifter #78',
    image: './images/rifter78.jpg',
    summary: 'The Modern Necromancer and how they may use their dark magic and perform blood sacrifices in our modern world and most civilized settings without people being the wiser. Excellent material on how the Necromancer can function in secret among civilized people, how to use Necromancy without killing, immortality for those willing to pay the price and become a monster, using dinosaur fossils, adventure ideas and more. Modern Necromancer O.C.C., Death Priest O.C.C.',
    games: ['Heroes Unlimited', 'Ninjas and Superspies', 'Nightbane', 'Chaos Earth', 'Phase World'],
    official: 'Yes',
    tags: ['occ', 'magic', 'adventure', 'ppe']
  },
  {
    id: '576',
    article: 'Gaming Through History',
    author: ['Hendrik Harterich'],
    artist: ['Mike Mumah'],
    page: '22-53',
    issue: rifter79,
    issueTitle: 'The Rifter #79',
    image: './images/rifter79.jpg',
    summary: "A set of guidelines, rules and ideas for using modern characters from just about any game, whether present day or the future, and putting them into settings from Earth's past. Offers some fun adventure ideas too.",
    games: ['Any'],
    official: 'No',
    tags: ['rules', 'tips', 'adventure']
  },
  {
    id: '577',
    article: "Justice's Return",
    author: ['Mark Oberle'],
    artist: [''],
    page: '54-58',
    issue: rifter79,
    issueTitle: 'The Rifter #79',
    image: './images/rifter79.jpg',
    summary: 'A tale of a fallen warrior who is given the chance to redeem himself and maybe bring a measure of justice to a remote wilderness town.',
    games: ['Rifts'],
    official: 'No',
    tags: ['story', 'location']
  },
  {
    id: '578',
    article: 'The Kingdom of New Oslo',
    author: ['David Collins'],
    artist: ['Nick Bradshaw'],
    page: '59-76',
    issue: rifter79,
    issueTitle: 'The Rifter #79',
    image: './images/rifter79.jpg',
    summary: "The fledgling nation of New Oslo, located in Scandinavia near the New German Republic and close enough to Russia to be concerned about what's happening there. Oslo overview, notable people and places, vehicles, and get with a few Hook, Line and Sinker adventures.",
    games: ['Rifts'],
    official: 'No',
    tags: ['location', 'ngr', 'adventure', 'npc', 'vehicle']
  },
  {
    id: '579',
    article: 'The Stage Magician, Revisited',
    author: ['Matt Reed'],
    artist: ['Mike Mumah'],
    page: '77-91',
    issue: rifter79,
    issueTitle: 'The Rifter #79',
    image: './images/rifter79.jpg',
    summary: 'A new perspective on the creation, abilities, and use of the Stage Magician as a crime-fighting hero. One that must draw upon his or her wits, trickery, sleight of hand, and theatrics to be effective.',
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['occ', 'power', 'magic']
  },
  {
    id: '580',
    article: 'Different ways to run a campaign',
    author: ['Julius Rosenstein'],
    artist: [''],
    page: '92-96',
    issue: rifter79,
    issueTitle: 'The Rifter #79',
    image: './images/rifter79.jpg',
    summary: 'A handful of ideas and methods for generating characters, randomly generating level of experience, bringing the group together, character closure when leaving a campaign, and other alternative ways to play.',
    games: ['Rifts'],
    official: 'No',
    tags: ['tips', 'gm']
  },
  {
    id: '581',
    article: 'Wayfarers',
    author: ['Julius Rosenstein', 'Kevin Siembieda'],
    artist: ['Mike Mumah'],
    page: '18-43',
    issue: rifter80,
    issueTitle: 'The Rifter #80',
    image: './images/rifter80.jpg',
    summary: 'A brilliant batch of memorable and fun characters, and ideas for the Palladium Fantasy RPG setting. For players, the Wayfarer characters/O.C.C.s and history are a blast to play. For Game Masters, the Wayfarers are roguish heroes or thieving bad guys who can be encountered just about anywhere in the Palladium World to help or cause a little mayhem.',
    games: ['Palladium Fantasy'],
    official: 'Yes',
    tags: ['occ', 'npc', 'gm']
  },
  {
    id: '582',
    article: 'House of the Red Sands',
    author: ['Kris Tipping', 'Charles Walton', 'Kevin Siembieda'],
    artist: ['Mark Dudley', 'Amy L. Ashbaugh'],
    page: '44-84',
    issue: rifter80,
    issueTitle: 'The Rifter #80',
    image: './images/rifter80.jpg',
    summary: 'The first Splicers Great House in a desert environment. It is a new, mysterious, Splicers House and their unique new Host Armors, War Mounts, Desert Rose, bio-engineered ants, other creations and adventure ideas.',
    games: ['Splicers'],
    official: 'Yes',
    tags: ['location', 'adventure']
  },
  {
    id: '583',
    article: 'Masters Unlimited',
    author: ['Paul Herbert'],
    artist: [''],
    page: '85-94',
    issue: rifter80,
    issueTitle: 'The Rifter #80',
    image: './images/rifter80.jpg',
    summary: 'An insidious, new villainous organization, a cadre of notable super-villains within the organization, and adventure ideas galore. Hook, Line and Sinker adventures too.',
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['adventure', 'npc']
  },
  {
    id: '584',
    article: 'Chaos Earth Nebraska, Part One',
    author: ['Dan Frederick', 'Megan Timperley', 'Kevin Siembieda'],
    artist: ['Benjamin Rodriguez'],
    page: '95-112',
    issue: rifter80,
    issueTitle: 'The Rifter #80',
    image: './images/rifter80.jpg',
    summary: 'The new setting of Nebraska. This source material examines the events and survivors of Nebraska, and a few of the weird monsters that survivors must deal with.',
    games: ['Chaos Earth'],
    official: 'Yes',
    tags: ['location', 'monster']
  },
  {
    id: '585',
    article: 'Gnomes: Undersized and Underestimated',
    author: ['Hendrik Harterich'],
    artist: ['Charles Walton II', 'Kevin Siembieda'],
    page: '16-38',
    issue: rifter81,
    issueTitle: 'The Rifter #81',
    image: './images/rifter81.jpg',
    summary: "A fascinating look and in-depth information about these often underestimated, little heroes and adventurers. An overview of their history, how they live and survive in Ophid's Grasslands, how they fight, and why they enjoy adventuring around the world.",
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['race', 'location']
  },
  {
    id: '586',
    article: 'Hitting the Streets with the Super Sleuth',
    author: ['Matt Reed'],
    artist: ['Mike Mumah'],
    page: '39-56',
    issue: rifter81,
    issueTitle: 'The Rifter #81',
    image: './images/rifter81.jpg',
    summary: 'Expands the Super Sleuth with skills, abilities, specialized gear and more.',
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['occ', 'ability', 'skill', 'equipment']
  },
  {
    id: '587',
    article: 'Navigating Game Power Levels - GM Advice for Running Rifts and All RPG Settings',
    author: ['Greg Diaczyk', 'Kevin Siembieda'],
    artist: [''],
    page: '57-66',
    issue: rifter81,
    issueTitle: 'The Rifter #81',
    image: './images/rifter81.jpg',
    summary: 'Helpful Game Master insight and tips for how to run adventures in high-powered game settings like Rifts, as well as how to handle different power levels and players archetypes, teamwork and other insight.',
    games: ['Rifts', 'Any'],
    official: 'No',
    tags: ['tips', 'gm']
  },
  {
    id: '588',
    article: 'Blood Moon - Adventure',
    author: ['Kevin Siembieda'],
    artist: ['Nick Bradshaw'],
    page: '67-97',
    issue: rifter81,
    issueTitle: 'The Rifter #81',
    image: './images/rifter81.jpg',
    summary: "Kevin Siembieda's 2018 Palladium Fantasy Open House tournament adventure.",
    games: ['Palladium Fantasy'],
    official: 'Yes',
    tags: ['adventure']
  },
  {
    id: '589',
    article: 'Chaos Earth Nebraska, Part Two',
    author: ['Dan Frederick', 'Megan Timperley', 'Kevin Siembieda'],
    artist: ['Benjamin Rodriguez'],
    page: '95-112',
    issue: rifter81,
    issueTitle: 'The Rifter #81',
    image: './images/rifter81.jpg',
    summary: 'A continuation of Chaos Earth Nebraska, presenting new O.C.C.s, a new D-Bee and adventure ideas. Examines some of the events and survivors of Nebraska.',
    games: ['Chaos Earth'],
    official: 'Yes',
    tags: ['location', 'occ', 'dbee', 'adventure']
  },
  {
    id: '590',
    article: 'Erick Wujcik Remembered',
    author: ['Kevin Siembieda'],
    artist: ['Kevin Siembieda'],
    page: '22-39',
    issue: rifter82,
    issueTitle: 'The Rifter #82',
    image: './images/rifter82.jpg',
    summary: "An uplifting and insightful celebration of Erick's life that is fun and touching.",
    games: ['Any'],
    official: 'No',
    tags: ['wujcik', 'all']
  },
  {
    id: '591',
    article: 'The Name Giver',
    author: ['Erick Wujcik'],
    artist: ['Scott Johnson'],
    page: '40-44',
    issue: rifter82,
    issueTitle: 'The Rifter #82',
    image: './images/rifter82.jpg',
    summary: 'Gaming advice by Erick Wujcik from The Rifter #1.',
    games: ['Any'],
    official: 'Yes',
    tags: ['tips', 'gm']
  },
  {
    id: '592',
    article: 'Thinking Big',
    author: ['Erick Wujcik'],
    artist: ['Apollo Okamura', 'Kevin Long'],
    page: '45-47',
    issue: rifter82,
    issueTitle: 'The Rifter #82',
    image: './images/rifter82.jpg',
    summary: 'More great tips and advice by Erick Wujcik from The Rifter #2.',
    games: ['Any'],
    official: 'Yes',
    tags: ['tips', 'gm']
  },
  {
    id: '593',
    article: 'The Impact of Age',
    author: ['Mark Oberle'],
    artist: ['R.K. Post', 'Roger Peterson'],
    page: '48-56',
    issue: rifter82,
    issueTitle: 'The Rifter #82',
    image: './images/rifter82.jpg',
    summary: "More information about The Becoming and tables for selecting skills based on the 'Bane's age and experience.",
    games: ['Nightbane'],
    official: 'Yes',
    tags: ['skill', 'rules', 'tips']
  },
  {
    id: '594',
    article: 'Hitting the Gym',
    author: ['Matt Reed'],
    artist: ['Mark Dudley'],
    page: '57-68',
    issue: rifter82,
    issueTitle: 'The Rifter #82',
    image: './images/rifter82.jpg',
    summary: 'Expands upon the Physical Training Hero with new abilities, signature moves, and more.',
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['skill', 'combat']
  },
  {
    id: '595',
    article: 'Chaos Earth Nebraska, Part Three',
    author: ['Dan Frederick', 'Megan Timperley', 'Kevin Siembieda'],
    artist: ['Benjamin Rodriguez'],
    page: '69-92',
    issue: rifter82,
    issueTitle: 'The Rifter #82',
    image: './images/rifter82.jpg',
    summary: 'A continuation of Chaos Earth Nebraska, presenting the Pyromancer O.C.C., Pyromancy Magic, the Zone Twister, some notable characters, and an adventure hook.',
    games: ['Chaos Earth'],
    official: 'Yes',
    tags: ['adventure', 'location', 'occ', 'magic', 'spell', 'npc']
  },
  {
    id: '596',
    article: 'The Prophet O.C.C.',
    author: ['Ian Herbert'],
    artist: ['Benjamin Rodriguez'],
    page: '15-19',
    issue: rifter83,
    issueTitle: 'The Rifter #83',
    image: './images/rifter83.jpg',
    summary: 'An optional O.C.C. that is not a Priest in the traditional sense, but a character who can be something of a wild card and a maverick.',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['occ']
  },
  {
    id: '597',
    article: "Half-Ogres or 'Hogres'",
    author: ['Ian Herbert'],
    artist: ['Mark Dudley'],
    page: '19-23',
    issue: rifter83,
    issueTitle: 'The Rifter #83',
    image: './images/rifter83.jpg',
    summary: 'A comprehensive look at the Hogre - a half human and half-Ogre subspecies.',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['race']
  },
  {
    id: '598',
    article: 'Operation Minotaur',
    author: ['Hendrik Harterich'],
    artist: ['Benjamin Rodriguez'],
    page: '23-47',
    issue: rifter83,
    issueTitle: 'The Rifter #83',
    image: './images/rifter83.jpg',
    summary: 'An epic, wartime adventure that is like Indiana Jones meets The Dirty Dozen, filled with horror and dangerous secrets.',
    games: ['Beyond the Supernatural'],
    official: 'No',
    tags: ['adventure']
  },
  {
    id: '599',
    article: 'Saving the World... with the Secret Operative',
    author: ['Matt Reed'],
    artist: ['Sires Jan Black'],
    page: '48-67',
    issue: rifter83,
    issueTitle: 'The Rifter #83',
    image: './images/rifter83.jpg',
    summary: 'A new look at Superspies and Secret Operatives for Heroes Unlimited complete with Superskills, Gadgets, and new abilities.',
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['ability', 'occ', 'skill', 'equipment']
  },
  {
    id: '600',
    article: 'On the Trail... with the Hunter/Vigilante',
    author: ['Matt Reed'],
    artist: ['Mike Mumah'],
    page: '67-81',
    issue: rifter83,
    issueTitle: 'The Rifter #83',
    image: './images/rifter83.jpg',
    summary: 'A new look at The Hunter/Vigilante for Heroes Unlimited. Complete with traps, new abilities, and equipment.',
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['ability', 'occ', 'equipment']
  },
  {
    id: '601',
    article: 'Treasures of the Megaverse',
    author: ['Carl Gleba'],
    artist: ['Mike Mumah'],
    page: '82-96',
    issue: rifter83,
    issueTitle: 'The Rifter #83',
    image: './images/rifter83.jpg',
    summary: 'A diverse and spectacular treasure trove of magic items. Rune Weapons, Magic Rings, Elixirs, Cloaks, TW Devices, and much more, including a few warships!',
    games: ['Rifts'],
    official: 'No',
    tags: ['weapon', 'magic', 'equipment', 'tw', 'technowizard', 'rune']
  },
  {
    id: '602',
    article: 'The Kingdom of Raf-Chalon',
    author: ['Glen Evans'],
    artist: ['Mike Mumah'],
    page: '20-44',
    issue: rifter84,
    issueTitle: 'The Rifter #84',
    image: './images/rifter84.jpg',
    summary: 'An Elven Kingdom in the Eastern Territory, but all is not as it seems. Surprises, intrigue, and fun await.',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['location']
  },
  {
    id: '603',
    article: 'Golems in the Myst',
    author: ['Greg Diaczyk'],
    artist: ['Kevin Long', 'Ramon Perez', 'Apollo Okamura'],
    page: '44-61',
    issue: rifter84,
    issueTitle: 'The Rifter #84',
    image: './images/rifter84.jpg',
    summary: 'Adventure and mayhem when questionable magic experiments go awry.',
    games: ['Rifts'],
    official: 'No',
    tags: ['adventure', 'tw', 'technowizard', 'techno-wizard', 'magic', 'robot']
  },
  {
    id: '604',
    article: 'Spellbound O.C.C.',
    author: ['Ian Herbert'],
    artist: ['Sires Jan Black'],
    page: '62-66',
    issue: rifter84,
    issueTitle: 'The Rifter #84',
    image: './images/rifter84.jpg',
    summary: 'A secretive and inventive new character to the world of Nightbane',
    games: ['Nightbane'],
    official: 'No',
    tags: ['occ']
  },
  {
    id: '605',
    article: 'All Quiet on the Western... What?',
    author: ['Kyle Osterberg'],
    artist: [''],
    page: '66-73',
    issue: rifter84,
    issueTitle: 'The Rifter #84',
    image: './images/rifter84.jpg',
    summary: 'A Beyond the Supernatural adventure set in World War I in the trenches of the Western Front.',
    games: ['Beyond the Supernatural'],
    official: 'No',
    tags: ['adventure', 'weapon']
  },
  {
    id: '606',
    article: 'The Dimma',
    author: ['Steven Dawes'],
    artist: ['Grae Steele'],
    page: '73-78',
    issue: rifter84,
    issueTitle: 'The Rifter #84',
    image: './images/rifter84.jpg',
    summary: 'Story and Monster for Beyond the Supernatural',
    games: ['Beyond the Supernatural'],
    official: 'No',
    tags: ['story', 'monster']
  },
  {
    id: '607',
    article: 'The Dark City of Cascade',
    author: ['Erick Wujcik', 'Matt Reed'],
    artist: ['Freddie Williams II', 'Don Hillsman'],
    page: '79-96',
    issue: rifter84,
    issueTitle: 'The Rifter #84',
    image: './images/rifter84.jpg',
    summary: 'The dark underbelly of the City of Cascade - a place populated by a wide range of villains and heroes, and adventure ideas for your Heroes Unlimited RPG campaigns.',
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['adventure', 'location', 'npc']
  },
  {
    id: '608',
    article: 'Soul In Flames',
    author: ['Barry Wright'],
    artist: ['Benjamin Worrell', 'Mike Mumah'],
    page: '22-35',
    issue: rifter85,
    issueTitle: 'The Rifter #85',
    image: './images/rifter85.jpg',
    summary: 'A tale of innocence lost when a family gets trapped by a local warlord wishing to use them as an example to further his own agenda.',
    games: ['Rifts'],
    official: 'No',
    tags: ['adventure', 'npc']
  },
  {
    id: '609',
    article: 'The Colony of Gonarn',
    author: ['Glen Evans'],
    artist: ['Mike Mumah'],
    page: '36-73',
    issue: rifter85,
    issueTitle: 'The Rifter #85',
    image: './images/rifter85.jpg',
    summary: 'A tale of adventure while exploring the flung colonies on the edge of civilization.',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['adventure', 'location', 'npc']
  },
  {
    id: '610',
    article: "Scout's Honor",
    author: ['Francois DesRochers'],
    artist: [''],
    page: '74-75',
    issue: rifter85,
    issueTitle: 'The Rifter #85',
    image: './images/rifter85.jpg',
    summary: 'A dark, post-apocalyptic tale set in the streets of Old Bones.',
    games: ['Rifts'],
    official: 'No',
    tags: ['story']
  },
  {
    id: '611',
    article: 'Vehicle Encounter Tables',
    author: ['Lloyd Blair'],
    artist: ['Nick Bradshaw'],
    page: '76-85',
    issue: rifter85,
    issueTitle: 'The Rifter #85',
    image: './images/rifter85.jpg',
    summary: 'A series of tables for looting vehicles.',
    games: ['Dead Reign'],
    official: 'No',
    tags: ['rules', 'vehicle']
  },
  {
    id: '612',
    article: 'Beyond Midnight',
    author: ['Dan Frederick'],
    artist: ['Ron Root'],
    page: '86-91',
    issue: rifter85,
    issueTitle: 'The Rifter #85',
    image: './images/rifter85.jpg',
    summary: 'A unique story and monster with adventure seeds for all of the major Palladium Megaverse settings. Inspired by Boxed Nightmares and After Midniught.',
    games: ['Beyond the Supernatural', 'All'],
    official: 'No',
    tags: ['story', 'monster']
  },
  {
    id: '613',
    article: 'Rifts Novella: Last Strike',
    author: ['Dan Frederick'],
    artist: ['Mike Leonard'],
    page: '92-109',
    issue: rifter85,
    issueTitle: 'The Rifter #85',
    image: './images/rifter85.jpg',
    summary: 'A tale of action and adventure that picks up after the events of Reapder Cell.',
    games: ['Rifts'],
    official: 'No',
    tags: ['story']
  },
  {
    id: '614',
    article: 'The Redeemer',
    author: ['Kyle Osterberg'],
    artist: ['Ron Root'],
    page: '110-113',
    issue: rifter85,
    issueTitle: 'The Rifter #85',
    image: './images/rifter85.jpg',
    summary: 'A new O.C.C. that happens when the evil vessel of a Nightlord has a change of heart.',
    games: ['Nightbane'],
    official: 'No',
    tags: ['occ']
  },
  {
    id: '615',
    article: 'A Tribute to Heroes Unlimited',
    author: ['Freddie E. Williams II'],
    artist: ['Freddie E. Williams II'],
    page: '114-115',
    issue: rifter85,
    issueTitle: 'The Rifter #85',
    image: './images/rifter85.jpg',
    summary: 'A visual story of how his encounter with Palladium Books RPGs changed his life.',
    games: ['Heroes Unlimited', 'All'],
    official: 'No',
    tags: ['story']
  },
  {
    id: '616',
    article: 'The Brotherhood',
    author: ['Kyle Osterburg'],
    artist: [''],
    page: '116-119',
    issue: rifter85,
    issueTitle: 'The Rifter #85',
    image: './images/rifter85.jpg',
    summary: 'The terrifying story of what awaits those who seek out the powers of darkness.',
    games: ['Rifts'],
    official: 'No',
    tags: ['story']
  },
  {
    id: '617',
    article: 'Magic Items of Lore',
    author: ['Christian Bonawandt'],
    artist: ['Kevin Long', 'Mandy War'],
    page: '120-127',
    issue: rifter85,
    issueTitle: 'The Rifter #85',
    image: './images/rifter85.jpg',
    summary: 'A collection of magic items for use with any and all of your favorite Palladium Books settings.',
    games: ['Any'],
    official: 'No',
    tags: ['magic', 'equipment']
  },
  {
    id: '618',
    article: 'The Naruni Civil War',
    author: ['Scott Gibbons'],
    artist: ['Mike Mumah'],
    page: '128-137',
    issue: rifter85,
    issueTitle: 'The Rifter #85',
    image: './images/rifter85.jpg',
    summary: 'A space adventure filled with intrigue, greed, advanced technology, and betrayal set to the backdrop of intergalactic war between rival arms dealers.',
    games: ['Rifts', 'Phase World'],
    official: 'No',
    tags: ['adventure']
  },
  {
    id: '619',
    article: 'The State of Rapid City',
    author: ['Sean Masters'],
    artist: ['Mandy War'],
    page: '138-147',
    issue: rifter85,
    issueTitle: 'The Rifter #85',
    image: './images/rifter85.jpg',
    summary: 'The new post-apocalyptic settlment of the Black Hills, sure to bring life to the frontiers of your Rifts campaign.',
    games: ['Rifts'],
    official: 'No',
    tags: ['location']
  },
  {
    id: '620',
    article: 'Hardware Expanded',
    author: ['Robert Daley Jr.'],
    artist: [''],
    page: '148-155',
    issue: rifter85,
    issueTitle: 'The Rifter #85',
    image: './images/rifter85.jpg',
    summary: 'Three new variations on the classic heroic O.C.C. as well as sample characters for use in your game.',
    games: ['Heroes Unlimited'],
    official: 'No',
    tags: ['occ', 'npc']
  },
  {
    id: '621',
    article: 'Dark Deadline',
    author: ['Addison Vigil'],
    artist: ['Mike Mumah'],
    page: '156-159',
    issue: rifter85,
    issueTitle: 'The Rifter #85',
    image: './images/rifter85.jpg',
    summary: 'An adventure in Roosevelt Haven where you have to figure out who you can trust, and who will betray their fellow humans for a handful of treasure.',
    games: ['Dead Reign'],
    official: 'No',
    tags: ['adventure', 'location']
  },
  {
    id: '622',
    article: 'Palladium Gaming Using Savage Rifts',
    author: ['Sean Roberson'],
    artist: ['Aaron J. Riley'],
    page: '160-161',
    issue: rifter85,
    issueTitle: 'The Rifter #85',
    image: './images/rifter85.jpg',
    summary: 'Shows how easy it is to run adventure material published in Savage Rifts supplements with the classic Palladiaum Books RPG rules system, and offers some helpful suggestions.',
    games: ['Rifts', 'Savage Rifts'],
    official: 'No',
    tags: ['tips']
  },
  {
    id: '623',
    article: 'The Glitter Boy Brotherhood: The Classic O.C.C. and Lore Expanded',
    author: ['Will Erwin'],
    artist: ['Ron Root'],
    page: '162-169',
    issue: rifter85,
    issueTitle: 'The Rifter #85',
    image: './images/rifter85.jpg',
    summary: 'Explains how the myriad secretive factions of Glitter Boy pilots organize their heroic efforts',
    games: ['Rifts'],
    official: 'No',
    tags: ['occ', 'lore']
  },
  {
    id: '624',
    article: 'In Shining Armor: The Culture of Glitter Boy Pilots',
    author: ['Johnny Roccia'],
    artist: ['Ron Root'],
    page: '170-173',
    issue: rifter85,
    issueTitle: 'The Rifter #85',
    image: './images/rifter85.jpg',
    summary: 'The technology, myths, and lore that have sprung up surrounding the iconic power armor suits.',
    games: ['Rifts'],
    official: 'No',
    tags: ['occ', 'lore']
  },
  {
    id: '625',
    article: 'Upgrading a Legend: Repairing and Modifying the USA-G10',
    author: ['Will Erwin'],
    artist: ['Daniel Reedus', 'Mandy War'],
    page: '174-191',
    issue: rifter85,
    issueTitle: 'The Rifter #85',
    image: './images/rifter85.jpg',
    summary: 'The details on various methods of repairing and upgrading the legendary USA-G10 power armor, and the history of some of the most iconic suits.',
    games: ['Rifts', 'Chaos Earth'],
    official: 'No',
    tags: ['equipment', 'story', 'lore']
  },
  {
    id: '626',
    article: 'Relics of Empire: The Elven City-States of North-Eastern Old Kingdom',
    author: ['Ian Herbert'],
    artist: ['Kevin Long', 'Mandy War'],
    page: '192-224',
    issue: rifter85,
    issueTitle: 'The Rifter #85',
    image: './images/rifter85.jpg',
    summary: 'The fate of the elves through excerpts from ancient texts and notes from a well-traveled historian.',
    games: ['Palladium Fantasy'],
    official: 'No',
    tags: ['story', 'lore']
  }
]

export default theRifterArr
